var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 141,
    viewBox: "0 0 77 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_72_73086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 141
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 75.5722,
    height: 141,
    rx: 10,
    fill: "#F0F3F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_72_73086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0093 109.832C78.0093 109.832 84.7678 121.835 70.8584 155.545L90.6001 210.244C90.6001 210.244 35.6393 225.672 1.73135 212.413C1.73135 212.413 8.31239 161.479 26.1948 105.999H41.743L38.7314 96.0137C38.7314 96.0137 67.736 115.195 78.009 109.832H78.0093Z",
    fill: "#6180EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9072 110.171C77.9278 110.083 77.8605 110.083 77.5866 110.127C77.4381 110.151 77.2386 110.184 77.0263 110.234C76.8073 110.27 76.5633 110.32 76.2901 110.358C74.8452 110.557 73.3806 110.564 71.9338 110.381C68.4395 109.998 64.1606 108.605 60.693 107.13C54.9758 104.492 49.4317 101.494 44.0944 98.1539C43.1983 97.5744 42.2734 97.0409 41.3232 96.5553C40.5795 96.2029 39.8617 95.7982 39.1753 95.3443L39.1703 95.3411C39.0316 95.2512 38.8686 95.206 38.7034 95.2117C38.5381 95.2173 38.3786 95.2735 38.2464 95.3727C38.1141 95.4719 38.0154 95.6093 37.9637 95.7663C37.912 95.9233 37.9097 96.0924 37.9571 96.2508L38.0889 96.6928C39.1073 100.313 39.986 103.338 40.8476 106.272L41.7417 105.069C37.0278 105.033 32.4917 105.021 26.1934 104.927C25.9692 104.923 25.7498 104.991 25.567 105.121C25.3841 105.251 25.2473 105.436 25.1765 105.648L25.1687 105.673L24.6269 107.309L22.3829 114.757C22.032 115.877 21.725 116.96 21.4186 118.015L20.5064 121.121C19.9084 123.168 19.2697 125.178 18.6453 127.341L16.5758 134.394C16.121 135.995 15.7755 137.409 15.4542 138.723L14.5591 142.467L13.6686 146.212C13.3669 147.53 13.0331 148.948 12.6356 150.563L10.5928 158.307C9.96843 160.668 9.34224 162.831 8.77802 164.918C7.80597 170.394 6.41502 177.543 5.82587 182.167C5.44974 184.31 5.13949 185.748 4.84634 187.09C4.56139 188.434 4.28676 189.68 3.96512 191.436C3.64454 193.244 3.52522 194.379 3.39521 195.512C3.26521 196.645 3.13376 197.776 2.85059 199.59C2.58842 201.174 2.35583 202.344 2.12859 203.442C1.91024 204.542 1.69651 205.571 1.4657 206.872C1.20033 208.614 0.933899 210.398 0.679581 212.286C0.648315 212.518 0.695862 212.754 0.814606 212.956C0.93335 213.159 1.11645 213.315 1.33463 213.401L1.34138 213.404C5.80016 215.105 10.4116 216.375 15.1126 217.198C19.7235 218.012 24.3764 218.567 29.0494 218.859C32.6114 218.985 36.4255 219.05 40.396 218.925C44.3665 218.812 48.4966 218.575 52.6975 218.202C61.2121 217.437 69.6759 216.186 78.0475 214.454C80.8237 213.944 84.4544 213.09 86.3226 212.766C87.8318 212.356 89.3524 211.936 90.9354 211.467L90.9792 211.454C91.1349 211.408 91.2801 211.332 91.4063 211.229C91.5326 211.127 91.6374 211.001 91.7149 210.858C91.7924 210.716 91.841 210.559 91.858 210.397C91.8749 210.236 91.8599 210.072 91.8137 209.917C91.8045 209.886 91.7931 209.853 91.782 209.823C86.9253 197.23 81.9411 183.031 78.32 172.038C77.0587 168.998 76.3499 166.777 75.1004 163.248C73.6774 159.525 72.7612 157.62 71.713 155.242L71.698 155.901C72.0125 154.897 72.3641 153.814 72.8189 152.515L73.4957 150.719C73.7094 150.149 73.91 149.61 74.0603 149.101C74.3777 148.088 74.6231 147.241 74.7638 146.637C75.0131 146.032 75.2795 145.355 75.5577 144.634L75.7675 144.084L75.9577 143.512L76.3446 142.336C76.8529 140.743 77.4349 139.101 77.8345 137.576C78.0568 136.517 78.3029 135.422 78.5547 134.299L79.1995 130.814C79.3241 130.225 79.4018 129.622 79.4866 129.016L79.7469 127.192C79.789 126.887 79.8392 126.582 79.8748 126.275L79.9589 125.349L80.1273 123.497C80.1986 122.881 80.1879 122.258 80.2185 121.642C80.2324 121.024 80.2748 120.41 80.2634 119.797C80.2458 119.184 80.2284 118.576 80.2111 117.972L80.1972 117.52L80.1558 117.071L80.0714 116.18C80.0415 115.885 80.0176 115.591 79.9824 115.3L79.8399 114.434L79.6974 113.581L79.5008 112.749C79.3742 112.207 79.2197 111.672 79.0377 111.146C78.953 110.886 78.8397 110.634 78.7425 110.383C78.6962 110.257 78.632 110.133 78.5733 110.01L78.4842 109.826C78.4757 109.81 78.476 109.806 78.4447 109.751C78.4185 109.705 78.3884 109.662 78.3546 109.622C78.2891 109.546 78.2114 109.481 78.1245 109.43C78.2223 109.546 78.3039 109.676 78.367 109.814C78.3927 109.934 78.4027 110.028 78.4418 110.172L78.7186 111.268C78.8151 111.72 78.9576 112.24 79.0502 112.824C79.1015 113.115 79.1674 113.416 79.2169 113.731L79.3519 114.691C79.666 117.237 79.7018 119.81 79.4588 122.364C79.4563 122.836 79.4164 123.29 79.3754 123.729L79.2618 125.002L79.1507 126.193C79.1001 126.575 79.0392 126.944 78.9854 127.303C78.7574 128.736 78.5882 130.001 78.3086 131.157C78.0493 132.317 77.8363 133.396 77.5756 134.465C77.2949 135.53 77.021 136.596 76.7407 137.751C76.6374 138.14 76.5451 138.493 76.4486 138.811C76.3417 139.126 76.2438 139.41 76.1501 139.668C75.9624 140.183 75.7957 140.596 75.6404 140.952C75.3298 141.665 75.0651 142.156 74.7684 142.805C74.5682 143.524 74.3103 144.277 74.0521 145.032L73.2952 147.261C73.0498 147.976 72.8154 148.647 72.6027 149.229C72.368 149.804 72.1571 150.289 71.9858 150.642C71.2 152.774 70.6009 154.261 70.15 155.252C70.0798 155.406 70.0684 155.58 70.1179 155.741L70.1375 155.805C70.3042 156.349 70.4136 156.761 70.4873 157.096C71.3229 159.479 71.3895 159.105 72.3441 161.917C73.6471 165.968 76.3748 173.074 76.6594 174.941C77.1606 176.022 78.0002 178.32 78.8746 180.739C79.9147 183.668 80.5815 185.797 81.1767 187.771L84.0366 195.583C85.5187 199.528 84.8516 198.864 85.8471 201.767C87.0293 204.887 88.1535 207.899 89.2064 210.746L90.1995 208.817C87.0005 209.711 83.8029 210.465 80.6891 211.148C77.5652 211.828 74.4913 212.435 71.428 212.982C68.3647 213.529 65.3132 214.017 62.2357 214.466C59.156 214.896 56.0539 215.321 52.8795 215.659C48.6544 215.98 45.1426 216.212 41.7203 216.33C38.3008 216.43 34.9647 216.492 31.1193 216.269C27.8458 216.139 23.9181 215.948 20.2336 215.479C19.7727 215.424 19.3125 215.383 18.8619 215.316L17.5269 215.111L16.231 214.91C15.8061 214.846 15.3904 214.778 14.9893 214.689C13.3804 214.359 11.9218 214.073 10.7581 213.713L8.7513 213.289C8.06812 213.113 7.36785 212.916 6.64655 212.717L5.55197 212.411C5.18295 212.307 4.82176 212.167 4.45026 212.044L2.18593 211.255L2.96386 212.574C3.72683 206.674 4.88517 200.05 6.06275 193.865C6.27112 192.488 6.51192 191.082 6.76659 189.638C7.02127 188.193 7.29768 186.71 7.60365 185.189L8.54151 180.479L9.57447 175.472C10.0265 173.177 10.5419 170.726 11.0705 168.205L11.8677 164.377L12.7225 160.518C13.836 155.368 15.0812 150.319 16.1751 146.056C16.895 143.156 17.8848 139.455 18.1117 138.013C21.0279 127.858 24.0534 117.038 27.3917 106.388L26.1974 107.258L38.0155 107.227C38.522 107.109 40.1823 107.076 41.746 107.037H41.798C42.0668 107.03 42.322 106.917 42.5073 106.722C42.6926 106.527 42.7928 106.267 42.786 105.998C42.7831 105.899 42.7661 105.8 42.7355 105.706C42.4505 104.836 42.1702 104 41.9518 103.439C40.6695 99.4979 40.6471 98.6825 39.7577 95.7097L38.1431 96.9112L38.4597 97.1174C38.9651 97.1911 40.4544 98.0022 42.3291 99.0259C44.2037 100.05 46.4609 101.29 48.4617 102.285C51.6877 104.071 54.2256 105.297 56.5775 106.377C58.9341 107.45 61.1012 108.39 63.7014 109.416C66.2055 110.247 66.8456 110.213 67.6976 110.304C69.2073 110.758 70.7647 111.035 72.3384 111.129C73.3452 111.195 74.3562 111.159 75.3558 111.022C75.8552 110.947 76.3484 110.836 76.8315 110.688C77.0668 110.619 77.2985 110.537 77.5257 110.444C77.5738 110.424 77.6568 110.396 77.6757 110.383C77.7042 110.367 77.7312 110.349 77.7565 110.329C77.8113 110.281 77.863 110.229 77.9111 110.174L77.9072 110.171Z",
    fill: "#6180EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1951 106.001H41.7433L38.7317 96.0157C38.7317 96.0157 67.7363 115.197 78.0093 109.834C78.0093 109.834 78.0588 109.923 78.1396 110.101L18.4058 132.292C20.7211 123.776 23.3099 114.948 26.194 106.001L26.1951 106.001Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8482 138.948C64.5701 138.371 64.1358 139.771 63.8577 139.194C63.5317 140.003 65.0007 139.586 64.8482 138.948Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2877 137.118C66.4003 136.965 66.3119 136.798 66.4868 136.648C66.3337 136.536 66.1662 136.624 66.0166 136.449C65.9044 136.602 65.9924 136.77 65.8179 136.919C65.9707 137.032 66.1385 136.944 66.2877 137.118Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9852 128.909C71.0635 128.593 71.2587 128.319 71.5312 128.142C71.325 127.788 70.2942 128.663 70.9852 128.909Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2382 134.366C64.9627 134.188 64.0825 133.158 63.7937 133.845L64.2382 134.366Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1219 137.278C60.1319 136.806 59.5823 135.938 59.2585 135.915C59.1866 136.549 59.5534 136.966 60.1219 137.278Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4697 141.202C54.6863 140.95 54.0879 140.632 54.3725 140.385C53.7 139.994 54.0192 140.975 54.4697 141.202Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7192 140.088C55.1591 139.853 54.8385 139.558 54.6219 139.271C54.5097 139.424 54.5974 139.591 54.4228 139.741L54.7192 140.088Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7212 141.147C52.2288 140.81 50.7289 140.313 51.65 140.007C50.804 139.696 51.1072 140.81 51.7212 141.147Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.393 137.714C55.7653 137.274 54.8288 137.032 54.6012 137.489C54.857 137.666 55.1398 137.501 55.393 137.714Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9053 128.349C63.8213 128.757 63.6414 128.898 63.2364 128.62C62.9308 129.386 64.8949 129.218 63.9053 128.349Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5942 138.301C52.8129 138.697 53.6015 137.88 52.9668 137.683L52.6195 137.98C52.7773 138.1 52.6907 138.201 52.5942 138.3V138.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5189 126.371C65.343 126.628 65.5064 126.91 65.2941 127.163C65.734 127.535 65.9748 126.599 65.5189 126.371Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9566 127.705C64.1731 127.452 63.5747 127.135 63.8593 126.888C63.2958 126.551 63.5234 127.593 62.8174 127.778C63.4892 128.326 63.2844 127.156 63.9566 127.705Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5014 135.38C52.708 135.734 53.7388 134.86 53.0481 134.614C52.7179 134.858 52.8629 135.137 52.5014 135.38Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9862 125.279C64.725 124.917 63.7992 124.46 63.567 124.436C63.3771 124.691 63.7939 124.994 63.9862 125.279Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6617 123.962C60.8781 124.15 61.9794 125.542 61.1153 124.728C61.0663 124.971 60.9346 125.189 60.7427 125.346C61.3693 125.735 61.9303 125.532 61.6332 126.388C62.4058 126.281 62.0304 124.698 61.6631 123.962H61.6617Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3844 124.339C64.924 124.058 64.9494 123.736 64.4607 123.374C64.4571 123.697 63.8665 123.974 64.3844 124.339Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7443 135.079C51.3266 135.463 50.9883 134.481 51.6123 134.339C51.3095 134.069 50.9758 134.196 50.6214 134.584C50.8219 134.762 50.8468 134.925 50.7443 135.079Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5768 124.681C62.6911 123.909 62.0621 123.435 61.3917 123.292C61.1413 123.986 62.3022 123.866 62.5768 124.681Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9103 121.79C65.2629 122.107 65.6968 121.401 66.0501 121.719C66.2022 121.515 65.872 121.273 66.1011 121.076C65.3481 121.585 65.6181 120.741 64.911 121.791L64.9103 121.79Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1743 137.225C47.3759 137.403 47.6157 137.101 47.8433 136.954C47.6531 136.633 47.424 136.796 47.2253 136.581C47.0735 136.786 47.4034 137.027 47.1743 137.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0938 131.62C53.7262 131.495 53.3646 131.292 52.9539 131.691C53.3222 131.817 53.6859 132.021 54.0938 131.62Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9404 115.143C70.8152 115.059 70.6637 115.022 70.5136 115.04C70.3635 115.058 70.2249 115.129 70.123 115.241C70.3581 115.681 70.6533 115.36 70.9404 115.143Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3267 139.515C41.6188 139.916 42.0099 139.068 42.3433 138.948C42.0512 138.546 41.6604 139.395 41.3267 139.515Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4972 128.576C54.92 128.018 54.0145 128.346 53.9044 127.881C53.7523 128.085 54.0825 128.327 53.8535 128.525C54.0576 128.677 54.2991 128.348 54.4972 128.576Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0468 138.601C42.0982 138.429 42.1026 138.246 42.0594 138.072C42.0163 137.898 41.9272 137.738 41.8014 137.61C41.5317 137.912 41.6607 138.246 42.0468 138.601Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2257 113.953C70.3102 113.828 70.3469 113.677 70.3291 113.527C70.3112 113.377 70.24 113.238 70.1284 113.136C69.8079 113.327 69.9696 113.555 69.7559 113.754C69.9083 113.867 70.0764 113.778 70.2257 113.953V113.953Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1477 137.313C43.005 137.719 42.1121 136.692 42.3721 136.522C41.5151 136.117 42.4081 137.142 42.1477 137.313Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3853 125.164C56.7059 124.795 55.7207 124.309 55.4453 124.765C55.7125 125.481 56.0779 124.954 56.3853 125.164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2849 113.555C69.5546 113.252 69.4274 112.918 69.0395 112.564C68.7699 112.867 68.8988 113.201 69.2849 113.555Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5742 114.715C67.5158 114.171 67.4802 113.628 68.3457 113.157C68.3279 112.287 67.0527 114.556 66.808 114.169C66.4215 114.794 67.4032 114.462 67.5742 114.715Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8076 118.389C61.2866 118.859 60.8703 119.257 61.349 119.727C61.7109 119.418 60.8699 117.701 61.7729 118.465C62.1672 117.546 61.1955 117.468 60.8076 118.389Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6961 137.605C40.3811 137.804 40.5114 136.603 39.9714 136.17C39.9579 136.66 39.8649 137.145 39.6961 137.605Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5166 134.345C43.3913 134.261 43.2399 134.224 43.0898 134.242C42.9397 134.26 42.801 134.331 42.6991 134.442C42.9342 134.883 43.2295 134.562 43.5166 134.345Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2782 132.542C45.4538 132.286 45.2903 132.003 45.5029 131.75C45.063 131.378 44.8208 132.314 45.2782 132.542Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2807 111.205C70.4328 111.001 70.1026 110.759 70.332 110.562C69.5805 110.027 69.6713 111.548 69.0191 110.781C68.9677 110.953 68.9633 111.136 69.0065 111.31C69.0496 111.485 69.1387 111.644 69.2645 111.772C69.6919 111.536 69.6228 111.261 69.8109 111.006C69.9837 110.867 70.1269 111.104 70.2807 111.205Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4925 117.551C61.4115 117.167 62.8793 116.683 63.0898 116.141C62.4487 115.946 61.8147 117.107 61.5272 117.475C61.8506 117.478 62.1278 118.069 62.4925 117.551Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7915 114.735C66.2032 114.532 65.6811 113.341 65.1988 114.041C65.7822 114.139 65.3715 114.275 65.7915 114.735Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5444 130.863C46.865 130.672 46.7029 130.443 46.917 130.245C46.6986 129.847 45.9097 130.664 46.5444 130.863Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2646 129.946C47.7341 130.276 48.2203 129.29 47.6628 129.006C46.9187 129.271 48.0094 129.681 47.2646 129.946Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9093 116.045C64.3051 115.826 63.4879 115.038 63.291 115.672L63.5873 116.019C63.7074 115.861 63.8089 115.948 63.9079 116.045L63.9093 116.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8626 124.316C53.926 124.078 53.994 123.841 54.2099 124.02C54.3848 123.926 54.3167 123.812 54.2352 123.699L53.9388 123.352L53.418 123.797L53.8626 124.316Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0539 124.659C52.3538 123.954 51.2621 123.99 50.9404 124.41C51.2485 125.287 51.7451 123.781 52.0539 124.659Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7197 117.818C59.9384 118.213 60.727 117.396 60.0923 117.199L59.745 117.496C59.9028 117.616 59.8162 117.717 59.7193 117.816L59.7197 117.818Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3418 120.306C53.3765 120.346 54.4487 121.928 53.1984 122.483C53.5842 122.382 53.9279 122.812 54.3382 122.411C54.1594 121.695 54.3318 121.007 54.3418 120.306Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7026 118.384C58.4476 118.195 58.1448 118.612 57.8599 118.804C58.2517 119.165 58.6642 118.807 58.7026 118.384Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5229 115.125C62.1133 114.99 61.7187 115.121 61.6802 115.544C62.0724 115.905 62.4841 115.546 62.5229 115.125Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1987 136.436C37.4004 136.614 37.6404 136.313 37.8677 136.165L37.275 135.471C37.0969 135.672 37.3986 135.913 37.5457 136.14L37.1987 136.436Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4132 121.445C54.6657 121.662 54.9831 121.063 55.2303 121.348C55.3821 121.144 55.0522 120.902 55.2812 120.705C54.6999 120.321 54.8107 121.285 54.4132 121.446V121.445Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1588 120.209C55.6575 119.802 54.7189 119.043 54.2445 119.489C54.8322 119.518 54.47 120.172 55.1588 120.209Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1683 134.408C38.32 134.204 37.9902 133.962 38.2192 133.765C38.1248 133.59 38.0119 133.658 37.8987 133.74L37.5514 134.036C37.7416 134.356 37.9703 134.195 38.1694 134.408L38.1683 134.408Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0366 133.667C39.3572 133.477 39.1955 133.248 39.4092 133.049C39.1891 132.653 38.4022 133.47 39.0366 133.667Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0304 130.259C43.4261 130.041 42.609 129.252 42.4124 129.887L42.7088 130.234C42.8292 130.076 42.9303 130.163 43.0293 130.259H43.0304Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3866 112.034C64.8557 111.278 63.6169 111.391 63.8449 110.696C62.7984 110.77 63.8313 111.365 64.3866 112.034Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.042 127.342C44.7658 127.303 44.4842 127.337 44.2249 127.439C44.0243 127.261 43.9994 127.098 44.102 126.944C43.6258 126.661 42.8831 127.692 43.5321 128.032C43.6268 127.057 44.4514 128.415 45.042 127.342Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5176 135.17C36.1309 134.894 35.7587 134.541 36.2378 134.255C36.0262 133.946 34.8023 134.874 35.5176 135.17Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6299 125.687C46.3225 125.478 45.9574 126.005 45.6899 125.289C45.6053 125.414 45.5686 125.565 45.5864 125.715C45.6043 125.866 45.6755 126.004 45.7871 126.106C46.111 126.078 46.4123 125.928 46.6299 125.687Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4252 126.969C44.8648 127.341 45.107 126.405 44.6496 126.178C44.4726 126.434 44.6361 126.716 44.4252 126.969Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6557 125.365C46.8933 124.827 47.1522 125.006 47.2256 124.277C46.6589 123.707 46.7244 125.246 46.3832 124.696C46.2083 124.79 46.2763 124.904 46.3575 125.016L46.6557 125.365Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.99 118.253C55.2678 117.848 55.1267 117.668 54.7189 117.584L54.3716 117.88C54.5618 118.202 54.7905 118.04 54.99 118.253Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5463 131.685L38.8936 131.389C38.6585 130.949 38.3635 131.27 38.0764 131.486C38.2296 131.599 38.397 131.511 38.5463 131.685V131.685Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0571 135.216C34.061 134.893 34.6516 134.615 34.1333 134.251C34.1312 134.574 33.5388 134.852 34.0571 135.216Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3813 132.079C36.2177 132.024 36.9044 133.304 37.3813 132.079V132.079Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3044 137.265C31.5741 136.963 31.4469 136.629 31.0594 136.275C31.0302 136.862 30.3762 136.5 30.3392 137.189C30.6384 137.5 31.0159 136.82 31.3044 137.265Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0239 136.35C32.3445 136.16 32.1828 135.931 32.3965 135.732C32.1927 135.58 31.9505 135.91 31.7532 135.681C31.5737 135.885 31.8768 136.123 32.0239 136.35Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0263 115.014C57.9795 114.481 56.6423 113.943 57.0263 115.014V115.014Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1236 138.226C29.903 138.483 29.103 137.268 29.8691 136.99C29.6661 136.578 28.4743 137.1 29.1746 137.583C28.9965 137.783 28.833 137.808 28.6791 137.705C28.4807 138.069 28.9113 138.197 29.1493 137.904C29.3071 138.025 29.2205 138.125 29.1236 138.225V138.226Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6002 137.379C26.5201 137.642 26.7616 137.931 26.3758 138.17C26.8695 138.195 27.2307 138.781 26.6212 139.161C26.9062 139.636 27.3297 138.39 27.5869 139.238C27.9734 138.929 26.1796 137.635 27.3668 137.925C27.7536 137.301 26.7716 137.632 26.6002 137.379V137.379Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7373 136.249C30.3694 136.124 30.0078 135.92 29.5975 136.32C29.9658 136.446 30.3277 136.649 30.7373 136.249Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0058 113.231C58.1695 113.286 57.4827 112.006 57.0058 113.231V113.231Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4407 135.901C30.8396 135.663 30.9536 135.403 30.6654 135.11L30.1447 135.554L30.4407 135.901Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5293 127.799C38.9678 128.172 39.4376 127.253 38.7537 127.008C38.674 127.27 38.9151 127.559 38.5293 127.799Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2207 134.589C30.0486 134.537 29.866 134.533 29.6917 134.576C29.5174 134.619 29.3579 134.708 29.2298 134.834C29.5322 135.104 29.8663 134.975 30.2207 134.589Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8231 126.854C36.6582 127.003 36.8694 127.181 36.9456 127.349C36.4854 127.769 36.3494 127.358 36.2511 127.942C36.8488 128.225 37.7182 127.507 36.8231 126.854Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9329 134.487C29.1231 134.232 28.7063 133.929 28.514 133.644C28.1532 134.036 28.5111 134.449 28.9329 134.487Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8854 131.967C32.4147 131.344 31.2934 130.866 30.7719 131.718C31.0953 132.406 31.531 131.694 31.8854 131.967Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0264 132.954C29.6591 132.822 29.2527 133.18 28.8616 133.346C29.563 133.773 29.4194 133.585 30.0264 132.954Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7464 113.866C53.4267 113.099 51.6985 113.146 52.3784 112.38C52.1416 112.302 51.671 112.529 51.9086 112.18C51.5229 112.281 51.1788 111.851 50.7688 112.252C50.9693 112.43 50.9943 112.594 50.8917 112.747C51.5653 112.393 52.2598 112.904 51.6326 113.615C52.3767 113.496 52.2192 113.487 52.7464 113.866Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4087 128.361C35.1875 126.838 34.3187 127.973 35.4087 128.361V128.361Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.959 120.213C44.7421 119.884 44.279 120.015 44.5145 119.692C44.4205 119.517 44.3072 119.585 44.1939 119.666L43.8466 119.963C44.1854 120.458 44.5476 120.655 44.9604 120.212L44.959 120.213Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6434 141.768C18.819 141.513 18.6559 141.229 18.8682 140.976C18.4283 140.604 18.186 141.541 18.6434 141.768Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2764 131.841C29.3688 131.583 30.2945 130.862 29.1882 131.269C28.9061 131.745 29.9366 132.488 30.2764 131.841Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1729 123.395C40.351 123.193 40.0493 122.954 39.9022 122.726C39.5033 122.964 39.3893 123.225 39.6774 123.517C39.8523 123.423 39.7843 123.31 39.7031 123.197C39.8758 123.057 40.0194 123.293 40.1729 123.395Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6421 127.815C34.3187 127.811 34.0415 127.221 33.6768 127.739C34.0002 127.742 34.2777 128.334 34.6421 127.815Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2942 114.157C50.8758 113.879 50.3494 113.514 50.6924 113.217C50.2229 112.888 49.7364 113.874 50.2942 114.157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0475 130.283C31.3175 129.98 31.19 129.646 30.8021 129.291C30.7506 129.464 30.7463 129.646 30.7894 129.821C30.8326 129.995 30.9217 130.154 31.0475 130.283Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9375 118.429C44.9731 118.189 45.1822 117.752 45.4583 117.985C46.0097 117.087 44.0331 117.966 44.9375 118.429Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.889 115.91C47.952 115.671 48.0204 115.435 48.2363 115.614C48.4008 115.465 48.1892 115.286 48.1134 115.118C47.993 115.276 47.8918 115.19 47.7928 115.093C47.6806 115.246 47.7682 115.413 47.5937 115.563L47.889 115.91Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.522 124.157C38.1197 124.449 38.4566 123.386 37.7713 123.043C37.4974 123.399 38.2091 123.833 37.522 124.157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.493 131.86C28.8232 131.616 28.6779 131.335 29.0391 131.094C28.8332 130.742 27.8023 131.616 28.493 131.86Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0779 123.636C36.4428 124.206 36.7491 124.253 36.036 124.526C36.2494 125.279 37.7892 123.965 37.0779 123.636Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7242 134.478C24.7736 134.235 24.9054 134.017 25.0972 133.86C24.456 134.02 24.2761 133.575 24.0346 132.966L23.3401 133.559C24.5472 133.473 23.7376 134.147 22.9422 134.499C23.7846 135.572 23.8979 133.211 24.7232 134.478H24.7242Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0239 131.663C27.3664 131.38 26.649 131.868 26.3388 132.501C26.8734 132.565 27.4412 132.21 28.0239 131.663Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.026 128.5C31.2322 128.854 32.2634 127.98 31.5724 127.734C31.1467 127.97 31.2141 128.245 31.026 128.5Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5627 131.71C26.5862 131.225 27.3211 130.798 27.8037 130.35C27.6032 130.172 27.5782 130.009 27.6808 129.855C27.4279 129.639 27.1109 130.236 26.8637 129.952C27.169 130.57 25.9775 131.069 26.5627 131.71Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4517 124.076C34.1022 123.72 33.6962 124.076 33.2873 124.47C33.6551 124.602 34.0432 124.47 34.4517 124.076Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3138 124.148L33.6611 123.851C33.4183 123.802 33.1998 123.671 33.0428 123.479C32.765 123.884 32.906 124.063 33.3138 124.148Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3422 134.617C20.2353 134.231 21.2259 133.931 20.5915 133.504C20.7001 133.891 19.7088 134.189 20.3422 134.617Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4474 125.947C29.5319 125.822 29.5686 125.671 29.5508 125.521C29.5329 125.371 29.4617 125.232 29.3501 125.13C29.0295 125.32 29.1913 125.549 28.9772 125.748C29.1304 125.861 29.2978 125.773 29.447 125.947H29.4474Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1709 127.148C23.9073 127.068 23.6184 127.309 23.3791 126.923C23.201 127.125 23.503 127.365 23.6501 127.593L24.1709 127.148Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1057 129.417C19.3901 129.685 19.9162 130.05 19.7075 130.357C20.1769 130.685 20.6631 129.701 20.1057 129.417Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9096 122.504C29.238 122.287 29.107 121.824 29.4304 122.06C29.9821 121.162 28.0042 122.041 28.9096 122.504Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3005 139.713C63.6654 140.283 63.9718 140.33 63.2587 140.604C63.6148 140.878 64.049 140.167 64.3725 140.853C64.272 140.467 64.7027 140.124 64.3005 139.713Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8135 134.569C66.6119 134.391 66.3721 134.693 66.1445 134.84C66.4195 136.063 66.2642 135.293 66.8135 134.569Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0997 138.892C62.1525 138.284 62.5197 138.5 62.9678 138.151C62.6921 137.348 61.4066 139.045 61.6805 138.049C61.0101 138 61.632 138.495 62.0994 138.892H62.0997Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9722 136.046C62.3571 136.36 64.0255 137.886 62.9722 136.046V136.046Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9023 140.42C58.4507 139.091 57.7269 140.055 58.9023 140.42V140.42Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6091 136.91C62.9381 136.458 61.9742 135.735 61.6091 136.91V136.91Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5282 135.525C62.6315 135.571 62.7438 135.591 62.8564 135.586C62.969 135.58 63.0788 135.549 63.1772 135.494C63.2756 135.439 63.36 135.362 63.4237 135.269C63.4874 135.176 63.5287 135.07 63.5444 134.958C63.3289 135.142 62.671 134.957 62.5282 135.525Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2996 133.968C63.1407 134.665 63.6045 133.74 63.8203 133.523C63.2426 133.092 63.4139 133.293 63.0794 132.655C63.0438 133.03 62.6331 133.375 62.1857 133.718C62.7592 134.279 63.3184 132.685 63.2996 133.967V133.968Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2785 132.185C63.5342 132.36 63.8174 132.197 64.0703 132.409C64.2869 132.157 63.6888 131.839 63.9731 131.592C63.5496 131.18 63.8776 132.085 63.2785 132.185Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6411 135.542C58.047 134.408 57.5537 136.523 58.6411 135.542V135.542Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2063 131.046C64.1452 131.366 63.2957 130.207 64.0996 129.983C63.9507 129.818 63.7723 130.03 63.6045 130.106C63.5943 129.858 63.4986 129.622 63.3338 129.437C63.2216 129.589 63.3096 129.757 63.1347 129.906C62.9616 130.045 62.8187 129.809 62.6645 129.707C62.6131 129.879 62.6087 130.062 62.6519 130.236C62.695 130.411 62.7842 130.57 62.9099 130.698C63.2123 129.699 63.8998 130.505 63.2063 131.046Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2275 124.153C68.9392 124.728 70.2874 125.316 70.2275 124.153V124.153Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7646 141.316L50.1119 141.019C49.9541 140.899 50.0407 140.798 50.1372 140.699C49.0248 140.827 49.5912 140.841 49.371 140.152L48.8503 140.597L49.2948 141.118L48.9475 141.414C49.1769 141.596 49.4423 141.295 49.2948 141.118C49.4676 140.978 49.6108 141.214 49.7646 141.316Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4104 124.251L69.9312 123.806C69.6426 123.361 69.2651 124.041 68.9659 123.73C68.7728 124.024 69.2237 123.894 69.4104 124.251Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6118 120.619C72.4412 120.359 71.4328 121.025 71.82 120.394C71.6711 120.229 71.4926 120.441 71.3245 120.516C71.4823 120.637 71.3958 120.738 71.2992 120.837C71.7324 120.817 72.1516 120.976 72.6118 120.617V120.619Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7407 128.743C62.1776 127.317 61.571 128.896 62.7407 128.743V128.743Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9683 124.788C67.8597 124.736 68.3146 122.973 65.9683 124.788V124.788Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1427 138.592C50.4518 138.16 49.701 138.501 49.8719 137.923C50.2695 137.674 50.6132 138.101 51.0118 137.852C51.1482 137.308 49.8096 138.175 49.4285 137.403C49.2465 137.633 49.5478 137.898 49.7248 137.75C49.7038 138.169 49.494 138.536 50.1437 138.593L50.1427 138.592Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.425 136.346C52.8706 136.718 52.7787 135.755 52.3274 135.528C51.7144 135.804 52.0863 136.157 51.6076 136.443C52.1896 136.819 52.035 136.416 52.4503 136.024C52.6081 136.144 52.5216 136.245 52.425 136.344V136.346Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3601 138.614C48.0674 138.902 47.8127 138.714 47.5174 139.033C48.2091 139.097 48.7149 139.127 48.7074 138.318C48.4777 138.136 48.2127 138.437 48.3601 138.614Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1297 141.277C43.0286 141.389 42.8899 141.461 42.7395 141.479C42.5891 141.497 42.4374 141.46 42.3126 141.374C41.8991 140.885 43.1394 141.383 42.3636 140.73C42.0337 140.974 42.1787 141.256 41.8175 141.497C42.7582 141.544 42.6093 143.372 43.6719 142.615C42.6122 142.376 42.8854 140.885 43.6006 141.475C43.7331 141.107 43.3748 140.701 43.207 140.311C43.1248 140.456 43.0753 140.618 43.062 140.785C43.0486 140.952 43.0718 141.12 43.1297 141.277Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.819 133.056C53.9882 132.854 53.767 132.799 53.6708 132.882C53.4703 132.704 53.4457 132.54 53.5479 132.387C53.347 132.218 53.2915 132.439 53.3741 132.535C53.2537 132.693 53.1529 132.606 53.0535 132.51C52.8847 132.711 53.1059 132.766 53.2017 132.683C53.3414 132.856 53.1045 132.999 53.003 133.153C53.2555 133.37 53.5729 132.771 53.8201 133.056L53.819 133.056Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6283 119.817C69.5743 120.053 69.3261 118.289 68.5816 118.357C68.4252 118.603 69.4347 119.224 68.6283 119.817Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0677 136.163C48.2686 136.331 48.3242 136.11 48.2412 136.014C49.0961 136.62 50.1743 134.57 49.0376 134.134C49.002 134.374 48.7926 134.811 48.5169 134.579C48.1443 135.025 49.1071 134.933 49.334 134.482C49.4519 134.707 49.0893 134.894 49.2831 135.125C48.7823 135.802 48.1076 135.451 48.0677 136.163Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.595 120.952C67.3894 121.159 66.2388 119.857 67.1924 119.542C66.2795 119.325 66.6702 120.569 66.595 120.952Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3363 122.878C65.0719 122.557 64.1454 122.107 63.9445 121.714C63.7105 121.939 63.4768 122.162 63.2752 121.985C63.1463 122.594 64.363 121.862 64.3363 122.878Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8459 133.792C50.8937 132.844 50.1599 134.301 49.855 134.037C49.6858 134.975 50.7985 133.549 50.8459 133.792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4342 132.136C52.1867 132.147 51.9504 132.242 51.7653 132.407C52.4224 132.9 52.5439 132.089 52.6333 131.666C52.3644 131.476 52.3149 131.912 52.4342 132.136Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4814 120.702C65.7012 120.408 65.0686 120.526 65.3589 120.206C64.9642 119.796 64.7274 120.657 64.6643 120.799C64.9169 121.015 65.2342 120.417 65.4814 120.702Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6067 118.035C68.8479 117.457 67.6553 117.974 67.3451 117.611C67.1146 118.067 68.2762 117.929 68.6067 118.035Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6485 117.146C69.9784 116.326 68.5497 116.303 69.6026 115.685C69.9944 115.006 68.9686 115.887 68.7595 116.104C68.824 115.075 68.1807 116.608 68.315 115.584C67.6913 115.197 67.796 116.161 67.7689 116.35C68.0029 116.553 68.7662 116.058 68.0653 116.697C68.8845 116.555 69.255 115.96 69.6489 117.147L69.6485 117.146Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.903 140.777C40.7249 140.977 40.5615 141.002 40.4072 140.899C40.035 141.811 41.531 140.894 40.9283 140.455C40.6078 140.266 40.7378 140.597 40.903 140.775V140.777Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.921 123.094C60.7458 123.482 62.0135 122.769 62.4074 122.725C61.71 122.543 61.995 122.134 62.6318 121.933L61.7413 120.892C61.492 122.527 61.5768 121.83 60.9196 123.093L60.921 123.094Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5866 130.206C52.3458 130.521 52.1435 130.35 51.9433 130.155C51.8942 130.398 51.7624 130.616 51.5704 130.773C51.834 130.853 52.1228 130.612 52.3625 130.998L53.0571 130.405C52.9631 130.23 52.8498 130.298 52.7365 130.379C52.6907 130.276 52.6714 130.163 52.6803 130.051C52.6892 129.939 52.726 129.83 52.7875 129.736C52.5866 129.567 52.5314 129.788 52.614 129.884C52.4936 130.042 52.3925 129.955 52.2934 129.858C52.1064 130.151 52.4409 129.996 52.5898 130.205L52.5866 130.206Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0263 124.156C60.7654 124.136 59.3581 123.777 59.112 123.436C58.8954 123.689 59.4935 124.006 59.2089 124.253C59.4105 124.422 59.4653 124.201 59.3823 124.105C59.4854 124.059 59.5983 124.04 59.7108 124.049C59.8233 124.058 59.9317 124.095 60.0263 124.156Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5468 132.153C47.6378 132.021 47.3838 132.913 46.6878 133.139C47.4358 133.732 47.3254 132.439 48.0257 132.598C48.1731 132.879 47.714 133.113 47.4793 133.364C48.779 134.343 48.4805 133.814 48.5479 132.153L48.5468 132.153Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8048 126.006C57.0434 126.069 57.2796 126.137 57.1011 126.353C57.9335 126.614 56.9943 125.389 57.203 125.066C56.7453 124.738 57.2539 125.802 56.8048 126.006Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.027 142.33C38.0683 142.095 37.2868 141.008 38.1036 141.365C38.5239 140.838 37.6049 141.321 37.4856 140.992C37.3153 141.41 37.6872 141.872 37.7057 142.305C37.5687 142.369 37.4134 142.381 37.268 142.34C37.1226 142.298 36.997 142.206 36.9139 142.08C36.7618 142.284 37.092 142.526 36.863 142.724C37.2306 142.857 37.6363 142.498 38.0274 142.33H38.027Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5476 127.932L55.0684 127.488C54.5647 127.714 54.1423 126.915 53.6329 127.212C53.4747 126.876 54.0525 126.598 53.3871 126.221C53.1086 127.396 53.7269 127.006 54.5476 127.932Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3845 115.43C66.7407 115.705 67.1749 114.993 67.4984 115.68C67.6729 114.495 68.7386 115.151 69.3064 115.337C69.5073 114.625 68.256 115.132 67.9472 114.096C68.0184 114.939 67.1315 114.964 66.3845 115.43V115.43Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7631 118.22C63.447 117.864 61.8947 118.553 61.9207 118.639C61.5228 119.428 62.8468 119.349 61.967 120.099L62.5597 120.794C62.4247 119.749 63.094 119.766 63.208 118.74C62.5832 118.354 62.9149 119.335 62.662 119.507C62.5765 119.419 62.5107 119.315 62.469 119.2C62.4273 119.084 62.4107 118.962 62.4204 118.84C62.43 118.718 62.4656 118.599 62.5247 118.492C62.5839 118.385 62.6653 118.292 62.7635 118.219L62.7631 118.22Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6853 118.127C65.8541 117.926 65.6333 117.871 65.5371 117.954C65.3914 117.726 65.7287 117.537 65.9097 117.336C65.3216 117.307 65.6838 116.653 64.9953 116.616C64.856 116.443 65.0929 116.3 65.1944 116.146C64.7998 115.736 64.5633 116.597 64.4999 116.738C64.6929 116.791 64.8734 116.882 65.0306 117.005C65.1878 117.129 65.3184 117.283 65.4146 117.459C65.1218 117.746 64.8671 117.559 64.5718 117.878C64.8952 118.566 65.3472 117.628 65.6853 118.127V118.127Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2833 130.671C50.5476 131.74 50.6822 129.731 49.9869 130.324C49.6998 130.569 50.2391 130.491 50.2833 130.671Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.553 121.607C60.6923 121.78 60.4554 121.923 60.3539 122.077C60.646 122.479 61.0367 121.631 61.3701 121.51C61.0816 121.065 60.7037 121.746 60.4048 121.434C60.2356 121.635 60.4568 121.69 60.553 121.607Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2085 114.52C69.1729 113.912 68.7501 113.794 68.1456 113.627C67.8831 113.857 68.931 114.371 69.2085 114.52Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6912 125.756C56.0452 125.542 55.1273 125.073 54.899 125.531C55.132 125.998 55.4418 125.496 55.6912 125.756Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2734 120.693C61.8982 121.08 61.5666 120.098 61.8198 119.926C61.4209 119.557 61.5256 120.521 61.2734 120.693Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2984 138.545C39.1335 138.694 39.3451 138.872 39.4213 139.041C38.648 138.798 38.3171 139.51 38.0574 139.904C38.4585 139.513 40.4179 139.078 39.2984 138.545Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5415 115.849C65.0374 115.721 65.8806 116.473 66.1345 116.544C66.4626 116.327 66.3315 115.864 66.6553 116.1C66.6132 115.254 66.0102 116.213 65.5415 115.849Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8644 129.83C50.1682 130.146 50.2719 129.13 50.9062 128.939C50.3004 128.424 50.149 129.412 49.8644 129.83Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0039 125.302C52.696 124.486 52.8114 125.76 53.1173 125.552C53.7973 125.178 53.091 124.954 52.8466 124.883C53.4272 124.366 53.9291 124.842 54.4556 125.01C54.0203 125.407 54.9072 125.909 54.0317 126.271C53.333 125.998 52.6552 125.674 52.0039 125.302ZM53.8839 126.099L54.2312 125.802C54.0734 125.682 54.1599 125.581 54.2565 125.482C53.954 125.212 53.6203 125.341 53.2659 125.727C53.5086 125.777 53.7269 125.908 53.8839 126.1V126.099Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6549 120.319C61.6996 120.443 60.2987 119.207 59.914 119.451C59.3979 118.953 60.7924 119.464 60.2866 118.833C60.7771 118.179 59.2419 119.827 59.4948 118.608C58.5288 118.337 59.7925 119.588 59.3929 119.896C59.8314 119.791 60.6627 119.644 60.1591 120.442C60.5509 120.643 60.496 120.197 60.6798 119.997C60.838 120.118 60.7511 120.219 60.6545 120.318L60.6549 120.319Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0247 141.038C36.7513 140.468 35.823 138.839 35.0131 139.501C35.2015 139.851 35.428 139.713 35.6567 139.552C35.9719 140.051 36.2868 140.9 35.5548 140.839C35.3511 141.271 35.8302 140.783 36.0247 141.038V141.038Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8865 136.889C41.0514 136.741 40.8402 136.562 40.7639 136.394C40.9331 136.307 41.0845 136.42 41.2594 136.271C41.4486 135.951 41.1169 136.081 40.9388 136.246C40.7383 136.068 40.7137 135.904 40.8163 135.751C40.0409 135.445 40.7162 136.587 40.8875 136.89L40.8865 136.889Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1915 123.529C55.8819 123.351 55.561 123.311 55.2515 123.131C55.2458 122.176 56.3368 123.038 56.4668 122.093C56.2271 122.058 55.79 121.848 56.0223 121.572C55.2482 121.647 53.9613 123.903 56.1915 123.529V123.529Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1983 127.995C49.3294 128.19 50.2469 127.707 49.8163 128.367C50.9283 128.7 49.3849 127.488 49.745 127.228C48.7954 127.235 48.4506 127.524 47.7635 127.718C47.2438 126.868 47.8049 126.103 47.4718 125.267C47.365 125.744 47.0953 126.208 47.5181 126.727C47.1234 126.941 46.8057 126.171 46.3783 126.798C46.5941 127.15 46.846 127.015 46.6989 126.824C47.7229 126.669 47.0551 127.403 47.7361 128.039C47.9637 127.582 48.9001 127.826 48.5276 128.264C49.0245 128.549 48.5472 127.42 49.4213 127.201C49.4161 127.48 49.3388 127.753 49.1969 127.993L49.1983 127.995Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5129 127.775C51.0711 128.111 50.5624 127.046 50.9111 126.835C50.8171 126.66 50.7035 126.728 50.5905 126.81L50.2433 127.106C50.4673 127.34 50.6903 127.573 50.5129 127.775Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5286 127.208C52.0782 126.821 51.5799 125.961 52.3966 126.467C52.6869 125.266 51.4349 126.53 51.1093 126.365C50.9765 126.74 51.3793 126.584 51.5286 127.208Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6598 113.995C66.829 113.794 66.6078 113.739 66.5116 113.822C66.1911 112.558 65.9695 111.414 65.7455 113.275C65.8416 113.45 65.9722 113.605 66.1293 113.728C66.2864 113.852 66.4668 113.943 66.6598 113.995Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2061 113.229C67.0327 114.112 67.5417 112.613 67.7013 113.106C68.0464 112.543 66.6954 112.747 67.7778 112.14C67.365 111.9 66.9194 112.073 66.4653 112.361C66.8044 112.621 67.2425 112.713 67.2061 113.229Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7239 120.167C58.565 120.865 59.0284 119.94 59.2446 119.723C58.1183 119.077 59.0316 119.59 58.7239 120.167Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0614 142.02C32.0178 141.157 32.0863 140.291 32.2651 139.445C31.5435 140.369 31.5285 141.431 32.0614 142.02Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5739 128.435C46.4866 128.86 46.5774 129.299 46.1504 129.697C46.3541 129.848 46.596 129.518 46.7936 129.748C47.0683 129.391 46.3566 128.957 47.043 128.634C47.0022 128.544 46.938 128.466 46.8571 128.409C46.7761 128.352 46.6813 128.318 46.5827 128.311C46.484 128.303 46.3851 128.322 46.2962 128.365C46.2073 128.409 46.1317 128.475 46.0773 128.558C46.2273 128.722 46.4061 128.512 46.5739 128.435Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2562 116.806C61.1532 116.852 61.0403 116.871 60.9279 116.862C60.8155 116.853 60.7071 116.817 60.6126 116.755C60.203 117.15 61.0635 117.387 61.2053 117.45C61.5483 117.153 61.0218 116.787 61.6035 116.51C61.3741 116.328 61.1084 116.629 61.2562 116.806Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7482 110.113C68.7343 110.519 68.9135 110.443 69.1927 110.633C69.3448 110.43 69.0146 110.188 69.2437 109.99C69.0399 109.838 68.7977 110.168 68.6 109.939C68.4312 110.14 68.652 110.195 68.7482 110.113Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5652 110.015C69.9602 110.425 70.1964 109.564 70.2598 109.422C70.0582 109.244 69.8181 109.546 69.5908 109.694C69.4327 109.573 69.5196 109.472 69.6161 109.373C68.8564 109.208 69.8031 109.899 69.5648 110.017L69.5652 110.015Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8843 135.598C39.2508 135.919 39.3317 134.901 38.9605 134.633C38.1131 134.888 39.3587 135.312 38.8843 135.598Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.839 125.696C51.017 125.494 50.715 125.254 50.5679 125.027C50.1444 125.606 49.8017 125.163 49.3778 125.742C49.5852 126.08 49.5916 126.74 50.144 126.289C48.9219 126.06 50.3456 125.245 50.839 125.696Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1595 111.768C68.5408 110.45 66.8621 110.326 68.1294 109.74C67.8964 109.273 67.5869 109.775 67.3376 109.515C67.5958 110.643 66.5732 110.664 67.1595 111.768Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3208 122.978C54.0072 123.278 53.1099 122.462 52.8253 123.101C52.6676 122.98 52.7541 122.879 52.851 122.78C52.7021 122.615 52.5233 122.826 52.3555 122.902C52.5133 123.023 52.4268 123.124 52.3299 123.223C52.6323 123.493 52.9664 123.364 53.3208 122.978Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.82 120.751C53.5764 120.421 53.295 120.566 53.0538 120.204C53.008 120.101 52.9887 119.988 52.9976 119.876C53.0065 119.764 53.0433 119.655 53.1048 119.561C53.4004 119.414 53.3808 119.853 53.2273 120.056C53.9343 120.357 53.4168 119.227 53.4766 118.942C53.7972 118.99 54.1634 118.45 54.4419 119.019C54.5798 118.598 54.0013 118.12 53.9001 117.681C53.8157 117.806 53.7791 117.957 53.797 118.107C53.8148 118.257 53.8859 118.396 53.9974 118.498C53.8289 118.585 53.6768 118.471 53.5023 118.621C53.4734 118.079 53.2334 117.52 53.9511 117.037C53.3737 116.606 53.545 116.807 53.2102 116.169C54.5994 116.414 53.4816 114.768 54.9467 114.687C55.0856 114.86 54.849 115.004 54.7472 115.157C54.8416 115.332 54.9548 115.264 55.0678 115.182L55.415 114.886C55.0528 114.008 54.5409 115.02 54.1787 114.14C54.0986 114.404 54.3401 114.693 53.9543 114.933C53.5108 114.519 53.9347 114.175 54.2036 113.819C53.2967 113.267 53.3812 114.433 53.3099 114.882C52.9042 115.144 53.1675 114.205 52.5438 114.335C52.1876 114.685 52.5438 115.091 52.9374 115.5L53.6319 114.907C53.7447 115.008 53.8168 115.147 53.8347 115.297C53.8526 115.448 53.8151 115.6 53.7292 115.725C53.4503 115.719 53.1775 115.642 52.9374 115.5C52.6322 115.875 52.3813 116.291 52.1922 116.736C52.5869 117.146 52.8234 116.285 52.8868 116.143C52.8351 116.571 53.4802 117.054 53.4282 117.482C52.4878 116.624 52.6524 118.871 53.301 119.091C52.9466 119.477 52.6129 119.606 52.3105 119.336C52.7194 119.542 52.8718 120.221 53.2968 121.195L53.82 120.751Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7422 138.832C34.4188 138.828 34.1413 138.238 33.7769 138.756C33.9297 138.868 34.0975 138.78 34.2467 138.955C34.0779 139.042 33.9262 138.928 33.7513 139.078C33.4232 139.531 34.4733 139.206 34.7422 138.832Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0475 112.341C57.899 112.919 58.8087 111.781 58.8137 112.887C58.2135 113.013 58.5102 113.185 57.7975 113.454C58.0402 113.504 58.2585 113.635 58.4155 113.827C58.8785 112.887 59.1635 111.935 60.3254 112.197C60.5124 112.927 59.4531 112.546 59.11 113.234C59.3487 113.298 59.5848 113.366 59.4064 113.582C59.9328 114.002 59.4498 113.083 59.779 112.964C60.1198 112.698 60.3713 113.743 59.7027 113.929C60.2053 113.968 61.1076 114.343 61.1888 113.561C60.9252 113.48 60.6367 113.722 60.397 113.337C60.5441 113.403 60.979 111.591 61.6123 112.299C60.8718 111.499 59.1189 111.712 58.0468 112.341L58.0475 112.341Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2102 115.345C60.485 115.625 60.9544 114.707 61.4346 114.553C60.9961 114.64 60.5883 114.332 60.1729 114.13C60.402 114.82 61.0385 115.192 60.0201 116.061C60.169 116.225 60.3475 116.014 60.5156 115.938C60.526 116.186 60.6216 116.422 60.7863 116.607C61.0232 116.154 61.223 115.682 61.3836 115.197C61.1824 115.028 61.1272 115.249 61.2102 115.345Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0202 111.839C66.2218 112.018 66.4618 111.716 66.6895 111.568C66.464 111.335 66.241 111.101 66.4187 110.899C65.6704 110.548 66.7094 111.655 66.0202 111.839Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3482 141.888C28.8276 141.964 29.327 141.792 29.758 142.486C29.8362 142.17 30.0315 141.896 30.3044 141.72C29.899 141.441 29.7195 141.582 29.6351 141.99C29.5223 141.889 29.4503 141.75 29.4324 141.6C29.4145 141.45 29.452 141.298 29.5378 141.173C29.146 140.972 29.2009 141.418 29.0171 141.618C28.3086 141.133 29.8036 140.694 28.7717 140.627C29.1959 140.04 29.494 141.045 29.9361 140.233C30.454 140.598 29.8648 140.874 29.8598 141.198C30.4846 141.585 30.153 140.604 30.4062 140.432C29.9756 139.737 29.4271 140.53 28.9961 139.835C28.0108 140.458 29.0641 141.243 28.3482 141.888Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7141 137.862C31.9216 138.025 31.4172 138.35 31.7951 139.247C31.5544 139.562 31.3517 139.389 31.1515 139.196C30.9994 139.4 31.3296 139.641 31.1006 139.839C31.5768 140.121 32.3195 139.091 31.6723 138.751C32.5022 138.972 33.1063 138.875 34.3231 137.989C33.9028 137.529 34.3142 137.393 33.7304 137.295C34.3915 136.767 34.3829 137.175 34.67 137.693C34.7028 137.156 35.0283 136.642 34.4755 136.059C34.0249 136.43 34.374 136.369 34.5984 136.554C34.3056 136.842 34.0506 136.654 33.7556 136.973C33.5063 136.506 34.2828 135.866 33.3638 135.809C33.1091 136.544 34.0687 137.376 32.8652 138.036C33.2962 137.335 32.6803 137.445 33.1145 136.923C32.3209 136.392 32.525 137.408 32.7163 137.862H32.7141Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.647 134.852C37.544 134.898 37.4312 134.917 37.3189 134.908C37.2065 134.899 37.0982 134.863 37.0037 134.801C36.8106 135.097 37.2612 134.965 37.4482 135.322C37.7688 135.131 37.6071 134.903 37.8208 134.704C37.6196 134.535 37.5643 134.756 37.6473 134.852H37.647Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5686 116.352C58.3971 116.708 57.8179 116.877 58.2839 117.542C59.1868 116.351 57.1056 116.253 58.9321 115.489C58.2981 115.416 57.8806 115.783 57.5686 116.352Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9758 124.332C50.1849 124.025 49.6581 123.659 50.374 123.393L50.0777 123.045C49.9573 123.203 49.8561 123.117 49.7571 123.02C49.7767 123.454 49.6178 123.872 49.9772 124.333L49.9758 124.332Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2967 142.532C28.0656 142.143 27.7998 140.912 28.3267 140.106C27.9227 139.754 27.5199 139.388 27.0394 140.004C28.4513 139.991 26.7455 140.877 27.8522 142.011C27.4426 142.411 27.081 142.208 26.7124 142.082C26.5549 142.891 27.8814 142.172 28.2957 142.531L28.2967 142.532Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0529 128.646C40.8802 128.785 40.7366 128.548 40.5828 128.447C40.2394 129.391 39.6367 129.642 39.2648 130.771C40.3452 130.555 40.3181 131.986 41.344 131.098C40.8499 131.199 40.4178 130.504 39.9338 130.5C39.6734 130.156 40.405 129.89 40.0104 129.535C41.0141 129.579 41.0807 128.818 41.4248 128.027C41.2061 127.632 40.4175 128.449 41.0522 128.645L41.0529 128.646Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0649 130.183C41.7123 129.86 41.2614 130.786 40.9002 130.575C40.7919 130.926 41.9577 130.838 42.0649 130.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4752 122.105C50.2854 122.36 50.7021 122.663 50.8941 122.948C51.5299 122.459 50.9653 121.874 51.3433 121.365C50.8425 120.883 51.1345 122.599 50.4752 122.105Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3574 123.96C48.971 123.603 48.842 123.271 49.112 122.969C48.6098 122.92 47.6826 122.857 47.6 123.659C48.0741 123.805 48.624 122.993 49.0354 123.934C48.0883 124.425 48.5396 124.744 49.356 123.96H49.3574Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9741 132.774C38.1134 132.946 37.8765 133.09 37.775 133.243C38.1775 133.568 38.8123 132.593 38.8169 132.353C38.574 132.304 38.3555 132.172 38.1985 131.98C38.1371 132.075 38.1003 132.183 38.0915 132.296C38.0826 132.408 38.102 132.521 38.148 132.624C37.7704 132.587 37.6496 132.933 37.9741 132.774Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5082 139.145C30.1612 139.437 29.8831 138.86 29.5169 139.39L29.9614 139.911C29.9903 139.323 30.6446 139.685 30.6816 138.997C30.4804 138.828 30.4266 139.049 30.5082 139.145Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8234 135.763C35.1337 135.409 34.7632 135.003 35.0728 134.649C34.859 134.295 34.3903 135.213 34.8487 135.441C34.6918 135.499 34.5242 135.522 34.3575 135.509C34.1907 135.496 34.0289 135.446 33.8831 135.365C33.5319 136.111 34.5972 135.603 34.8234 135.763Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.385 120.475C52.1296 120.618 51.9152 120.28 52.0883 120.128C51.7948 119.908 51.9127 120.541 51.5928 120.251C51.403 120.505 51.8197 120.808 52.0117 121.093C52.4374 120.857 52.3697 120.582 52.5581 120.327C52.3569 120.158 52.3016 120.38 52.3846 120.475H52.385Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4203 116.179C57.1674 115.962 56.8504 116.56 56.6029 116.276C56.288 116.676 57.5863 116.762 57.4203 116.179Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6074 122.846C49.5753 122.333 49.4505 121.829 49.2391 121.36L48.5445 121.952C49.2694 122.065 49.1084 122.111 49.6074 122.846Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2971 115.683C57.7246 115.732 57.6957 115.423 58.1655 114.942C57.9365 114.678 57.2038 114.775 57.8182 115.238C57.5379 115.371 57.2839 115.167 57.0011 115.336C56.8123 115.656 57.1436 115.526 57.3217 115.361C57.4795 115.481 57.3929 115.583 57.2961 115.682L57.2971 115.683Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8283 111.264C63.41 110.985 62.8835 110.62 63.2266 110.324C62.6998 109.943 62.7279 111.584 62.0867 110.395C61.9114 110.491 61.7573 110.622 61.6336 110.779C61.5099 110.936 61.4192 111.117 61.3669 111.31C61.5952 111.497 62.0793 111.096 61.8876 110.865C62.0656 110.841 62.2467 110.866 62.412 110.936C62.5774 111.006 62.7209 111.119 62.8276 111.263L62.8283 111.264Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7484 142.006C26.1666 142.078 26.4024 141.569 26.6421 140.944C26.3985 140.614 26.1171 140.759 25.8759 140.398C26.2079 141.322 26.0248 141.198 25.7484 142.006Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2393 117.139C54.6797 115.698 53.7977 116.91 55.2393 117.139V117.139Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4029 125.187C44.1478 125.329 43.933 124.991 44.1065 124.839C43.5263 124.548 43.9416 126.532 44.6992 125.534C44.4987 125.356 44.4737 125.192 44.5763 125.038C44.3751 124.87 44.3199 125.091 44.4029 125.187Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1724 122.57L47.7278 122.05C47.3777 122.238 47.5141 122.465 47.6769 122.693C47.5038 122.832 47.361 122.596 47.2071 122.494C46.8705 123.049 47.8888 123.13 48.1724 122.57Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0811 120.94C50.344 120.71 49.295 120.195 49.0183 120.047C48.578 120.26 49.2281 121.037 48.993 120.367C49.3916 120.106 49.6911 121.091 50.0811 120.94Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9012 117.447C48.4271 118.057 48.628 118.721 49.0704 119.403C48.6918 120.097 48.4581 118.955 48.0795 119.649C48.6048 119.831 49.1377 119.915 49.6631 120.098C49.1698 119.512 49.1698 118.449 48.9012 117.447Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9199 113.951C56.4492 113.306 56.3573 114.473 57.9199 113.951V113.951Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4761 127.384C41.7051 127.648 42.4378 127.551 41.8234 127.087C42.3035 126.434 42.8328 126.786 42.8652 126.197C42.1885 125.663 42.0104 126.95 41.4761 127.382V127.384Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9822 141.46C25.5995 141.312 25.1058 139.679 25.9521 139.432C25.072 138.866 24.7902 138.816 24.6186 137.869C23.82 138.253 24.968 139.045 24.0469 138.958C23.7954 139.67 25.052 138.339 25.3089 139.381C24.8348 140.045 25.2643 140.781 24.9822 141.46Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2837 131.262C37.06 131.11 35.8945 131.301 36.5891 131.854C36.6878 131.271 36.8238 131.682 37.2837 131.262Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3673 129.484C39.4564 128.465 40.261 127.503 39.7702 126.439C39.7623 127.822 38.8736 128.139 39.3673 129.484Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0167 136.93C25.3779 136.538 25.0199 136.125 24.5978 136.087C24.9098 136.237 25.2881 135.542 25.5884 135.842C26.0005 135.418 25.095 135.746 24.9957 135.147C25.5438 134.864 26.0192 134.458 26.3848 133.962C26.7008 134.202 26.5273 134.405 26.3339 134.605C26.5889 134.795 26.8913 134.378 27.1763 134.186C26.1911 133.983 26.9939 133.392 27.5749 133.246C27.7173 133.568 27.2942 133.367 27.0537 133.69C27.0945 133.781 27.1587 133.858 27.2397 133.915C27.3206 133.972 27.4153 134.006 27.5139 134.014C27.6125 134.021 27.7114 134.003 27.8002 133.959C27.8891 133.916 27.9646 133.849 28.019 133.767C27.9913 133.443 27.8414 133.142 27.5998 132.924C26.8098 132.988 26.622 133.221 26.0628 133.936C25.4801 133.469 26.4849 133.165 25.6436 133.093C26.1066 134.33 24.0763 134.58 25.1182 135.642C24.3078 135.977 24.4368 136.558 23.8772 137.001C24.549 137.551 24.3445 136.38 25.017 136.93L25.0167 136.93Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.674 135.122C24.1967 135.015 23.7322 134.745 23.2136 135.168C23.3387 135.252 23.4902 135.289 23.6402 135.271C23.7903 135.253 23.9289 135.182 24.0307 135.071C24.0413 135.318 24.137 135.555 24.3017 135.74L24.649 135.444C24.4912 135.323 24.5778 135.222 24.6743 135.123L24.674 135.122Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3868 135.253C28.9627 135.016 28.7027 136.3 29.4497 136.147C30.0509 135.623 27.6331 134.321 28.1161 134.584C27.861 134.727 27.6462 134.389 27.8197 134.237C26.7707 134.344 27.8008 134.969 28.3868 135.254C27.8625 135.744 27.4104 135.317 26.9513 134.978C26.6222 135.81 25.6765 136.802 25.0161 136.93C24.936 137.194 25.1771 137.482 24.7913 137.722C26.1652 138.581 25.8738 136.514 27.243 137.43C27.2541 137.334 27.2393 137.238 27.2003 137.15C27.1613 137.062 27.0994 136.986 27.0212 136.931C26.9429 136.875 26.8512 136.841 26.7555 136.833C26.6597 136.824 26.5635 136.842 26.4769 136.883C25.8432 136.349 27.5098 135.993 26.7525 135.448C27.2131 135.084 27.5789 135.914 28.0395 135.55C28.3957 135.828 27.4653 136.479 27.3706 135.821C27.2455 136.189 27.0421 136.551 27.4418 136.961C28.0238 136.257 28.042 136.106 28.7547 136.741C28.9446 136.486 28.5278 136.183 28.3355 135.898C28.2176 135.673 28.5802 135.486 28.3864 135.255L28.3868 135.253Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9316 133.427C31.6235 134.061 32.924 133.917 32.8221 134.469C33.8504 134.327 32.587 133.308 31.9316 133.427Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.768 125.381C42.7785 125.629 42.8742 125.865 43.039 126.05C43.0882 125.808 43.2198 125.589 43.4116 125.432C43.1787 124.966 42.8695 125.468 42.6202 125.208C42.451 125.409 42.6718 125.464 42.768 125.381Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7944 120.839C47.2158 121.478 48.2616 122.104 48.7944 120.839V120.839Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0676 140.74C23.7382 140.123 24.5805 140.589 24.7622 140.148C24.5192 140.098 24.3007 139.967 24.1439 139.775C23.4489 140.676 24.0174 140.714 24.4865 141.583C24.6967 141.35 24.6251 140.039 24.0676 140.74Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.608 132.345C35.0201 131.921 34.1143 132.25 34.0153 131.65C34.1161 132.036 33.6861 132.38 34.0865 132.79C34.4163 132.572 34.2842 132.109 34.608 132.345Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1434 121.602C45.9429 121.993 46.3878 121.939 46.588 122.122L46.9353 121.826C46.4957 121.371 46.6934 121.002 47.16 121.035C47.347 120.5 46.0793 121.213 45.6736 121.402C45.2861 122.039 46.3116 121.153 46.4929 121.305C46.6353 121.56 46.297 121.775 46.1456 121.602H46.1434Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7134 141.849C22.0162 142.174 22.1444 140.849 22.6791 141.926C23.4862 141.558 22.8059 141.071 23.4243 140.69C23.1393 140.21 22.7852 140.583 22.5099 139.97C23.0022 139.4 23.6141 140.519 23.6746 139.578C22.9861 139.641 22.9979 139.493 23.7256 138.934C23.2226 138.467 22.616 139.316 22.1676 138.163C21.384 138.692 22.6762 138.484 22.413 139.154C22.1733 138.803 21.7484 139.272 21.1514 138.731C20.7777 140.09 20.0803 139.868 20.6527 140.958C20.8308 140.758 20.9943 140.733 21.1482 140.835C21.338 140.581 20.9213 140.278 20.7293 139.992C20.9768 139.982 21.2131 139.886 21.3982 139.722C21.1977 139.544 21.1727 139.38 21.2753 139.226C21.5004 139.108 21.6878 139.471 21.9186 139.277C22.112 139.724 21.0833 140.075 21.8171 140.564C22.3988 140.287 21.8723 139.921 22.2153 139.625C22.5081 140.079 22.4971 140.51 23.0787 140.988C22.2541 141.007 21.4331 141.104 20.627 141.279C20.3506 141.683 21.4345 141.751 21.7669 141.208C21.8127 141.311 21.832 141.424 21.8231 141.536C21.8142 141.649 21.7774 141.757 21.7159 141.852L21.7134 141.849Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8391 134.961C32.2963 133.692 30.4612 134.068 31.1401 133.204C30.4836 132.757 30.7437 133.393 30.1235 133.771C30.4024 134.341 30.769 133.801 31.0888 133.848C31.5373 134.261 29.9775 134.515 30.8395 134.961H30.8391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8097 128.713C37.9037 128.888 38.017 128.82 38.1302 128.738L38.4775 128.442C37.6722 128.432 38.5416 127.584 37.7366 127.574C37.1874 128.245 38.3575 128.041 37.8079 128.714L37.8097 128.713Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6517 114.34C55.649 113.5 54.4227 113.478 54.4825 112.384C54.1619 112.195 54.2923 112.527 54.4572 112.705C54.1587 113.459 53.1966 112.664 53.441 113.272C53.1763 113.64 54.0109 113.019 54.5808 113.2C55.0211 113.614 54.023 113.912 54.6517 114.34Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6728 125.622C39.9093 126.049 40.184 125.98 40.439 126.168C40.3033 125.694 41.4602 124.835 41.5318 124.637C42.1562 124.961 41.4937 124.185 41.2355 124.29C41.103 125.239 40.4996 125.287 39.6728 125.622Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1394 119.251C47.3841 119.883 46.4627 119.393 46.5934 120.017C46.8362 120.067 47.0545 120.199 47.2114 120.39C47.1252 119.952 47.4322 119.545 47.6353 119.129C47.3966 119.065 47.1601 118.997 47.3389 118.782C46.6172 119.146 46.9079 117.024 45.5818 118.481C46.1652 118.579 45.7546 118.715 46.1745 119.175C46.1357 119.917 46.3729 118.631 46.0773 118.358C46.8103 118.133 46.4124 119.406 47.1398 119.251L47.1394 119.251Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8942 132.213C30.5783 132.514 31.5845 132.742 31.8086 132.933C31.6882 133.091 31.587 133.005 31.488 132.908C31.935 133.78 32.0508 132.1 30.8953 132.213H30.8942Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8666 131.477C34.4543 131.067 32.9975 131.352 33.5959 130.808C33.3946 130.639 33.3398 130.861 33.4224 130.956C33.302 131.115 33.2009 131.028 33.1018 130.931C32.7154 131.555 33.6967 131.224 33.868 131.477H33.8666Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7764 129.847C34.4909 129.682 34.6145 130.959 35.7764 129.847V129.847Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1018 126.71C39.3974 126.903 39.2653 126.452 39.6226 126.265C38.5565 125.083 38.8845 126.018 39.1018 126.71Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7221 123.92C42.7838 123.826 42.8208 123.718 42.8298 123.605C42.8387 123.493 42.8193 123.38 42.7734 123.277C42.9514 123.076 43.1149 123.051 43.2685 123.154C43.2809 122.038 42.1066 123.273 42.7221 123.92Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2202 120.635C45.5146 119.054 45.0337 120.609 46.2202 120.635V120.635Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7644 127.252C37.9336 127.051 37.712 126.996 37.6162 127.078C38.0458 126.181 37.3067 126.647 37.5699 125.618C37.3148 125.428 37.0124 125.845 36.7271 126.037C36.7389 125.658 36.574 125.551 36.2573 125.838C37.4399 126.005 37.0445 126.901 37.7644 127.252V127.252Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3159 129.894C34.4666 129.366 34.0452 128.793 33.7998 128.234C33.222 128.715 32.6318 129.353 32.1399 128.75C32.0617 129.065 31.8663 129.339 31.5935 129.516C31.7919 129.698 32.4441 129.278 33.029 129.791C32.946 129.353 33.1284 128.936 33.7745 128.555C33.9843 129.003 33.767 129.418 34.3163 129.893L34.3159 129.894Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2739 116.829C48.5555 115.986 48.3122 116.932 47.8135 116.875C47.6386 117.254 48.8362 117.425 49.2739 116.829Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7949 116.384C50.1642 115.981 49.2011 116.079 49.003 116.16C48.6607 115.706 49.5477 115.607 49.6976 115.567C49.9242 115.331 48.624 115.373 49.4522 114.577C48.2896 114.34 49.7372 115.666 48.5329 115.961C48.9218 116.504 49.371 116.281 49.7945 116.384H49.7949Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.801 137.967C24.0967 138.16 23.9649 137.709 24.3218 137.522C23.3501 136.982 23.5738 137.05 23.801 137.967Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2705 124.212C39.6472 123.783 39.0744 124.174 38.886 123.293C38.1978 123.616 39.1353 124.068 38.6366 124.406C39.1617 123.929 39.4545 124.334 40.2705 124.212Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7681 120.927C43.185 120.46 44.1898 120.156 43.3492 120.084C43.5109 120.679 43.2545 121.446 42.4555 121.147C42.1375 121.507 43.1141 121.396 42.5528 121.964C43.3499 122.26 43.2887 120.705 44.0901 120.953C44.2789 120.632 43.9476 120.762 43.7695 120.927H43.7681Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4067 114.407C51.1524 114.462 49.8712 114.162 50.564 114.825C50.8582 114.539 51.1132 114.727 51.4067 114.407Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7424 125.469C38.0381 125.662 37.9063 125.212 38.2632 125.025L37.8187 124.504C37.4397 125.198 37.2064 124.056 36.8277 124.75C37.1127 125.248 37.7645 124.838 37.7421 125.469H37.7424Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6254 132.602C28.2089 132.701 27.7982 132.837 28.2182 133.297C28.5939 133.322 28.9996 132.97 29.4082 132.582C29.2077 132.404 29.1827 132.24 29.2857 132.086C28.8821 132.587 28.5886 132.879 27.6258 132.602H27.6254Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8226 131.074C30.2644 132.444 31.8694 128.913 30.7 130.579C30.5305 130.821 30.897 130.892 30.8226 131.074Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9441 117.616C47.2871 117.319 46.7603 116.954 47.3423 116.676C47.1133 116.495 46.8475 116.796 46.995 116.973",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9352 139.766C20.2868 138.832 18.956 137.59 19.5669 138.279C19.605 138.553 19.3211 138.8 19.6641 139.097C19.2406 139.676 18.898 139.233 18.4741 139.812C19.0981 140.014 19.5491 139.22 19.7361 140.236C19.7995 139.997 19.8675 139.761 20.0834 139.939C20.2522 139.738 20.031 139.683 19.9352 139.766Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3047 128.357C33.2107 128.182 33.0974 128.25 32.9841 128.331C32.3227 128.372 32.6682 127.129 32.146 126.646L31.2779 127.387C31.4795 127.565 31.7193 127.263 31.9469 127.116C32.4277 127.657 32.4032 129.167 33.3047 128.357Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4652 121.393C41.8926 121.156 41.8232 120.881 42.0112 120.626L41.4652 121.393Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8824 130.677C30.4263 131.275 30.1417 129.818 30.5513 130.406C30.7422 130.137 30.3056 130.087 30.0811 130.207C30.0707 129.959 29.9751 129.723 29.8104 129.538C30.063 129.506 30.796 129.395 30.183 128.92C30.4619 128.925 30.7347 129.002 30.9748 129.144C31.3766 128.852 30.5282 128.461 30.4078 128.128C30.2165 128.869 29.4354 129.563 29.5857 130.33C29.8197 130.533 30.583 130.038 29.882 130.677L29.8824 130.677Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7367 127.34C33.1806 127.872 33.7152 127.253 34.2231 126.972C34.0511 126.921 33.8684 126.917 33.6942 126.96C33.5199 127.003 33.3604 127.092 33.2322 127.218C33.0744 127.098 33.161 126.997 33.2578 126.897C32.9622 126.704 33.094 127.155 32.7371 127.342L32.7367 127.34Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2671 122.92C38.1093 122.8 38.1958 122.699 38.2927 122.599C37.7228 122.45 38.0819 123.094 38.5638 123.268C38.7722 123.058 38.8994 122.781 38.9225 122.487C38.9456 122.192 38.8631 121.898 38.6899 121.659C38.3429 121.951 38.0648 121.374 37.6993 121.904C37.9782 122.474 38.3447 121.933 38.6646 121.981C38.8844 122.322 38.7045 122.631 38.2671 122.92Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6847 136.425C20.9031 137.137 20.2114 137.375 19.6429 137.316C19.4911 138.052 20.8571 136.833 21.2262 137.764C21.3444 136.966 21.223 136.613 22.1455 136.38C22.3382 135.77 21.0513 136.727 20.6847 136.425Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9523 140.257C18.0017 140.014 18.1334 139.796 18.3252 139.638L17.9523 140.257Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1964 135.735C22.4457 135.751 22.9088 135.343 23.0645 134.994C21.9104 135.042 22.4664 134.2 22.0529 133.457C21.4537 133.556 21.7822 134.462 21.3583 134.05C21.4712 134.46 22.4012 134.698 22.1964 135.735Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6053 130.82C28.5759 131.126 28.5517 129.201 29.5405 128.868C28.935 129.016 28.3206 129.282 27.7596 128.889C27.4297 129.331 28.3544 129.801 28.2294 129.088C28.4182 129.697 28.2846 130.28 27.6053 130.82Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9782 125.981C34.2689 125.401 33.1048 126.344 32.8138 126.375C32.0979 126.336 33.6199 126.685 33.9782 125.981Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1029 123.314C37.2721 123.113 37.0505 123.057 36.9547 123.14C36.8158 122.748 37.261 122.691 37.4502 123.017C37.6023 122.814 37.2721 122.572 37.5015 122.374C36.2249 122.916 36.0528 121.74 35.448 121.726C35.2699 121.928 35.5716 122.167 35.7191 122.395C35.701 122.717 35.6755 123.039 35.6425 123.36C36.0372 123.77 36.2737 122.909 36.3371 122.768C36.5376 122.946 36.5622 123.109 36.46 123.263C36.6637 123.415 36.9056 123.085 37.1032 123.314H37.1029Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.356 137.212C17.9182 137.15 17.8929 138.469 17.0177 137.754L18.356 137.212Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3303 137.534L18.7748 138.055C19.2204 137.766 18.5394 137.388 18.851 137.09C18.5554 136.897 18.6872 137.348 18.3303 137.534Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7002 135.858L22.0475 135.561C21.8893 135.441 21.9762 135.34 22.0728 135.241C21.7725 134.942 21.3938 135.636 21.0818 135.486C20.9732 135.235 21.0106 134.785 21.2809 135.017C21.4505 134.074 20.3669 135.133 20.3153 134.94C20.0285 135.474 21.1235 135.403 21.3525 136.156C21.5174 136.007 21.3059 135.828 21.2296 135.66C21.4028 135.521 21.5456 135.758 21.6998 135.859L21.7002 135.858Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4907 130.57C26.3023 130.22 26.0754 130.356 25.8471 130.519C25.8364 130.271 25.7406 130.035 25.576 129.85C25.6733 131.31 24.158 130.337 23.8396 131.332C24.197 131.839 24.6607 132.263 25.1984 132.573C25.3502 132.369 25.0204 132.127 25.249 131.929C24.9416 131.72 24.5765 132.247 24.309 131.531C24.5904 130.933 25.4692 131.984 24.8298 131.086C25.3972 130.738 25.8984 131.237 26.49 130.57L26.4907 130.57Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6584 127.014C31.3801 127.533 31.5489 125.499 31.9963 126.472C32.1904 125.775 30.8208 125.878 32.0981 125.185C30.8276 124.839 31.717 126.693 30.6584 127.014Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5942 120.841C37.8199 120.794 38.5778 120.297 38.0272 119.825C37.7935 120.08 37.9274 121.526 38.5942 120.841Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1523 135.332C18.8093 135.629 19.3358 135.994 18.7541 136.272C18.353 135.862 18.783 135.519 18.6829 135.132C18.0773 134.939 18.8065 136.208 17.7642 136.517C18.3864 136.721 19.0483 136.773 19.6948 136.669C18.9853 136.752 19.4558 135.821 19.8683 136.521L20.2156 136.225C20.0578 136.104 20.1443 136.003 20.2412 135.904C19.64 135.571 19.3685 136.275 19.153 135.333L19.1523 135.332Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9382 127.928C30.1641 127.786 30.2143 127.627 30.1373 127.459C30.3724 126.675 29.8007 128.27 29.3202 127.556C28.8896 128.216 29.8071 127.733 29.9382 127.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2394 121.951C36.9461 122.215 37.0668 121.606 37.2812 121.06C36.8716 120.882 36.1197 121.009 37.0102 120.391C36.7665 120.061 36.4851 120.206 36.244 119.844C36.0623 120.073 36.3633 120.339 36.5404 120.192C36.5261 120.786 36.1856 121.352 36.2394 121.951Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8273 124.516C32.015 124.866 32.2423 124.728 32.471 124.567C32.6715 124.745 32.6964 124.909 32.5939 125.063C32.6879 125.237 32.8015 125.169 32.9144 125.088L33.2617 124.791C32.8742 124.376 32.4781 124.531 32.5208 123.923C32.045 123.781 32.7107 124.45 31.8263 124.516H31.8273Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3603 121.154C34.5331 121.015 34.6763 121.252 34.8301 121.353C34.823 121.72 34.4066 121.923 33.7883 122.244C34.031 122.293 34.2493 122.425 34.4063 122.617C34.1135 122.904 33.8588 122.717 33.5639 123.036L34.0084 123.557C34.173 123.408 33.9614 123.229 33.8855 123.061C33.9706 123.071 34.0567 123.063 34.1386 123.038C34.2205 123.013 34.2964 122.971 34.3615 122.916C34.4266 122.86 34.4797 122.792 34.5173 122.715C34.5549 122.638 34.5762 122.554 34.5801 122.468C34.7806 122.646 34.8052 122.81 34.703 122.964C35.2914 123.348 34.6189 122.339 35.249 122.197C34.3293 122.335 34.9666 121.954 35.1518 121.38",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4219 121.815C29.4766 122.278 30.1135 121.902 30.1972 122.607C29.6036 122.765 28.9993 122.879 28.3891 122.95C29.4545 122.846 29.4905 123.677 30.5145 124.737C30.7817 123.32 31.6034 124.795 31.2601 123.501C30.8743 123.602 30.5306 123.171 30.1202 123.572C30.1338 123.166 29.955 123.241 29.6757 123.051C30.22 122.997 30.8091 122.37 31.3612 122.213C31.57 122.607 31.1333 122.95 31.7548 123.377C32.3516 122.655 32.888 122.698 33.3641 123.505C33.5397 123.249 33.3762 122.966 33.5889 122.713",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.626 128.148C28.3253 127.681 26.6138 128.441 27.2625 129.012C27.5916 128.225 27.9492 128.616 28.626 128.148Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7126 137.161C18.067 136.948 17.1484 136.479 16.9211 136.937C17.154 137.403 17.4615 136.901 17.7126 137.161Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.013 126.729C24.8609 127.365 24.6265 127.994 25.1822 128.686C24.9596 128.02 26.0203 127.457 25.013 126.729Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9815 132.318C22.2828 131.921 22.5239 132.282 22.7733 132.542C22.9254 132.339 22.5952 132.096 22.8242 131.899C22.699 131.814 22.5475 131.778 22.3974 131.795C22.2472 131.813 22.1086 131.885 22.0068 131.996C21.969 131.724 22.2525 131.476 21.9092 131.177C21.7841 131.545 21.5811 131.907 21.9804 132.317L21.9815 132.318Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 132.165C20.506 132.758 20.6064 133.631 21.4346 133.085C21.0595 133.049 20.714 132.638 20.3717 132.191C20.8233 131.898 21.379 131.918 21.4136 131.3C21.0488 131.318 20.2463 132.168 20.6217 131.076C20.0518 130.937 19.5268 132.166 19.2073 132.583C19.8506 132.227 19.5873 132.662 19.6265 133.426C20.0183 133.652 19.7181 132.477 20.05 132.164V132.165Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5233 129.202C23.0424 129.821 22.6495 129.331 22.2104 129.422C21.9938 129.675 22.5922 129.992 22.3076 130.239C23.4285 130.636 23.8065 129.588 23.722 128.732C23.628 128.557 23.5144 128.625 23.4015 128.706L23.0542 129.003C23.2073 129.115 23.3748 129.027 23.5244 129.202H23.5233Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9574 133.698C19.0379 133.435 18.7964 133.146 19.1821 132.906C18.6835 132.625 17.7403 133.248 18.1403 133.797C18.3155 133.703 18.2471 133.589 18.1659 133.476C18.3025 133.412 18.4575 133.399 18.6028 133.44C18.7481 133.481 18.8739 133.572 18.9574 133.698Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6644 130.188C22.1887 130.522 21.5319 129.445 21.419 129.197C21.7417 129.215 22.0635 129.241 22.3843 129.273",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9909 123.888C28.756 125.025 29.0762 123.662 27.9909 123.888V123.888Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2199 129.668C20.983 129.589 20.5128 129.816 20.7497 129.468C20.0402 129.562 21.5034 131.42 21.2199 129.668Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0974 124.95C26.9906 125.873 27.4098 124.163 27.7664 124.679C27.8996 124.305 27.4967 124.46 27.3475 123.837C26.6604 124.161 27.3717 124.594 27.0974 124.95Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6334 128.16C22.5326 127.775 22.9629 127.431 22.5622 127.02C22.0585 127.359 22.4232 127.764 22.6334 128.16Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5049 124.257C26.9035 124.626 26.7991 123.662 27.0513 123.49C26.8981 123.378 26.7307 123.466 26.5811 123.291L26.2338 123.588C26.4589 123.821 26.6823 124.055 26.5045 124.257H26.5049Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.771 122.576C27.5694 122.398 27.3297 122.699 27.1017 122.846C26.8834 121.722 28.9026 121.682 29.6553 121.268",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6512 128.556C47.6612 128.213 47.1105 128.769 47.1205 128.429C46.7664 128.733 47.5661 128.897 47.6512 128.556Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.785 128.042C48.8761 127.997 48.8758 127.895 48.9951 127.868C48.9502 127.776 48.8484 127.777 48.8209 127.657C48.7301 127.703 48.7301 127.804 48.6108 127.832C48.6557 127.922 48.7575 127.922 48.785 128.042Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3977 129.132C41.8608 129.139 41.4689 128.455 41.351 128.391C41.0643 128.674 41.3104 128.728 41.3977 129.132Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2944 129.815C36.5502 129.737 36.48 129.457 36.3942 129.166C36.2407 129.308 36.3108 129.589 36.2944 129.815Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0327 125.301C53.1475 125.171 53.3076 125.089 53.4805 125.072C53.4698 124.853 52.7652 125.015 53.0327 125.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4888 126.232C48.876 126.326 48.7121 125.62 48.4058 125.876L48.4888 126.232Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.819 126.601C45.9398 126.379 45.8927 125.832 45.7446 125.741C45.6626 125.873 45.6256 126.028 45.639 126.183C45.6525 126.338 45.7156 126.485 45.819 126.601Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4606 130.614C27.4884 130.655 27.7608 130.765 27.8445 130.649C28.0323 130.392 27.1884 130.206 27.4606 130.614Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7231 127.301C42.0398 127.087 41.482 126.95 41.2836 127.027C41.311 127.311 41.6579 127.081 41.7231 127.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1707 127.073C42.3357 127.006 42.1298 126.708 42.3257 126.661C42.1027 126.31 42.0129 126.854 42.1707 127.073Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2457 129.109C31.2521 129.351 31.8274 129.157 31.5745 128.908L31.3369 128.963C31.381 129.059 31.3169 129.086 31.2457 129.109Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4951 127.425C38.6964 127.763 38.7801 127.215 38.9429 127.196C38.7416 126.859 38.6576 127.408 38.4951 127.425Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5631 126.605C42.8295 126.602 42.7501 126.383 42.718 126.194C42.6272 126.239 42.6272 126.34 42.5079 126.368L42.5631 126.605Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7274 127.924C34.8923 127.858 34.6864 127.56 34.8823 127.513C34.6593 127.162 34.5699 127.706 34.7274 127.924Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8803 126.37C41.2041 126.335 40.6146 125.729 41.1265 125.812C40.802 125.456 40.672 126.059 40.8803 126.37Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8976 129.26C28.147 128.983 27.4584 128.527 28.2075 128.436C28.1124 128.165 27.6693 128.489 27.613 128.575C27.6654 128.872 27.7281 129.153 27.8976 129.26Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4672 125.644C43.7521 125.527 43.3674 125.181 43.1466 125.343C43.225 125.489 43.3995 125.481 43.4672 125.644Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7777 127.626C33.027 127.611 33.1439 127.515 33.079 127.305L32.7228 127.388L32.7777 127.626Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8111 123.294C49.6708 123.467 49.5511 123.49 49.4268 123.258C49.0934 123.547 50.0669 123.95 49.8111 123.294Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9945 125.235C42.0009 125.476 42.5762 125.283 42.3236 125.033L42.086 125.089C42.1313 125.184 42.0658 125.211 41.9949 125.235H41.9945Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0629 122.753C50.9165 122.831 50.9244 123.005 50.7616 123.073C50.8788 123.358 51.2239 122.973 51.0629 122.753Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9935 123.001C50.1584 122.934 49.9525 122.636 50.1484 122.589C49.9639 122.29 49.8154 122.841 49.436 122.755C49.6198 123.182 49.8104 122.576 49.9942 123.001H49.9935Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5438 127.161C31.7087 127.095 31.5028 126.797 31.6987 126.749C31.4758 126.399 31.386 126.943 31.5438 127.161Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8434 125.698C38.1348 125.611 37.7847 125.288 37.733 125.223C37.395 125.383 37.9072 125.449 37.8434 125.698Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6904 125.591C36.616 125.221 36.2491 125.32 35.8943 125.4C35.9755 125.53 36.1044 125.623 36.2533 125.659C36.4022 125.694 36.5592 125.67 36.6904 125.591Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8399 127.395C28.0536 127.247 28.1704 126.88 27.9396 126.746C27.7864 126.887 27.8566 127.168 27.8399 127.395Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6692 123.825C42.6802 124.044 43.3844 123.883 43.1173 123.596C42.9004 123.632 42.9 123.8 42.6692 123.825Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6047 121.857C51.0443 121.867 50.7176 121.422 50.6133 121.354C50.4601 121.428 50.5837 121.673 50.6047 121.857Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8257 120.66C49.4079 120.557 49.5877 121.488 49.378 120.889C49.2949 120.993 49.1788 121.064 49.0492 121.091C49.2508 121.43 49.5671 121.471 49.2148 121.803C49.6077 121.943 49.8186 121.1 49.8257 120.66Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0252 121.509C51.3506 121.509 51.4418 121.362 51.2988 121.07C51.2176 121.222 50.8689 121.21 51.0252 121.509Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9093 123.251C42.0913 123.576 42.1725 123.027 42.5034 123.113C42.4261 122.91 42.2359 122.889 41.9727 122.985C42.0243 123.119 41.9958 123.203 41.9093 123.251Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0825 121.226C50.179 121.071 50.21 120.883 50.1686 120.705C50.1272 120.527 50.0168 120.372 49.8616 120.275C49.5724 120.543 50.1527 120.772 50.0825 121.226Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9016 120.429C51.991 120.666 52.3703 120.437 52.4597 120.675C52.5819 120.615 52.4854 120.42 52.6421 120.382C52.1598 120.438 52.4953 120.106 51.9016 120.429Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6878 123.391C39.7394 123.525 39.9279 123.44 40.0718 123.426C40.0607 123.226 39.9119 123.248 39.8702 123.097C39.7473 123.157 39.8438 123.353 39.6878 123.391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3496 122.433C44.2071 122.283 44.0842 122.098 43.7914 122.187C43.935 122.337 44.0568 122.522 44.3496 122.433Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3984 118.757C56.3598 118.687 56.297 118.632 56.2214 118.603C56.1458 118.575 56.0625 118.575 55.9867 118.603C55.9899 118.869 56.2089 118.788 56.3984 118.757Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6779 125.071L28.9155 125.015C28.9123 124.749 28.6933 124.829 28.5038 124.861C28.549 124.95 28.6509 124.95 28.6779 125.071Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6217 124.262C31.7385 124.547 32.1869 124.226 31.923 123.941C31.8201 124.047 31.8635 124.243 31.6217 124.262Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3488 123.039C36.3887 123.301 36.783 122.995 36.9707 123.019C36.9308 122.757 36.5365 123.062 36.3488 123.039Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2901 121.087C45.6282 120.927 45.1174 120.86 45.1797 120.612C45.0572 120.671 45.1541 120.867 44.9973 120.905C45.0568 121.027 45.2524 120.93 45.2901 121.087Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6511 125.523C25.8926 125.517 25.6989 124.941 25.4495 125.194L25.5047 125.432C25.6009 125.387 25.6276 125.453 25.6511 125.523V125.523Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0856 124.117L29.8481 124.172C29.9511 124.256 30.0223 124.372 30.0497 124.501C30.299 124.486 30.4158 124.391 30.351 124.181C29.9923 124.516 30.3489 124.126 30.0856 124.117V124.117Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9151 122.782C36.9818 122.713 37.0288 122.627 37.0511 122.534C37.0735 122.441 37.0704 122.343 37.0422 122.251C36.8399 122.328 36.8189 122.519 36.9151 122.782Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3522 118.017C56.4231 117.978 56.4778 117.915 56.5063 117.839C56.5347 117.764 56.535 117.681 56.5072 117.605C56.3073 117.616 56.3291 117.764 56.178 117.806C56.2229 117.897 56.3248 117.897 56.3522 118.017Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1772 124.542C27.2517 124.695 27.4978 124.572 27.6802 124.55C27.5833 124.283 27.2994 124.351 27.1772 124.542Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2797 122.196C37.5868 122.6 37.4154 121.893 37.5811 121.876C37.274 121.473 37.4453 122.179 37.2797 122.196Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0251 119.932C47.2684 119.836 46.9182 119.362 46.6771 119.512C46.6283 119.917 46.9314 119.757 47.0251 119.932Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1219 123.733C30.5582 123.398 29.4291 123.299 30.249 123.203C30.1019 122.742 29.9017 123.376 29.7183 123.075C29.6516 123.144 29.6047 123.23 29.5823 123.323C29.56 123.417 29.563 123.514 29.5911 123.606C29.8544 123.51 30.0446 123.531 30.1219 123.733Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.004 117.596C56.2063 117.519 56.2273 117.329 56.1311 117.066C55.9306 117.143 55.9082 117.333 56.004 117.596Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7868 124.49C25.8937 124.487 25.999 124.463 26.0964 124.419C26.1938 124.375 26.2813 124.312 26.3535 124.233C26.3423 124.206 26.3219 124.183 26.2958 124.17C26.2698 124.157 26.2398 124.153 26.2113 124.159C26.1828 124.166 26.1575 124.183 26.14 124.206C26.1226 124.23 26.114 124.259 26.1159 124.288C25.9995 124.311 25.9898 124.164 25.9418 124.078C25.8509 124.123 25.8509 124.225 25.7316 124.252L25.7868 124.49Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.389 123.276C29.3059 123.379 29.1896 123.45 29.0599 123.477C29.1728 123.797 29.5312 123.632 29.389 123.276Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6324 123.24C30.6388 123.482 31.2141 123.288 30.9612 123.038L30.7236 123.094C30.7688 123.19 30.7033 123.216 30.6324 123.24Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9059 117.726C54.9423 117.559 55.0384 117.411 55.1761 117.31C55.3138 117.209 55.4837 117.161 55.6539 117.176C55.8594 116.759 54.6964 117.522 54.6754 117.278C54.3395 117.48 54.887 117.563 54.9059 117.726Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5917 124.177L26.8296 124.122C26.8264 123.856 26.6073 123.935 26.4178 123.967C26.4627 124.06 26.5642 124.06 26.5917 124.177Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7803 123.901C28.3068 123.696 27.5178 123.205 27.7803 123.901V123.901Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7913 117.805C50.9032 118.146 50.6075 118.232 50.7201 118.573C50.9694 118.516 50.9915 117.494 51.2316 118.079C51.6441 117.74 51.2017 117.464 50.7913 117.805Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0448 121.731C36.3209 121.994 36.6785 121.456 36.5285 121.118C36.4015 121.347 36.2382 121.554 36.0448 121.731Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6592 121.124C38.6206 121.053 38.5577 120.998 38.4821 120.97C38.4065 120.941 38.3232 120.941 38.2474 120.969C38.2506 121.235 38.4697 121.156 38.6592 121.124Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7958 123.988C26.0451 123.973 26.1619 123.877 26.0971 123.668L25.7409 123.75L25.7958 123.988Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0536 116.726C57.1758 116.667 57.0792 116.471 57.2363 116.433C57.0112 115.995 56.68 116.739 56.5596 116.215C56.4928 116.284 56.4459 116.369 56.4235 116.463C56.4011 116.556 56.4042 116.654 56.4324 116.745C56.6924 116.738 56.728 116.591 56.8801 116.516C56.9966 116.492 57.0062 116.64 57.0543 116.726L57.0536 116.726Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.719 123.647L26.9565 123.592C26.8534 123.509 26.7822 123.392 26.7549 123.263C26.5234 123.387 26.5462 123.507 26.7193 123.647H26.719Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.313 123.509C27.2083 123.432 27.0523 123.226 27.23 123.152C26.9401 122.67 26.8702 123.825 27.313 123.509Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7987 117.822C51.3802 117.373 52.1959 117.505 52.4292 117.3C52.1727 117.05 51.5864 117.444 51.3606 117.549C51.5106 117.63 51.497 117.978 51.7987 117.822Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0553 117.297C54.3007 117.302 54.346 116.608 53.9449 116.822C54.1978 117.012 53.9695 116.975 54.0553 117.297Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8391 117.455C53.0806 117.449 52.8869 116.873 52.6375 117.126L52.6927 117.364C52.7886 117.318 52.8156 117.384 52.8391 117.455Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0368 118.909C46.1255 118.812 46.2149 118.716 46.2744 118.854C46.3813 118.854 46.3756 118.783 46.3656 118.708L46.3104 118.47L45.9542 118.553L46.0368 118.909Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0946 118.627C45.4101 118.366 44.8833 118.114 44.6276 118.235C44.5578 118.727 45.1644 118.134 45.0946 118.627Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4154 117.266C50.4218 117.508 50.9971 117.314 50.7445 117.064L50.507 117.119C50.5522 117.215 50.4867 117.242 50.4158 117.266L50.4154 117.266Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2505 117.124C46.7824 116.906 46.9025 117.92 46.1723 117.876C46.3803 117.923 46.4373 118.212 46.7304 118.122C46.8584 117.768 47.0332 117.432 47.2501 117.125L47.2505 117.124Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7935 117.285C49.719 117.132 49.4729 117.256 49.2905 117.277C49.3878 117.544 49.6713 117.476 49.7935 117.285Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4077 116.678C52.2464 116.513 52.0269 116.478 51.9048 116.669C52.002 116.937 52.2855 116.869 52.4077 116.678Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1468 120.562C35.1984 120.696 35.3869 120.612 35.5308 120.597L35.4203 120.122C35.2857 120.174 35.3705 120.362 35.3847 120.506L35.1468 120.562Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.005 117.684C47.0716 117.848 47.3694 117.643 47.4167 117.838C47.5389 117.779 47.4424 117.583 47.5991 117.546C47.4175 117.22 47.233 117.704 47.005 117.684Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6621 117.279C47.9994 117.208 47.7401 116.618 47.4053 116.713C47.677 116.871 47.3454 117.092 47.6621 117.279Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1062 119.838C36.2284 119.779 36.1318 119.583 36.2886 119.545C36.2886 119.438 36.2173 119.444 36.1422 119.454L35.9046 119.509C35.9156 119.709 36.0642 119.687 36.1062 119.838Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7002 119.7C36.9 119.689 36.8783 119.541 37.0293 119.498C37.0229 119.257 36.4462 119.451 36.7002 119.7Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0529 115.669C54.4618 115.426 53.8459 115.175 54.1241 114.901C53.6105 114.679 53.9542 115.215 54.0529 115.669Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6896 115.164C56.1996 115.109 56.2281 114.754 56.5576 114.587C56.3332 114.314 56.2253 114.271 55.9083 114.487C56.6584 114.89 55.5635 114.585 55.6896 115.164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4724 114.75C57.7385 114.611 57.5472 114.187 58.1028 114.228C58.4947 113.937 57.6284 114.366 57.7823 113.926C57.6284 113.987 57.6754 114.471 57.5447 113.982C57.4887 114.027 57.4424 114.083 57.4084 114.146C57.3744 114.21 57.3535 114.279 57.3468 114.351C57.3402 114.422 57.348 114.495 57.3697 114.563C57.3915 114.632 57.4267 114.695 57.4734 114.75H57.4724Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0638 116.309C48.2953 116.185 48.2725 116.065 48.0994 115.925L47.8618 115.98C47.8729 116.18 48.0228 116.159 48.0638 116.309Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0841 114.177C55.0905 114.419 55.6657 114.225 55.4128 113.975L55.1753 114.031C55.2208 114.127 55.1549 114.154 55.0841 114.177Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8267 115.273C50.4087 115.255 49.9083 114.67 49.8267 115.273V115.273Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2557 114.422C50.7946 114.734 50.7836 113.958 50.2557 114.422V114.422Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4318 112.97C55.6548 113.173 55.814 112.758 56.1724 112.923L56.0619 112.448C55.8404 112.604 55.5519 112.673 55.7966 112.384C55.6854 111.966 55.4625 112.728 55.4126 112.348C55.1415 112.45 55.4728 112.928 55.0475 112.934C55.2755 113.26 55.5073 112.761 55.4678 112.586C55.7617 112.532 55.5843 112.973 55.4322 112.97L55.4318 112.97Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0947 113.154C54.515 113.336 54.6468 113.125 54.2771 112.861C54.1549 112.921 54.2514 113.116 54.0947 113.154Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.688 112.445C57.5156 112.177 57.4219 111.784 57.0468 111.842C56.9428 112.271 57.2588 112.447 57.688 112.445Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7807 112.87C54.864 112.767 54.9802 112.696 55.1099 112.668C54.9929 112.606 54.8648 112.568 54.7329 112.555C54.601 112.543 54.4679 112.557 54.3416 112.597C54.4064 112.818 54.7547 112.588 54.7807 112.87Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8706 112.152C58.0056 112.101 57.9205 111.912 57.9062 111.768L57.55 111.851C57.6284 111.997 57.8026 111.989 57.8706 112.152Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4452 111.392C58.0398 111.343 58.1998 111.646 58.0249 111.74C58.1207 111.984 58.5948 111.633 58.4452 111.392Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1183 112.165C55.5048 112.169 55.2708 111.786 55.6572 111.789C55.5094 111.544 54.9662 111.889 55.1183 112.165Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8521 112.102C54.8225 111.714 54.2864 112.139 54.1753 111.883C53.8636 112.184 54.5974 112.169 54.8521 112.102Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5821 112.592C50.85 112.943 50.8706 112.312 51.0024 112.244C50.6751 111.98 50.5714 112.543 50.5821 112.592Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6038 111.032C54.8453 111.026 54.6515 110.45 54.4022 110.703L54.4574 110.94C54.5536 110.895 54.5803 110.961 54.6038 111.032Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2028 128.785C46.7611 128.899 46.8951 128.998 46.4904 128.95C46.5919 129.168 46.9731 128.938 46.9574 129.342C47.0044 129.134 47.2933 129.077 47.2035 128.784L47.2028 128.785Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7885 130.328C37.0753 130.439 37.2769 130.234 37.6206 130.135C37.5465 129.983 37.3 130.106 37.1177 130.127C37.0724 130.031 37.138 130.004 37.2088 129.98C37.0265 129.683 37.0062 130.314 36.7885 130.328Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6611 126.961C49.6095 126.827 49.4211 126.911 49.2768 126.926C49.1065 127.573 49.2219 127.17 49.6611 126.961Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3608 127.853C46.5353 127.578 46.6564 127.771 46.9549 127.715C47.0215 127.266 45.9932 127.755 46.369 127.35C46.063 127.162 46.2361 127.55 46.3604 127.853L46.3608 127.853Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4748 126.717C47.1054 126.715 47.5218 127.85 47.4748 126.717V126.717Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2452 129.595C37.4632 129.508 36.9214 128.931 36.8057 129.321C36.8712 129.542 37.2178 129.312 37.2452 129.595Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4672 127.792C44.5797 127.051 43.9973 127.329 44.4672 127.792V127.792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6154 126.792C47.357 126.905 47.0777 126.324 46.6154 126.792V126.792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3922 126.361C47.4303 126.408 47.4785 126.445 47.5333 126.47C47.588 126.495 47.6478 126.507 47.708 126.505C47.7681 126.503 47.827 126.488 47.8801 126.459C47.9332 126.431 47.9791 126.391 48.0142 126.342C47.8663 126.375 47.5999 126.125 47.3922 126.361Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1409 125.811C47.894 126.103 48.3414 125.778 48.4971 125.729C48.4342 125.644 48.3894 125.548 48.3656 125.446C48.3418 125.344 48.3395 125.238 48.3589 125.134C48.2502 125.304 47.9699 125.366 47.6732 125.419C47.8089 125.826 48.4657 125.207 48.1409 125.811Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5694 124.96C48.6478 125.106 48.8219 125.098 48.89 125.261C49.0549 125.194 48.849 124.897 49.0449 124.849C48.9448 124.55 48.8771 125.06 48.5694 124.96Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.543 125.413C45.5398 124.728 44.7857 125.611 45.543 125.413V125.413Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8157 124.402C49.1829 124.784 49.065 124.026 49.501 124.117C49.4711 124.002 49.3343 124.059 49.2356 124.053C49.2915 123.933 49.3041 123.798 49.2712 123.669C49.1804 123.714 49.1804 123.816 49.0611 123.844C48.9417 123.871 48.935 123.72 48.8869 123.633C48.8202 123.702 48.7732 123.788 48.7508 123.881C48.7285 123.975 48.7315 124.072 48.7597 124.164C49.149 123.764 49.2773 124.316 48.8149 124.402H48.8157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8438 122.858C53.0911 122.813 53.5862 123.425 53.8438 122.858V122.858Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9105 125.969L40.1481 125.914C40.1028 125.818 40.1684 125.791 40.2393 125.768C39.68 125.554 39.9454 125.7 40.0099 125.32L39.6537 125.403L39.7363 125.759L39.4984 125.814C39.5094 125.841 39.5298 125.864 39.5559 125.877C39.5821 125.891 39.6123 125.895 39.641 125.888C39.6697 125.882 39.6951 125.865 39.7126 125.841C39.7301 125.817 39.7385 125.788 39.7363 125.759C39.8528 125.736 39.8624 125.883 39.9105 125.969Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4319 122.703L53.7881 122.621C53.7607 122.338 53.4141 122.568 53.3485 122.347C53.1843 122.44 53.4308 122.49 53.4315 122.703H53.4319Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8442 121.767C55.8271 121.602 55.1849 121.67 55.5237 121.466C55.4934 121.351 55.357 121.408 55.2583 121.402C55.3035 121.498 55.238 121.525 55.1671 121.549C55.3776 121.646 55.5376 121.824 55.8439 121.767H55.8442Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1623 123.194C49.245 122.379 48.5685 122.979 49.1623 123.194V123.194Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9995 127.52C30.2728 127.422 29.7894 127.235 29.7702 127.072C29.4325 127.273 29.98 127.357 29.9995 127.52Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6656 122.112C52.576 122.551 53.2254 121.827 51.6656 122.112V122.112Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7595 124.77C41.0123 124.641 40.5721 124.618 40.7951 124.386C41.0444 124.365 41.1028 124.654 41.3532 124.632C41.5516 124.408 40.7032 124.49 40.7121 124.03C40.685 124.041 40.6628 124.061 40.6494 124.087C40.6359 124.113 40.6322 124.143 40.6389 124.172C40.6455 124.2 40.662 124.226 40.6856 124.243C40.7091 124.261 40.738 124.269 40.7673 124.267C40.6547 124.461 40.4649 124.583 40.7595 124.77Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3948 124.265C42.5148 124.55 42.7079 124.072 42.5497 123.853C42.191 123.833 42.2808 124.092 41.983 124.11C42.1668 124.43 42.1921 124.202 42.486 124.118C42.5312 124.214 42.4657 124.241 42.3948 124.265Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6014 126.879C30.4966 126.716 30.4503 126.766 30.2534 126.459C29.9908 126.498 30.2975 126.893 30.2726 127.081C30.4585 127.027 30.7392 127.033 30.7203 126.851C30.8536 126.67 30.7203 126.802 30.6014 126.879Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9076 124.341C39.6978 124.406 39.6226 124.254 39.4046 124.333C39.7174 124.533 39.95 124.672 40.1455 124.286C40.1343 124.259 40.1139 124.237 40.0878 124.223C40.0618 124.21 40.0318 124.206 40.0033 124.213C39.9747 124.22 39.9495 124.236 39.932 124.26C39.9146 124.283 39.906 124.312 39.9079 124.341H39.9076Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7711 124.318C36.6954 124.347 36.6118 124.347 36.536 124.319C36.4602 124.29 36.3974 124.235 36.3594 124.163C36.2835 123.83 36.7512 124.371 36.5417 123.87C36.3252 123.906 36.3248 124.074 36.094 124.1C36.5289 124.354 36.0085 125.185 36.6995 125.087C36.2557 124.712 36.7519 124.072 36.9457 124.529C37.0988 124.386 37.0287 124.106 37.0454 123.879C36.9706 123.928 36.9074 123.993 36.8601 124.069C36.8128 124.145 36.7826 124.23 36.7715 124.318H36.7711Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8888 125.382C35.3073 125.439 34.8888 124.976 35.3091 125.034C35.2129 124.791 34.7395 125.139 34.8888 125.382Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.866 123.046C43.9956 122.993 43.9044 122.912 43.8382 122.927C43.7869 122.794 43.8154 122.71 43.9019 122.662C43.8482 122.532 43.7673 122.624 43.783 122.69C43.6872 122.735 43.6601 122.669 43.6366 122.599C43.5069 122.653 43.5985 122.733 43.6644 122.718C43.6879 122.834 43.5404 122.844 43.4542 122.892C43.5208 123.057 43.8186 122.85 43.866 123.047V123.046Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.151 120.407C54.5428 120.752 54.858 119.854 54.4883 119.702C54.3537 119.781 54.6799 120.324 54.151 120.407Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1341 124.824C35.1812 124.616 35.47 124.558 35.3803 124.266C35.2303 124.409 35.0451 124.531 35.1341 124.824Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3729 123.106C40.4266 123.235 40.5075 123.145 40.4918 123.078C40.7497 123.577 41.7645 122.868 41.3321 122.382C41.2555 122.487 41.0493 122.643 40.9759 122.465C40.6909 122.585 41.169 122.778 41.3877 122.619C41.3877 122.756 41.17 122.755 41.2053 122.913C40.8014 123.11 40.5681 122.778 40.3732 123.106H40.3729Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9071 120.445C53.2331 120.739 53.0079 119.84 53.5376 119.923C53.1572 119.595 53.0371 120.281 52.9071 120.445Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3624 120.804C51.7899 120.833 51.4615 120.391 51.4622 120.154C51.2958 120.204 51.1302 120.252 51.0779 120.119C50.8666 120.376 51.6243 120.328 51.3624 120.804Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9342 125.066C32.2786 125.077 32.1187 124.774 32.3545 124.718C32.2594 124.645 31.807 124.614 31.9342 125.066Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2741 122.665C42.5298 122.227 41.8235 122.736 41.7437 122.537C41.4331 122.941 42.3115 122.538 42.2741 122.665Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4349 122.27C43.3148 122.214 43.1792 122.201 43.0509 122.234C43.2415 122.629 43.4986 122.275 43.645 122.096C43.5642 121.939 43.4334 122.134 43.4349 122.27Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1056 124.739C29.0676 125.003 30.8654 125.44 30.1056 124.739V124.739Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4397 120.052C52.6178 119.967 52.2872 119.867 52.5034 119.787C52.4169 119.496 52.0927 119.846 52.0279 119.898C52.0945 120.062 52.3923 119.857 52.4397 120.052Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5794 119.556C54.8362 119.342 54.143 119.293 54.0846 119.044C53.8638 119.204 54.4483 119.424 54.5794 119.556Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2921 119.39C55.6508 119.082 54.9779 118.72 55.6298 118.685C55.9824 118.459 55.2793 118.625 55.1265 118.677C55.4114 118.204 54.7279 118.773 55.0438 118.321C54.8429 117.983 54.6556 118.467 54.5961 118.55C54.6574 118.704 55.1411 118.657 54.6513 118.788C55.0748 118.92 55.3954 118.73 55.2921 119.39Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.377 125.391C28.155 125.203 27.8462 125.156 27.7358 124.789C27.5285 125.028 28.0325 125.498 28.377 125.391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8365 123.533C35.703 123.585 35.6189 123.556 35.5712 123.47C35.1705 123.811 36.1055 123.744 35.9274 123.387C35.8205 123.219 35.8016 123.408 35.8362 123.533L35.8365 123.533Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6872 120.066C49.5091 120.208 50.2856 120.18 50.4833 120.256C50.1984 119.999 50.4331 119.875 50.7847 119.936L50.619 119.223C50.0983 119.938 50.3102 119.628 49.6872 120.066V120.066Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9832 121.391C43.7912 121.481 43.7374 121.35 43.6904 121.209C43.6073 121.312 43.491 121.383 43.3613 121.41C43.4681 121.513 43.663 121.47 43.6819 121.712L44.1574 121.601C44.1574 121.495 44.0861 121.5 44.011 121.51C44.0391 121.392 44.0662 121.273 44.1934 121.217C44.1396 121.087 44.0587 121.179 44.0744 121.245C43.9786 121.29 43.9515 121.225 43.928 121.154C43.7674 121.246 43.9636 121.255 43.9832 121.391V121.391Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0019 120.35C49.3581 120.522 48.7782 120.006 48.7451 119.783C48.5802 119.85 48.7861 120.148 48.5901 120.195C48.6443 120.325 48.7248 120.234 48.7091 120.167C48.8274 120.195 48.946 120.222 49.0023 120.35H49.0019Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.243 124.243C32.3262 124.14 32.4423 124.068 32.5718 124.041C32.4257 123.578 32.1899 124.27 32.1326 123.767C31.7953 123.928 32.3057 123.995 32.243 124.243Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0177 120.435C47.1153 120.524 47.2107 120.613 47.0729 120.673C47.4038 121.001 47.2599 120.189 47.438 120.087C47.3016 119.818 47.2809 120.449 47.0177 120.435Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0899 123.563C34.1675 123.461 34.0639 122.753 34.3638 123.124C34.6925 122.977 34.1383 122.981 34.1622 122.795C33.9784 122.952 34.0414 123.262 33.9438 123.472C33.8631 123.468 33.7863 123.436 33.7275 123.381C33.6686 123.325 33.6316 123.251 33.6232 123.17C33.5011 123.23 33.5976 123.425 33.4409 123.463C33.5823 123.617 33.863 123.546 34.0899 123.563Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4724 120.794L45.8286 120.712C45.5337 120.695 45.5298 120.213 45.2153 120.228C45.2231 120.03 45.5654 120.039 45.3424 119.697C44.9214 120.186 45.3104 120.153 45.4721 120.795L45.4724 120.794Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1657 117.773C54.2673 117.991 54.6484 117.76 54.6327 118.165C55.0067 117.646 55.3512 118.219 55.5752 118.447C55.8463 118.158 55.1271 118.091 55.2354 117.524C55.0623 117.943 54.6349 117.736 54.1657 117.773Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7626 118.206C52.1751 118.206 51.2685 118.15 51.2596 118.198C50.8767 118.475 51.5254 118.763 50.9223 118.902L51.0327 119.378C51.2258 118.849 51.5396 119.021 51.8456 118.563C51.644 118.225 51.5606 118.773 51.3978 118.792C51.3788 118.73 51.3734 118.664 51.3819 118.599C51.3905 118.534 51.4128 118.472 51.4473 118.416C51.4819 118.361 51.528 118.313 51.5824 118.277C51.6368 118.241 51.6984 118.217 51.7629 118.206H51.7626Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1702 118.881C53.2999 118.827 53.2087 118.746 53.1424 118.762C53.1292 118.619 53.3358 118.611 53.4712 118.56C53.1991 118.402 53.5321 118.18 53.2144 117.993C53.1909 117.877 53.3383 117.868 53.4245 117.819C53.338 117.528 53.0142 117.878 52.949 117.93C53.0277 118.002 53.091 118.089 53.1352 118.187C53.1793 118.284 53.2033 118.389 53.2058 118.496C52.996 118.561 52.9209 118.409 52.7029 118.488C52.6872 118.894 53.1324 118.559 53.1698 118.88L53.1702 118.881Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7747 121.045C42.6375 121.615 43.1953 120.697 42.7195 120.807C42.5229 120.854 42.7978 120.948 42.7747 121.045Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8783 119.27C49.9018 119.386 49.7543 119.395 49.6681 119.443C49.708 119.706 50.102 119.399 50.29 119.424C50.2626 119.142 49.916 119.372 49.8509 119.151C49.7212 119.204 49.8124 119.285 49.8786 119.27H49.8783Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2995 122.332C31.1685 122.261 31.058 122.158 30.979 122.031C31.0584 122.417 30.6007 122.288 30.5515 122.882C30.4735 122.699 31.1927 122.721 31.1456 122.744C31.2799 122.68 31.4972 122.005 31.8313 122.459C31.5713 122.865 32.1402 123.314 31.5492 123.402C31.7679 123.961 32.1084 122.819 32.4365 123.446C32.7738 123.245 32.2263 123.161 32.2071 122.999C32.4821 122.884 32.5159 123.156 32.829 122.979C32.7147 122.739 32.9462 122.714 33.1304 122.659",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7299 118.036C55.8634 117.739 55.691 117.579 55.4449 117.35C55.2639 117.395 55.6351 117.897 55.7299 118.036Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9324 124.01C29.045 124.259 29.4051 123.663 29.0873 123.598C28.9224 123.664 29.1283 123.962 28.9324 124.01Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5503 120.042C46.7708 120.028 46.4506 119.579 46.2298 119.741C46.2258 120.02 46.4962 119.856 46.5503 120.042Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4453 119.013C50.6466 119.35 50.7303 118.803 50.8931 118.784C50.7951 118.51 50.6078 118.994 50.4453 119.013Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6246 122.079C35.5099 122.11 35.5661 122.246 35.5608 122.345C35.2534 122.039 34.9222 122.296 34.7013 122.419C34.988 122.332 36.0249 122.608 35.6246 122.079Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6623 117.765C53.4546 117.58 53.6697 118.144 53.7727 118.24C53.9818 118.218 54.0334 117.966 54.1289 118.157C54.3173 117.746 53.7955 118.052 53.6623 117.765Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7832 120.541C42.8495 120.767 43.149 120.31 43.4956 120.376C43.3357 119.982 43.0208 120.414 42.7832 120.541Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9116 118.92C45.4409 118.703 45.1823 119.335 45.3785 119.312C45.7931 119.302 45.5128 119.021 45.4141 118.927C45.817 118.825 45.9381 119.174 46.1465 119.384C45.8423 119.465 46.1397 119.921 45.635 119.878C45.3706 119.576 45.1287 119.256 44.9112 118.919L44.9116 118.92ZM45.6079 119.76L45.8455 119.705C45.8003 119.609 45.8658 119.582 45.9367 119.558C45.8594 119.356 45.6692 119.335 45.406 119.431C45.5091 119.514 45.5803 119.631 45.6076 119.76L45.6079 119.76Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2432 118.684C50.7084 119 50.3501 118.069 50.1054 118.09C49.9828 117.727 50.5189 118.312 50.4341 117.888C50.8277 117.698 49.694 118.102 50.1135 117.587C49.7217 117.22 50.0138 118.125 49.7484 118.173C49.9825 118.231 50.4131 118.366 49.9778 118.62C50.1143 118.812 50.198 118.587 50.334 118.538C50.3793 118.634 50.3137 118.661 50.2428 118.684L50.2432 118.684Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2002 123.553C28.1703 123.947 28.65 123.087 29.0322 123.36C28.7996 123.217 28.8509 122.731 28.9578 122.5C29.2428 122.505 28.8566 122.719 29.1594 122.829C29.4401 122.767 29.4618 122.544 29.8447 122.544C29.2445 122.511 29.2652 122.181 28.5735 122.464C29.1583 122.973 28.4563 123.289 28.146 123.315C28.2059 123.47 28.6899 123.422 28.2002 123.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2833 122.248C33.0803 122.403 33.428 122.289 33.4575 122.458L33.2833 122.248Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7855 121.684C36.9002 121.655 36.8439 121.518 36.8493 121.419C36.9508 121.419 36.9953 121.511 37.1146 121.483C37.2831 121.376 37.0933 121.357 36.9682 121.392C36.9169 121.258 36.9454 121.174 37.032 121.126C36.7388 120.79 36.7784 121.499 36.7855 121.684Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3358 119.108C47.2332 118.947 47.0903 118.85 46.9878 118.688C47.22 118.233 47.5256 118.911 47.8198 118.495C47.7151 118.418 47.5591 118.212 47.7368 118.139C47.3507 117.984 46.1852 118.738 47.3358 119.108Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3613 123.158C29.5227 123.055 29.6199 122.913 29.7816 122.81C29.8041 122.641 29.18 122.895 29.3613 123.158Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1211 119.837C43.567 120.269 43.1328 119.314 43.3672 119.279L43.1211 119.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5958 119.727C43.7778 120.024 43.7985 119.393 44.0161 119.379C44.0161 119.272 43.9449 119.277 43.8697 119.287L43.6321 119.343C43.6816 119.509 43.7301 119.675 43.5965 119.727L43.5958 119.727Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2185 119.707C44.5747 119.659 44.5494 119.128 44.8126 119.569C45.2457 119.07 44.341 119.362 44.2267 119.204C44.0714 119.35 44.3008 119.375 44.2185 119.707Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1377 122.728C30.6973 122.771 30.2342 121.918 30.7126 121.968C30.7126 121.861 30.6414 121.866 30.5662 121.877C30.5427 121.76 30.6902 121.751 30.7764 121.703C30.7019 121.55 30.4558 121.673 30.2734 121.694C30.3365 122.255 30.4084 122.296 30.1377 122.727V122.728Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.648 117.159C54.7777 117.106 54.6865 117.025 54.6206 117.041C54.7791 116.364 54.9554 115.765 54.3916 116.593C54.394 116.699 54.418 116.805 54.4621 116.902C54.5062 116.999 54.5694 117.087 54.648 117.159Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0974 116.93C54.7979 117.307 55.4084 116.72 55.3628 116.994C55.6652 116.811 54.9738 116.575 55.6367 116.554C55.4999 116.339 55.2449 116.311 54.96 116.336C55.0568 116.543 55.2421 116.694 55.0978 116.93L55.0974 116.93Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9985 123.225C27.9985 123.118 27.9273 123.123 27.8521 123.133C27.6943 123.142 27.6138 122.815 27.7691 122.777C27.3613 122.369 27.5472 123.579 27.9985 123.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3645 118.136C49.1173 118.428 49.565 118.103 49.7207 118.053C49.3453 117.47 49.6527 117.938 49.3645 118.136Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8884 122.749C27.9814 122.913 28.0309 122.667 28.2446 122.666C27.9643 122.606 27.6598 122.156 27.4489 122.475C27.4927 122.646 28.2382 122.482 27.8884 122.749Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3934 117.164C51.2752 117.136 51.1565 117.109 51.1006 116.982C50.8093 117.068 51.1594 117.392 51.211 117.457C51.4468 117.4 51.2869 117.098 51.6313 117.109C51.6202 117.082 51.5997 117.06 51.5737 117.046C51.5476 117.033 51.5177 117.029 51.4891 117.036C51.4606 117.042 51.4353 117.059 51.4179 117.083C51.4004 117.106 51.3919 117.135 51.3938 117.164H51.3934Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5953 115.831C56.4885 116.02 56.5925 116.029 56.678 116.188C56.8002 116.128 56.7036 115.932 56.8604 115.895C56.8012 115.772 56.6053 115.869 56.5676 115.712C56.4383 115.765 56.5295 115.846 56.5953 115.831Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0074 115.985C57.0939 116.277 57.4177 115.927 57.4829 115.875C57.4313 115.74 57.2428 115.825 57.0989 115.839C57.0537 115.743 57.1192 115.717 57.1901 115.693C56.8699 115.427 57.1492 115.988 57.0074 115.985Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5246 122.243C29.6543 122.189 29.5628 122.108 29.4972 122.124C29.8648 121.518 29.7377 122.07 30.1191 122.105C30.0899 121.661 29.8474 121.562 29.6881 121.328C29.2995 121.52 29.135 121.221 28.9757 121.493C29.0274 121.954 29.3398 121.997 29.5257 122.241L29.5246 122.243Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1525 120.579C36.2476 120.821 36.5361 120.358 36.426 120.139C35.9608 120.053 36.4481 120.56 36.1525 120.579Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2629 118.821C44.3975 118.769 44.3127 118.58 44.2985 118.436L44.2629 118.821Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4348 116.225C56.415 115.94 55.6485 115.468 56.394 115.502C56.3983 115.223 56.1279 115.385 56.0734 115.2C55.9185 115.799 55.428 115.557 55.4348 116.225Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1087 118.141C46.3606 118.452 46.1358 117.844 45.8434 118.077C45.7981 117.981 45.8637 117.954 45.9346 117.931C45.9043 117.816 45.7675 117.872 45.6692 117.867C45.7144 117.963 45.6489 117.99 45.578 118.013C45.6553 118.216 45.8455 118.237 46.1087 118.14V118.141Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5131 115.56C47.2777 114.922 46.8036 116.028 47.0568 116.292C46.7936 116.389 46.6034 116.367 46.5261 116.165C46.6686 116.363 46.5749 116.723 46.5368 117.29L46.893 117.207C46.8574 116.991 46.6892 116.99 46.6636 116.76C46.6917 116.642 46.7188 116.523 46.846 116.467C47.0223 116.47 46.9048 116.674 46.7822 116.732C47.044 117.049 47.0764 116.385 47.174 116.265C47.3144 116.366 47.6211 116.2 47.6132 116.539C47.7821 116.373 47.6253 116.005 47.6845 115.771C47.6136 115.81 47.559 115.872 47.5305 115.948C47.5021 116.024 47.5017 116.107 47.5295 116.183C47.428 116.183 47.3835 116.091 47.2641 116.119C47.3838 115.855 47.4066 115.531 47.8668 115.478C47.804 115.394 47.7593 115.298 47.7355 115.195C47.7118 115.093 47.7096 114.987 47.729 114.884C48.3274 115.342 48.2024 114.286 48.9176 114.608C48.9411 114.724 48.7936 114.734 48.7075 114.782C48.7075 114.889 48.7787 114.883 48.8538 114.873L49.0914 114.818C49.1356 114.312 48.6437 114.666 48.6882 114.16C48.5853 114.267 48.6287 114.462 48.3869 114.481C48.2779 114.175 48.565 114.117 48.7787 114.014",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2431 114.388C48.2718 114.464 48.2718 114.548 48.2433 114.624C48.2148 114.699 48.1596 114.762 48.0882 114.8",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8777 121.624C27.9429 121.846 28.2898 121.615 28.3172 121.898C28.5456 121.834 27.9486 121.447 28.5908 121.458C28.4558 121.809 28.879 121.877 28.4633 121.989C28.5944 122.395 28.7839 121.904 28.875 122.144C28.9141 121.853 28.8455 121.557 28.682 121.312",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9686 114.256C50.7549 114.494 51.4673 114.178 51.198 114.704C50.8824 114.616 50.9804 114.771 50.5761 114.723C50.6792 114.806 50.7504 114.922 50.7777 115.052C51.2294 114.72 51.5988 114.34 52.085 114.748C51.9941 115.14 51.5863 114.699 51.2529 114.942C51.3505 115.03 51.4459 115.12 51.3081 115.179C51.4545 115.508 51.4506 114.954 51.6372 114.978C51.8645 114.935 51.7266 115.493 51.3637 115.417C51.5923 115.56 51.9286 115.959 52.1594 115.608C52.0525 115.505 51.8577 115.548 51.8388 115.307C51.8923 115.374 52.5441 114.622 52.6709 115.113C52.5163 114.551 51.6312 114.221 50.9686 114.256V114.256Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5034 112.773C52.5269 112.889 52.3794 112.899 52.2932 112.947C52.1507 112.96 52.1425 112.754 52.0916 112.618C52.0004 112.663 52.0008 112.765 51.8814 112.792",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3076 112.46C53.1552 112.379 53.1687 112.03 52.8681 112.187C52.8599 112.029 53.1865 111.949 53.2243 112.104",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4505 112.015C51.5195 112.082 51.6051 112.129 51.6985 112.151C51.7918 112.173 51.8895 112.17 51.9812 112.142C51.9812 112.244 51.8897 112.288 51.9175 112.407C51.4223 111.879 51.8085 112.886 51.8729 113.295C51.9951 113.235 51.8986 113.04 52.0553 113.002C52.5565 113.322 51.4074 113.665 52.3403 113.688C52.3403 113.789 52.2484 113.834 52.2765 113.953C52.1025 113.846 51.9451 113.714 51.8095 113.561C51.7911 113.782 51.8547 114.002 51.9882 114.179C52.1217 114.356 52.3158 114.477 52.5333 114.52C52.2302 114.298 52.5216 114.231 52.6523 114.493C52.861 114.498 52.5387 114.052 52.4229 114.045C52.4339 113.856 52.586 114.057 52.7791 113.962C52.6815 113.873 52.586 113.784 52.7239 113.725C52.6313 113.564 52.6224 113.76 52.4863 113.78C52.5387 113.271 53.4099 112.481 52.658 112.362",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7309 116.459C51.3177 116.413 51.7665 116.093 52.0322 116.139C51.8028 116.072 51.6849 115.825 51.5378 115.627C51.4769 116.011 51.6874 116.344 50.9904 116.506C51.0206 116.62 51.1571 116.564 51.2557 116.57C51.1999 116.69 51.1874 116.825 51.2201 116.953C51.444 116.797 51.6549 116.622 51.8506 116.431C51.7964 116.302 51.7159 116.393 51.7316 116.459H51.7309Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8764 115.979C54.9281 116.114 55.1165 116.029 55.2608 116.015C55.2113 115.849 55.1628 115.683 55.2964 115.631C55.0278 115.28 55.2487 116.061 54.8761 115.979L54.8764 115.979Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1275 121.602C30.2422 121.471 30.4022 121.389 30.5752 121.372C30.4512 121.141 30.3312 121.164 30.1909 121.337C30.1622 121.261 30.1621 121.177 30.1907 121.102C30.2192 121.026 30.2743 120.963 30.3458 120.925C30.2094 120.733 30.1257 120.958 29.9896 121.008",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5394 120.095C35.7392 120.084 35.7175 119.935 35.8682 119.894C35.814 119.764 35.7335 119.855 35.7492 119.921",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7553 116.041C50.0612 116.414 49.7439 116.352 49.8019 116.782C50.5236 116.439 49.5597 115.881 50.6147 115.967C50.4826 115.885 50.3275 115.848 50.1726 115.862C50.0178 115.875 49.8714 115.938 49.7553 116.042V116.041Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9053 115.007C56.957 115.142 57.1454 115.057 57.2893 115.043C57.3488 114.709 56.7411 114.526 57.2701 114.421C57.248 114.212 56.9958 114.16 57.1874 114.065C56.6556 113.879 57.3249 114.978 56.9053 115.007V115.007Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4468 114.111C56.3446 114.325 57.4299 113.618 57.6355 113.835C57.8884 113.724 57.582 113.183 57.4698 113.123C57.1272 113.113 57.6835 113.663 57.3427 113.653C57.0766 113.7 57.1749 113.161 57.0577 112.968C56.657 113.167 57.1115 113.264 57.1044 113.709C56.7724 113.731 56.392 113.404 56.1259 113.81C56.2171 114.052 56.4034 113.564 56.6289 113.819C56.6299 113.954 56.4119 113.954 56.4468 114.111Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.036 112.865C57.6955 112.977 57.6086 112.682 57.2677 112.794C57.584 113.506 57.957 113.157 58.3926 112.783C58.3317 112.63 57.8476 112.677 58.3374 112.545C58.2684 112.479 58.1827 112.432 58.0894 112.409C57.996 112.387 57.8984 112.39 57.8066 112.418C57.8366 112.533 57.9737 112.477 58.072 112.482C58.0163 112.602 58.0037 112.738 58.0364 112.866L58.036 112.865Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2411 122.129C26.4612 122.114 26.4591 121.96 26.3323 121.983L26.2411 122.129Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1586 115.037C55.4696 115.251 55.7018 114.447 55.2584 114.387C55.0806 114.458 55.4315 114.813 55.1586 115.037Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4455 115.203C54.935 115.27 54.598 114.823 54.9848 114.827C54.5018 114.217 55.081 114.12 55.2117 113.647C55.491 113.579 55.6092 113.77 55.9523 113.6C55.7161 113.249 56.3159 113.42 56.0794 113.069C55.6605 113.079 55.7467 113.404 55.5679 113.564C55.283 113.531 55.174 113.217 54.9546 113.08C54.7052 113.375 55.1608 113.472 55.0012 113.821C54.9301 113.952 54.8263 114.062 54.6999 114.141C54.5079 114.232 54.4541 114.101 54.4071 113.959C54.2135 114.145 54.0937 114.395 54.0698 114.663C54.4755 114.713 54.3152 114.409 54.4901 114.315C54.4901 114.422 54.5613 114.416 54.6365 114.406C54.5654 114.537 54.4616 114.648 54.3351 114.727C54.385 115.107 54.6083 114.345 54.7195 114.762C54.8327 115.036 54.1627 114.822 54.4455 115.202V115.203Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4157 119.015C36.4393 119.131 36.2918 119.14 36.2056 119.189C36.3171 119.441 36.8578 119.135 36.918 119.023C36.8149 118.94 36.7437 118.823 36.7164 118.694C36.623 118.771 36.5279 118.848 36.534 118.987C36.3645 118.876 36.222 119.01 36.415 119.015H36.4157Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9517 116.925C46.2117 116.917 46.2473 116.77 46.3994 116.696C46.3453 116.566 46.2648 116.657 46.2804 116.723C46.251 116.726 46.2218 116.717 46.1981 116.7C46.1743 116.682 46.1576 116.657 46.151 116.628C46.1443 116.599 46.1481 116.569 46.1617 116.543C46.1753 116.517 46.1979 116.497 46.2252 116.486",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7271 115.923C49.6604 115.758 49.3627 115.964 49.3153 115.768C49.0674 115.88 49.6608 116.24 49.7271 115.923Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7913 115.657C49.9822 115.786 50.0445 115.632 50.3857 115.519C50.3419 115.337 49.9708 115.204 50.1482 115.574C49.9822 115.568 49.9127 115.409 49.7364 115.42C49.5679 115.526 49.7578 115.545 49.8828 115.511C49.928 115.607 49.8625 115.634 49.7916 115.657H49.7913Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5035 114.921C53.848 114.932 53.688 114.629 53.9238 114.572C53.7675 114.262 53.3771 115.048 53.3657 114.326C53.2588 114.329 53.1535 114.353 53.0562 114.397C52.9588 114.441 52.8713 114.504 52.799 114.583C52.8609 114.728 53.1908 114.656 53.1552 114.5C53.3333 114.541 53.4355 114.703 53.5032 114.92L53.5035 114.921Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4566 115.842C48.5453 115.021 47.8287 115.379 48.4566 115.842V115.842Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5122 114.989C49.9733 114.32 49.6424 114.852 50.5122 114.989V114.989Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0514 112.379C59.3513 112.279 58.8405 112.213 58.941 111.904C58.5666 112.104 58.8989 112.194 59.0514 112.379Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6485 113.955C50.532 113.978 50.5224 113.831 50.4743 113.745C50.1494 113.971 50.6129 114.26 50.9138 114.019C50.8868 113.731 50.9979 113.529 50.8394 113.159C50.7671 113.238 50.6796 113.301 50.5822 113.345C50.4849 113.39 50.3796 113.414 50.2727 113.416C50.3621 113.654 50.807 113.322 50.8308 113.662C50.8027 113.78 50.776 113.899 50.6485 113.955V113.955Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1117 113.811C49.2185 114.115 48.6721 114.011 48.8655 114.369C49.5462 114.216 48.9692 113.903 49.2666 113.399",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2915 114.038C50.2612 113.923 50.1245 113.98 50.0261 113.974C49.9727 113.738 50.3154 113.748 50.1533 113.444C50.0885 113.761 49.4936 113.401 49.7415 113.289C49.7415 113.182 49.6703 113.187 49.5951 113.197L49.3572 113.253C49.7088 113.45 49.7886 114.083 50.2911 114.036L50.2915 114.038Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4063 112.902C51.484 112.487 50.7651 112.967 50.2814 112.913C50.3733 113.331 51.168 112.716 51.4063 112.902Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2117 111.499C54.3507 111.548 54.398 111.744 54.6235 111.654C54.6808 111.235 54.2178 111.654 54.2755 111.234C53.9798 111.295 54.2602 112.12 54.2117 111.499Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3719 141.204C61.3865 140.705 60.5857 141.517 60.6003 141.019C60.0856 141.462 61.2483 141.7 61.3719 141.204Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0181 140.457C63.1503 140.392 63.1499 140.244 63.3237 140.204C63.2582 140.072 63.11 140.073 63.0708 139.899C62.9387 139.964 62.939 140.113 62.7656 140.152C62.8315 140.284 62.9796 140.284 63.0181 140.457Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2789 142.042C52.9521 142.053 52.3815 141.057 52.2108 140.964C51.7959 141.377 52.1546 141.455 52.2789 142.042Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1964 136.473C69.3632 136.284 69.5958 136.164 69.8472 136.139C69.8315 135.822 68.8078 136.056 69.1964 136.473Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.591 137.825C63.1541 137.962 62.9155 136.935 62.4706 137.307L62.591 137.825Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7087 138.362C58.8843 138.042 58.8156 137.244 58.6019 137.113C58.3244 137.523 58.4284 137.944 58.7087 138.362Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7532 139.382C53.2134 139.071 52.4027 138.871 52.1145 138.983C52.1541 139.395 52.6584 139.06 52.7532 139.382Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4048 139.049C53.6445 138.952 53.3453 138.519 53.6299 138.45C53.3061 137.94 53.1754 138.73 53.4048 139.049Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0603 139.561C48.3531 140.051 48.4753 139.256 48.7114 139.228C48.4186 138.737 48.2965 139.533 48.0603 139.561Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9753 138.369C54.3628 138.364 54.2471 138.046 54.2004 137.77C54.0683 137.836 54.0686 137.984 53.8951 138.024L53.9753 138.369Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.584 140.287C42.8237 140.19 42.5245 139.757 42.8091 139.688C42.4853 139.179 42.3549 139.969 42.584 140.287Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5286 138.027C51.9995 137.976 51.1421 137.097 51.8848 137.215C51.4142 136.698 51.2254 137.575 51.5286 138.027Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6544 142.229C33.0163 141.826 32.0157 141.163 33.105 141.032C32.9668 140.638 32.3214 141.108 32.2409 141.233C32.3171 141.664 32.4083 142.071 32.6544 142.229Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2886 136.971C55.7025 136.801 55.1433 136.299 54.8227 136.533C54.9371 136.746 55.1907 136.735 55.2886 136.971Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7508 139.852C40.1113 139.83 40.283 139.691 40.189 139.386L39.6707 139.506L39.7508 139.852Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5116 133.554C64.3079 133.806 64.1334 133.839 63.9531 133.502C63.4687 133.922 64.8835 134.508 64.5116 133.554Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1487 136.376C53.1579 136.727 53.9943 136.448 53.6271 136.083L53.2815 136.163C53.3474 136.303 53.252 136.341 53.149 136.377L53.1487 136.376Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3312 132.768C66.1175 132.881 66.13 133.135 65.8931 133.234C66.0648 133.648 66.567 133.088 66.3312 132.768Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7773 133.129C65.017 133.032 64.7178 132.599 65.0024 132.53C64.7342 132.096 64.5184 132.897 63.9659 132.771C64.2331 133.39 64.5102 132.51 64.7773 133.129Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9551 139.177C38.1948 139.08 37.8956 138.647 38.1802 138.578C37.856 138.068 37.7257 138.859 37.9551 139.177Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1131 137.049C47.537 136.924 47.0276 136.453 46.9525 136.358C46.4613 136.592 47.2036 136.689 47.1131 137.049Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4375 136.892C45.3306 136.354 44.7964 136.499 44.2802 136.615C44.5132 136.954 44.848 137.127 45.4375 136.892Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5701 139.518C32.8793 139.303 33.051 138.77 32.7151 138.574C32.4921 138.779 32.5943 139.187 32.5701 139.518Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1291 134.328C54.1451 134.646 55.1688 134.411 54.7802 133.995C54.465 134.044 54.4646 134.29 54.1291 134.328Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6659 131.466C66.3049 131.48 65.8301 130.833 65.678 130.734C65.4558 130.842 65.6353 131.2 65.6659 131.466Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5332 129.725C63.9277 129.575 64.1873 130.929 63.8821 130.058C63.7614 130.208 63.5925 130.312 63.4041 130.352C63.6972 130.844 64.1567 130.905 63.6448 131.388C64.2148 131.59 64.5232 130.364 64.5332 129.725Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2765 130.96C66.7496 130.96 66.8822 130.747 66.6744 130.321C66.5562 130.542 66.0496 130.522 66.2765 130.96Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0249 133.492C53.2896 133.964 53.4075 133.166 53.8887 133.291C53.7765 132.996 53.5001 132.966 53.1175 133.106C53.1923 133.3 53.1506 133.422 53.0249 133.492V133.492Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.906 130.549C65.2622 130.057 64.9972 129.504 64.5854 129.167C64.1651 129.556 65.009 129.888 64.906 130.549Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5507 129.389C67.6807 129.734 68.2321 129.402 68.3621 129.745C68.5402 129.659 68.3995 129.375 68.6274 129.318C67.9261 129.402 68.4137 128.918 67.5507 129.389Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.794 133.695C49.8688 133.891 50.1427 133.766 50.3525 133.748C50.3365 133.457 50.1199 133.488 50.0594 133.269C49.8813 133.356 50.022 133.64 49.794 133.697V133.695Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5718 132.303C56.363 132.085 56.186 131.815 55.7604 131.946C55.9705 132.163 56.1475 132.432 56.5718 132.303Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0894 126.96C74.0332 126.857 73.9418 126.777 73.8319 126.736C73.722 126.694 73.6008 126.694 73.4906 126.734C73.4956 127.123 73.814 127.006 74.0894 126.96Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7893 136.138L34.1348 136.058C34.1301 135.671 33.8117 135.787 33.5364 135.833C33.6019 135.965 33.7501 135.965 33.7893 136.138Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0684 134.962C38.238 135.376 38.8901 134.91 38.5065 134.496C38.3569 134.649 38.42 134.935 38.0684 134.962Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9397 133.183C44.9978 133.565 45.5709 133.12 45.8438 133.155C45.786 132.774 45.2129 133.22 44.9397 133.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9397 130.346C58.4309 130.112 57.6904 130.015 57.7791 129.655C57.601 129.742 57.7417 130.026 57.5137 130.083C57.5999 130.261 57.8845 130.118 57.9411 130.348L57.9397 130.346Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3891 136.795C29.7403 136.786 29.4603 135.95 29.0959 136.317L29.1761 136.663C29.3161 136.597 29.3549 136.692 29.3891 136.795Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8349 134.752L35.4894 134.832C35.6393 134.953 35.7428 135.122 35.7826 135.31C36.143 135.289 36.3147 135.15 36.2207 134.844C35.6992 135.331 36.2175 134.765 35.8349 134.752V134.752Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7644 132.81C45.8614 132.71 45.9297 132.585 45.9623 132.449C45.9949 132.314 45.9905 132.172 45.9496 132.038C45.655 132.151 45.6247 132.427 45.7644 132.81Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0212 125.882C74.1243 125.826 74.2037 125.735 74.2451 125.625C74.2864 125.515 74.2868 125.394 74.2463 125.284C73.956 125.3 73.9866 125.516 73.7679 125.577C73.8331 125.709 73.9813 125.709 74.0212 125.882Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6071 135.37C31.714 135.592 32.073 135.413 32.3384 135.382C32.1973 134.993 31.7848 135.092 31.6071 135.37Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2943 131.958C46.741 132.545 46.4916 131.517 46.7324 131.492C46.2861 130.906 46.5354 131.934 46.2943 131.958Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4635 128.668C60.8172 128.528 60.3107 127.84 59.9573 128.057C59.8839 128.646 60.326 128.413 60.4635 128.668Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8869 134.194C36.5209 133.706 34.88 133.562 36.0718 133.422C35.8581 132.752 35.5667 133.674 35.3003 133.237C35.2033 133.337 35.135 133.462 35.1024 133.597C35.0698 133.733 35.0742 133.875 35.115 134.008C35.4983 133.869 35.7747 133.899 35.8869 134.194Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5152 125.271C73.8094 125.158 73.8401 124.882 73.7004 124.499C73.4059 124.613 73.3752 124.889 73.5152 125.271Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5863 135.293C29.7417 135.289 29.8948 135.254 30.0364 135.19C30.1779 135.126 30.3051 135.034 30.4102 134.919C30.3962 134.877 30.367 134.842 30.3283 134.82C30.2895 134.798 30.2441 134.792 30.2009 134.802C30.1576 134.812 30.1197 134.838 30.0945 134.874C30.0693 134.911 30.0586 134.955 30.0646 134.999C29.8955 135.035 29.8816 134.819 29.8118 134.694C29.6796 134.759 29.6796 134.908 29.5061 134.947L29.5863 135.293Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8219 133.531C34.701 133.681 34.532 133.784 34.3435 133.823C34.5074 134.287 35.0285 134.049 34.8219 133.531Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6308 133.475C36.6404 133.826 37.4764 133.546 37.1088 133.182L36.7633 133.262C36.8292 133.401 36.7337 133.44 36.6308 133.475Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.919 125.46C71.972 125.217 72.1119 125.001 72.3126 124.854C72.5133 124.707 72.7608 124.638 73.0086 124.661C73.3074 124.055 71.6162 125.164 71.5859 124.809C71.0958 125.102 71.8915 125.224 71.919 125.46Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7557 134.839L31.1016 134.759C31.0969 134.371 30.7785 134.487 30.5028 134.534C30.5691 134.666 30.7158 134.665 30.7557 134.839Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4834 134.438C33.2489 134.14 32.1005 133.424 32.4834 134.438V134.438Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9368 125.575C66.0992 126.07 65.6693 126.196 65.8317 126.692C66.1918 126.608 66.226 125.122 66.5754 125.973C67.1763 125.48 66.533 125.079 65.9368 125.575Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4986 131.283C44.9 131.665 45.4197 130.883 45.2021 130.393C45.0172 130.726 44.7796 131.026 44.4986 131.283Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2998 130.4C48.2437 130.296 48.1523 130.217 48.0424 130.175C47.9324 130.134 47.8113 130.134 47.701 130.174C47.7057 130.562 48.0245 130.447 48.2998 130.4Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9072 134.722C29.2249 134.706 28.9905 133.682 28.5738 134.071C28.624 134.386 28.8701 134.386 28.9072 134.722Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5989 134.561C29.9593 134.539 30.1314 134.401 30.037 134.096L29.5187 134.216L29.5989 134.561Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1595 129.786C50.3733 129.672 50.3604 129.418 50.5977 129.32C50.4281 128.906 49.9262 129.465 50.1595 129.786Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0423 124.006C75.2204 123.92 75.0797 123.636 75.3076 123.579C74.9803 122.941 74.4991 124.023 74.3231 123.261C74.2261 123.361 74.1578 123.486 74.1253 123.622C74.0928 123.757 74.0973 123.899 74.1382 124.033C74.5162 124.022 74.5682 123.808 74.789 123.7C74.9582 123.664 74.9721 123.88 75.0419 124.005L75.0423 124.006Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9406 134.068L31.2861 133.988C31.1362 133.867 31.0326 133.698 30.993 133.51C30.6564 133.689 30.6895 133.864 30.9406 134.068Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8047 133.867C31.6526 133.756 31.4257 133.456 31.6843 133.349C31.2622 132.647 31.161 134.327 31.8047 133.867Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3994 125.599C66.791 124.948 67.9768 125.139 68.3159 124.84C67.943 124.476 67.0906 125.051 66.7608 125.202C66.9827 125.32 66.9627 125.827 67.3994 125.599Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6821 124.837C71.0383 124.844 71.1049 123.835 70.5215 124.146C70.8902 124.422 70.5571 124.369 70.6821 124.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6349 129.079C51.9252 129.062 51.8942 128.846 52.1133 128.786C52.1037 128.434 51.2673 128.716 51.6349 129.079Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4593 128.706C52.6655 129.101 53.3537 128.594 53.0702 128.199C52.4618 128.116 53.068 128.789 52.4593 128.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.914 125.066C69.2652 125.057 68.9852 124.22 68.6209 124.587L68.701 124.933C68.8406 124.867 68.8791 124.963 68.9147 125.066H68.914Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0249 127.18C59.1539 127.038 59.2853 126.9 59.3704 127.1C59.5247 127.098 59.5179 126.993 59.5029 126.886L59.4228 126.541L58.9045 126.661L59.0249 127.18Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2653 131.506C37.7112 131.218 37.0469 130.783 37.0245 130.469C36.5493 130.804 37.3504 131.02 37.2653 131.506Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6555 126.771C58.1146 126.392 57.3484 126.026 56.9766 126.201C56.8751 126.916 57.7566 126.054 57.6555 126.771Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3899 124.791C65.3995 125.143 66.2355 124.861 65.8682 124.498L65.5227 124.578C65.5886 124.718 65.4932 124.757 65.3899 124.791Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7896 124.585C60.1092 124.267 60.2838 125.742 59.2223 125.678C59.5243 125.746 59.6077 126.166 60.0337 126.034C60.1687 125.478 60.532 125.065 60.7896 124.585Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4863 124.819C64.3795 124.597 64.0204 124.776 63.7551 124.807C63.8965 125.196 64.3089 125.097 64.4863 124.819Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2876 123.936C68.0532 123.697 67.7341 123.646 67.5563 123.924C67.6977 124.314 68.112 124.214 68.2876 123.936Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.193 129.583C43.2678 129.779 43.542 129.654 43.7515 129.635L43.5908 128.944C43.3949 129.019 43.5196 129.293 43.5385 129.503L43.193 129.583Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4318 125.397C60.5283 125.637 60.9614 125.337 61.0305 125.622C61.2086 125.536 61.0662 125.251 61.2959 125.195C61.0316 124.723 60.7634 125.428 60.4318 125.397Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8115 132.741C28.7759 132.247 28.1298 132.728 28.0001 132.383C27.5118 132.809 28.5415 132.751 28.8115 132.741Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3599 131.553C32.1611 131.239 31.79 131.199 31.3757 131.235C31.6019 131.501 31.8363 131.761 32.3599 131.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3885 124.81C61.8786 124.709 61.5017 123.849 61.0152 123.987C61.4102 124.217 60.9265 124.539 61.3885 124.81Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5877 128.53C44.7658 128.444 44.6251 128.16 44.853 128.103C44.8505 127.948 44.7462 127.956 44.6393 127.971L44.2938 128.051C44.3098 128.341 44.526 128.31 44.5869 128.529L44.5877 128.53Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4513 128.33C45.7416 128.314 45.711 128.098 45.9297 128.037C45.9208 127.685 45.0841 127.967 45.4513 128.33Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4257 127.407C49.7769 127.398 49.4969 126.562 49.1326 126.929L49.2127 127.275C49.3523 127.209 49.3908 127.305 49.4264 127.407H49.4257Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.679 122.47C71.2735 122.116 70.378 121.751 70.7837 121.354C70.0357 121.03 70.5344 121.81 70.679 122.47Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0577 121.736C73.7993 121.656 73.8413 121.14 74.3193 120.896C73.9934 120.5 73.836 120.436 73.3754 120.752C74.4664 121.338 72.8746 120.894 73.0577 121.736Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6497 121.134C76.0366 120.931 75.7587 120.314 76.5662 120.375C77.1379 119.951 75.8763 120.576 76.1003 119.937C75.8763 120.025 75.945 120.729 75.7548 120.017C75.3997 120.228 75.3687 120.96 75.6497 121.134Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8569 126.114C51.6803 125.988 51.4741 125.91 51.2585 125.888C51.1837 125.694 51.2254 125.572 51.3511 125.502C51.1235 125.137 50.2423 125.583 50.5675 126.049C50.9828 125.41 51.0662 126.642 51.8569 126.113V126.114Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4862 128.108C43.008 128.137 42.878 127.761 43.3101 127.735C43.2748 127.446 42.0986 127.648 42.4862 128.108Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5439 125.539C53.4065 125.285 52.9662 125.518 53.0378 124.928C52.9347 124.985 52.8552 125.076 52.8139 125.186C52.7725 125.296 52.7721 125.417 52.8127 125.527C53.0461 125.624 53.3075 125.628 53.5439 125.539Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5635 125.635C51.7337 126.049 52.2356 125.49 52.0013 125.17C51.789 125.283 51.8007 125.536 51.5635 125.635Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6778 125.327C54.034 125.042 54.149 125.255 54.4614 124.78C54.2737 124.185 53.769 125.27 53.7302 124.768C53.5759 124.77 53.5827 124.875 53.5977 124.982L53.6778 125.327Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9716 123.4C62.3082 123.22 62.2751 123.044 62.024 122.842L61.6785 122.922C61.6945 123.212 61.9107 123.182 61.9716 123.4Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8215 126.787L46.167 126.707C46.162 126.319 45.8439 126.435 45.5682 126.481C45.6338 126.614 45.7819 126.614 45.8215 126.787Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4613 127.618C41.5796 127.396 42.0861 127.416 41.8592 126.979C41.741 127.201 41.2344 127.181 41.4613 127.618Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8774 126.642C44.0942 126.188 44.1102 127.317 44.8774 126.642V126.642Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.178 120.301C72.1872 120.652 73.0236 120.372 72.6563 120.008L72.3108 120.088C72.3764 120.227 72.2813 120.267 72.178 120.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0145 129.68C31.4149 129.968 32.7064 129.561 32.2761 128.841C32.1226 129.584 31.4377 129.325 31.0145 129.68Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8297 128.047C39.1239 127.935 39.1545 127.658 39.0149 127.275C38.7848 127.67 38.4628 127.187 38.191 127.649C38.2858 127.969 38.7898 127.636 38.8297 128.047Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6535 127.673C39.9438 127.657 39.9131 127.441 40.1318 127.38C40.0456 127.202 39.761 127.343 39.7044 127.115C39.5092 127.19 39.6332 127.464 39.6535 127.673Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5354 121.894C65.3831 121.867 64.654 121.017 64.5354 121.894V121.894Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9801 127.93C37.4257 128.386 37.3082 127.262 37.9365 127.344C37.9436 126.987 36.9345 126.921 37.2455 127.504C37.0513 127.579 36.9292 127.538 36.8597 127.412C36.5926 127.592 36.844 127.834 37.113 127.717C37.1796 127.856 37.0845 127.895 36.9801 127.93Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5433 126.443C35.3937 126.596 35.4567 126.881 35.1052 126.909C35.4368 127.102 35.477 127.636 34.9199 127.68C34.9477 128.11 35.6847 127.402 35.5586 128.078C35.9355 128.004 35.1604 126.47 35.8763 127.094C36.3668 126.801 35.5707 126.679 35.5429 126.443H35.5433Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8018 127.143C38.5927 126.925 38.416 126.655 37.9904 126.787C38.1991 127.003 38.3761 127.273 38.8018 127.143Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1583 120.657C65.9416 121.11 65.9255 119.982 65.1583 120.657V120.657Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9097 128.844C29.8093 128.747 29.6848 128.679 29.5491 128.646C29.4135 128.614 29.2715 128.618 29.1382 128.659C29.2511 128.953 29.5268 128.984 29.9097 128.844Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7219 126.797C39.0824 126.775 39.2544 126.636 39.16 126.331L38.6418 126.451L38.7219 126.797Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6805 118.545C73.0047 118.841 73.2366 118.237 73.7573 118.477L73.5967 117.786C73.2761 118.012 72.8551 118.113 73.2113 117.693C73.0499 117.086 72.7254 118.192 72.6528 117.641C72.2588 117.789 72.7404 118.483 72.122 118.492C72.4537 118.966 72.7906 118.241 72.7329 117.986C73.1603 117.907 72.9021 118.549 72.6805 118.545V118.545Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7398 118.814C71.351 119.078 71.5423 118.771 71.0051 118.386C70.827 118.474 70.9674 118.759 70.7398 118.814Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9639 117.783C75.7145 117.394 75.577 116.821 75.0317 116.906C74.8796 117.53 75.3402 117.788 75.9639 117.783Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2006 124.099C47.3701 124.513 48.0227 124.047 47.6387 123.633C47.488 123.787 47.5522 124.072 47.2006 124.099Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7365 118.4C71.8574 118.25 72.0264 118.147 72.2148 118.107C72.0449 118.016 71.8587 117.96 71.6669 117.942C71.4751 117.924 71.2816 117.945 71.0978 118.002C71.1926 118.325 71.6966 117.989 71.7365 118.4Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2289 117.356C76.4252 117.282 76.3002 117.008 76.2813 116.798L75.763 116.918C75.8767 117.131 76.1303 117.12 76.2289 117.356Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.04 125.812C38.9397 125.715 38.8152 125.647 38.6795 125.615C38.5438 125.582 38.4019 125.587 38.2685 125.628C38.3807 125.922 38.6571 125.952 39.04 125.812Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.445 128.838C24.7353 128.822 24.7046 128.606 24.9233 128.545C24.9137 128.194 24.0777 128.476 24.445 128.838Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3616 122.837C46.1946 122.881 46.2765 123.08 46.269 123.223C45.8013 123.348 45.8544 123.016 45.578 123.384C45.8893 123.793 46.746 123.608 46.3616 122.838V122.837Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1881 125.282C38.4104 125.175 38.2312 124.816 38.2006 124.551C37.8113 124.692 37.9107 125.105 38.1881 125.282Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.125 124.6C41.7131 124.359 41.1104 123.629 40.4461 124.03C40.4233 124.619 40.9775 124.283 41.125 124.6Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2276 117.376C72.7893 117.381 72.4495 116.825 73.0112 116.83C72.7961 116.473 72.0064 116.975 72.2276 117.376Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4902 124.616C39.284 124.393 38.8758 124.495 38.546 124.471C38.8776 125.015 38.8455 124.834 39.4902 124.616Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9925 119.571C62.7363 119.286 61.5266 118.7 62.27 118.414C62.1347 118.276 61.7286 118.264 62.0171 118.109C61.7147 118.04 61.6314 117.62 61.2053 117.752C61.2802 117.947 61.2388 118.069 61.1127 118.138C61.704 118.135 62.0007 118.736 61.3133 119.002C61.8693 119.186 61.7639 119.123 61.9922 119.572L61.9925 119.571Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8413 117.283C71.7982 116.72 71.0192 117.338 70.8568 116.965C70.4062 117.403 71.4709 117.381 71.8413 117.283Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8463 123.371C45.2385 122.243 44.2329 122.714 44.8463 123.371V123.371Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3496 121.164C54.3172 120.86 53.951 120.785 54.2292 120.646C54.2271 120.492 54.1224 120.498 54.0155 120.513L53.67 120.593C53.727 121.057 53.9065 121.322 54.3496 121.164Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7631 127.854C25.0737 127.509 24.5412 127.46 24.7353 126.95C24.5929 127.255 24.0646 127.32 24.2046 127.802C24.4084 127.551 24.5829 127.517 24.7631 127.854Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4143 127.521L25.9326 127.401L25.772 126.71C25.7036 127.012 25.2836 127.095 25.4158 127.521H25.4143Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6333 117.997C66.0229 118.506 66.0529 117.589 66.2441 117.491C65.7686 117.107 65.6187 117.926 65.6333 117.997Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4838 126.624C28.6975 126.51 28.685 126.257 28.9219 126.158C28.7527 125.745 28.2501 126.303 28.4838 126.624Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.061 123.937C39.5267 123.434 40.4236 123.267 39.5146 123.153C39.1499 123.381 39.5955 124.262 40.061 123.937Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9102 121.649C50.1061 121.574 49.9815 121.3 49.9626 121.09C49.6021 121.112 49.4301 121.251 49.5245 121.556C49.6787 121.554 49.6719 121.449 49.657 121.343C49.8262 121.307 49.8401 121.523 49.9099 121.648L49.9102 121.649Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5127 122.721C44.2908 122.602 44.3107 122.096 43.874 122.323C44.0956 122.441 44.0756 122.947 44.5127 122.721Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.058 126.36C28.4524 126.222 27.9815 125.577 27.8572 125.496C27.4262 125.572 27.0187 125.664 26.8598 125.91C27.0098 126.031 27.1133 126.2 27.153 126.388C27.3927 126.291 27.0935 125.858 27.3781 125.789C27.4557 126.416 27.9188 125.463 28.058 126.36Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1967 118.894C60.6976 118.911 60.465 118.47 60.8076 118.388C60.6014 117.994 59.9132 118.501 60.1967 118.894Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9979 118.013C64.5194 118.042 64.3897 117.665 64.8218 117.64C64.7865 117.35 63.6104 117.553 63.9979 118.013Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.148 123.138C41.4422 123.026 41.4729 122.749 41.3332 122.366C41.2362 122.466 41.1678 122.591 41.1352 122.727C41.1026 122.862 41.1071 123.004 41.148 123.138Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.973 119.928C55.0845 119.775 55.3837 119.549 55.4913 119.807C56.1926 119.384 54.5135 119.283 54.973 119.928Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9098 119.244C58.0387 119.102 58.1701 118.964 58.2552 119.164C58.4223 119.12 58.34 118.921 58.3479 118.779C58.2082 118.844 58.1698 118.749 58.1341 118.646C58.002 118.711 58.0024 118.859 57.8289 118.899L57.9098 119.244Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8088 121.226C48.1169 121.642 48.7292 121.029 48.3787 120.547C48.0624 120.695 48.3979 121.249 47.8088 121.226Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8235 123.313C39.1384 123.264 39.1387 123.017 39.4746 122.98C39.4586 122.662 38.4349 122.897 38.8235 123.313Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4804 115.728C71.8316 115.719 71.5516 114.882 71.1873 115.25L71.2674 115.595C71.407 115.53 71.4462 115.625 71.4804 115.728Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6874 120.708C47.0462 120.874 47.24 121.016 46.6508 120.949C46.5279 121.546 48.0606 121.19 47.6874 120.708Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2873 123.771C35.4082 123.621 35.5772 123.517 35.7656 123.478C35.267 123.359 35.3026 122.987 35.3521 122.48L34.6611 122.641C35.5245 123.014 34.7248 123.189 34.0502 123.147C34.2475 124.189 35.1701 122.6 35.2876 123.77L35.2873 123.771Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5703 123.008C38.2177 122.578 37.548 122.658 37.1078 122.983C37.4536 123.219 37.9723 123.177 38.5703 123.008Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7731 121.9C41.7888 122.218 42.8129 121.984 42.4242 121.567C42.046 121.578 41.9943 121.791 41.7731 121.9Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7976 119.986C50.2744 119.642 50.902 119.183 51.2881 118.961C51.1622 118.847 51.0055 118.773 50.8377 118.747C50.6698 118.722 50.4981 118.746 50.3438 118.817C50.9137 119.931 49.636 119.129 49.7208 120.054C50.3132 120.172 50.0998 119.624 50.7976 119.986V119.986Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2654 118.019C59.7284 117.963 59.9938 117.784 59.8353 117.34C59.7722 117.645 58.9811 117.497 59.2654 118.019Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5106 117.498C62.0634 117.023 61.7724 116.941 61.7481 116.168C61.112 116.591 61.6359 116.818 61.5106 117.498Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6427 114.447C75.0533 114.408 74.7185 113.903 75.0405 113.809C74.7777 113.378 74.3581 114.05 74.6427 114.447Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8121 113.993C76.165 114.3 77.0684 113.951 76.4229 113.488C76.169 113.625 76.4016 114.065 75.8121 113.993Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0631 116.722C64.1662 116.666 64.2457 116.574 64.2871 116.465C64.3284 116.355 64.3288 116.234 64.2882 116.123C63.9007 116.129 64.0161 116.448 64.0631 116.722Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6151 118.785C53.7255 119.162 54.3649 118.688 54.6919 118.717C54.5818 118.34 53.9421 118.814 53.6151 118.785Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5454 122.518C37.7349 122.192 38.3949 122.16 38.8879 122.024C38.8131 121.829 38.8544 121.708 38.9805 121.638C38.8832 121.398 38.4508 121.698 38.3817 121.413C38.371 121.947 37.3705 121.867 37.5454 122.517V122.518Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.229 118.693C52.3902 118.363 52.149 119.486 53.229 118.693V118.693Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4279 116.739L62.7734 116.658C62.7685 116.271 62.45 116.387 62.1747 116.433C62.2399 116.565 62.3884 116.565 62.4279 116.739Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.577 124.287C27.7907 124.173 27.7783 123.92 28.0151 123.821C27.8442 123.407 27.3423 123.966 27.577 124.287Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7192 120.073C45.606 119.701 45.1978 119.803 44.775 119.928C44.9009 120.042 45.0576 120.116 45.2254 120.142C45.3933 120.168 45.565 120.144 45.7192 120.073Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9106 117.292C57.7259 117.622 57.9036 116.466 56.9106 117.292V117.292Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9079 119.714L45.2534 119.634C45.1035 119.513 45 119.344 44.9603 119.155C44.6237 119.337 44.6568 119.511 44.9079 119.714Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.091 118.511C50.2581 118.467 50.1761 118.268 50.1836 118.125C50.6196 118.345 50.7849 118.396 51.2607 118.057C50.9402 117.861 50.4376 117.954 49.971 117.993L50.091 118.511Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.248 113.998C63.1458 114.54 63.4279 114.881 64.007 114.914C63.7221 114.751 63.4631 114.08 64.1919 114.143L64.0715 113.624C63.7231 113.973 63.8346 114.064 63.248 113.998Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1401 117.539C52.089 117.953 51.6335 116.505 51.1401 117.539V117.539Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.188 116.134C57.6582 116.605 57.7793 115.63 57.5057 115.149C57.1335 115.311 57.7515 116.091 57.188 116.134Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4496 117.7C50.9401 117.407 50.144 117.284 50.1162 117.048C49.6261 117.341 50.4222 117.463 50.4496 117.7Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6965 117.611C47.7606 117.91 48.1157 116.509 48.5602 117.41C49.0012 117.125 48.6194 116.662 48.4922 116.333C48.2236 117.203 48.2147 116.547 47.3228 116.787C48.1097 117.014 47.5625 116.8 47.6965 117.611V117.611Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8404 116.233C52.6135 115.553 52.6309 115.835 52.2541 115.277C51.7818 115.541 52.4867 115.811 52.4546 116.141C52.3887 116.4 51.9738 116.163 51.6307 116.514C51.8373 117.081 52.4749 116.42 52.8418 116.233H52.8404Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5723 116.246C53.4583 116.032 53.2047 116.045 53.106 115.808C52.6921 115.978 53.2513 116.48 53.5723 116.246Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2186 112.661C68.8181 112.554 68.068 112.081 68.749 111.81C68.6368 111.515 68.3604 111.485 67.9779 111.624C68.0217 111.791 68.2204 111.709 68.3636 111.717C68.3661 112.064 67.9422 112.144 68.2186 112.661Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9419 114.703C53.5917 114.947 52.9014 115.306 53.1305 114.345C52.339 114.246 53.3912 115.296 52.5997 115.197C52.8113 115.852 54.0712 115.451 53.9419 114.703Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.592 116.774C46.6013 117.125 47.4376 116.845 47.0704 116.481L46.7249 116.561C46.7904 116.701 46.695 116.74 46.592 116.774Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5807 112.697C62.8026 112.815 62.7827 113.322 63.2197 113.095C62.9978 112.976 63.0181 112.469 62.5807 112.697Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.228 114.354C56.5646 114.174 56.5315 113.998 56.2803 113.795L55.9348 113.875C56.0847 113.996 56.1883 114.165 56.228 114.354Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.085 113.326C58.8791 113.103 58.4709 113.205 58.141 113.181C58.0983 113.803 58.7409 113.325 59.085 113.326Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8207 111.347C66.9464 111.771 67.4173 111.262 67.5117 111.187C67.2781 110.696 67.1808 111.438 66.8207 111.347Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7183 113.329C56.7136 113.02 56.5077 113.034 56.2908 113.064C56.1925 112.658 56.4689 112.486 56.2228 111.987C56.0557 112.031 56.138 112.23 56.1302 112.373C56.0899 112.742 55.7765 112.941 55.3864 113.092C55.697 113.384 56.2413 113.299 56.7165 113.329H56.7183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0609 112.836C58.295 113.327 58.3918 112.584 58.752 112.675C58.4613 112.133 58.3306 112.614 58.0609 112.836Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1826 113.786C54.1774 114.228 54.0945 113.014 53.1826 113.786V113.786Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7227 111.338C63.7911 111.036 64.2111 110.953 64.0789 110.527C63.7473 110.495 63.4791 111.2 63.2152 110.727C62.6762 111.164 63.7295 110.975 63.7213 111.338H63.7227Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6948 110.434C63.6387 110.331 63.5473 110.252 63.4373 110.21C63.3274 110.169 63.2063 110.168 63.0961 110.209C63.1007 110.595 63.4191 110.48 63.6948 110.434Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8145 111.404C54.7023 111.11 54.4258 111.079 54.0429 111.219C54.1551 111.513 54.4319 111.544 54.8145 111.404Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2939 138.886C64.2191 138.691 63.9452 138.815 63.7354 138.834C63.4882 139.775 63.6564 139.19 64.2939 138.886Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.496 140.183C59.7496 139.782 59.9255 140.063 60.3597 139.982C60.4566 139.33 58.9627 140.041 59.5081 139.452C59.0632 139.178 59.315 139.742 59.496 140.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1161 138.532C60.5793 138.529 61.1845 140.179 61.1161 138.532V138.532Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7435 140.094C56.9074 139.015 56.0632 139.422 56.7435 140.094V140.094Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8663 138.64C60.9445 138.804 60.5384 137.96 59.8663 138.64V138.64Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9954 138.014C61.0505 138.082 61.1206 138.136 61.2002 138.173C61.2799 138.209 61.3668 138.227 61.4544 138.224C61.5419 138.221 61.6277 138.198 61.7049 138.157C61.7821 138.116 61.8487 138.057 61.8994 137.986C61.6846 138.036 61.2971 137.673 60.9954 138.014Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0843 137.214C61.7252 137.639 62.376 137.166 62.6025 137.094C62.5112 136.972 62.4463 136.832 62.4118 136.683C62.3772 136.535 62.3739 136.38 62.402 136.23C62.2439 136.477 61.8367 136.568 61.4047 136.644C61.6002 137.236 62.5555 136.336 62.0843 137.214Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7069 135.977C62.8206 136.191 63.0742 136.178 63.1728 136.415C63.4125 136.318 63.1133 135.885 63.3979 135.816C63.253 135.381 63.1557 136.123 62.7069 135.977Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3076 136.633C58.3033 135.64 57.2066 136.923 58.3076 136.633V136.633Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0647 135.166C63.599 135.721 63.4258 134.619 64.062 134.752C64.0182 134.585 63.8198 134.667 63.6766 134.66C63.758 134.485 63.7765 134.288 63.729 134.101C63.5968 134.167 63.5972 134.315 63.4237 134.354C63.2545 134.39 63.2406 134.174 63.1708 134.049C63.0738 134.149 63.0054 134.273 62.9728 134.409C62.9403 134.545 62.9447 134.687 62.9856 134.82C63.5516 134.239 63.7379 135.041 63.0657 135.166L63.0647 135.166Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.375 132.921C69.2804 132.857 69.9999 133.744 70.375 132.921V132.921Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1182 137.444L50.4637 137.364C50.3978 137.224 50.4933 137.186 50.5962 137.15C49.783 136.841 50.1688 137.052 50.2628 136.499L49.7445 136.62L49.8649 137.138L49.5191 137.218C49.5327 137.261 49.5618 137.297 49.6007 137.319C49.6396 137.341 49.6854 137.348 49.7289 137.337C49.7725 137.327 49.8107 137.301 49.8359 137.264C49.8611 137.227 49.8715 137.182 49.8649 137.138C50.0341 137.102 50.048 137.319 50.1182 137.444V137.444Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7762 132.696L70.2944 132.576C70.2549 132.165 69.7505 132.5 69.6558 132.178C69.4168 132.313 69.7751 132.383 69.7762 132.696Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2837 131.335C73.2588 131.095 72.3248 131.192 72.8178 130.897C72.774 130.73 72.5752 130.812 72.432 130.804C72.4979 130.944 72.4025 130.982 72.2995 131.018C72.6055 131.158 72.8381 131.418 73.2837 131.335Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5676 133.41C63.689 132.225 62.7056 133.097 63.5676 133.41V133.41Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7092 139.699C36.1064 139.556 35.404 139.283 35.3758 139.048C34.8853 139.34 35.6814 139.462 35.7092 139.699Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2086 131.835C68.5329 132.475 69.4764 131.422 67.2086 131.835V131.835Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3523 135.701C51.7202 135.513 51.0801 135.48 51.4046 135.142C51.7686 135.111 51.852 135.531 52.216 135.498C52.5045 135.172 51.271 135.291 51.2842 134.623C51.2421 134.636 51.2067 134.666 51.1849 134.704C51.1632 134.743 51.1567 134.789 51.1668 134.832C51.1768 134.875 51.2026 134.913 51.2392 134.938C51.2757 134.963 51.3204 134.974 51.3644 134.968C51.2002 135.251 50.9241 135.429 51.3523 135.701Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7316 134.966C53.9058 135.383 54.1868 134.685 53.9567 134.367C53.4352 134.338 53.5649 134.715 53.1332 134.741C53.4003 135.208 53.437 134.875 53.8644 134.753C53.9303 134.892 53.8349 134.931 53.7319 134.967L53.7316 134.966Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5853 138.767C36.4329 138.53 36.3659 138.603 36.0792 138.156C35.6977 138.214 36.1433 138.787 36.1069 139.06C36.3769 138.982 36.7837 138.989 36.7581 138.727C36.9518 138.463 36.7581 138.655 36.5853 138.767Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1145 135.078C49.8095 135.171 49.7009 134.951 49.3832 135.066C49.8377 135.357 50.1757 135.558 50.46 134.997C50.446 134.955 50.4168 134.92 50.3781 134.898C50.3393 134.876 50.2939 134.87 50.2507 134.88C50.2074 134.89 50.1695 134.916 50.1443 134.952C50.1191 134.989 50.1084 135.034 50.1145 135.078Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.554 135.044C45.4439 135.086 45.3224 135.086 45.2122 135.045C45.102 135.003 45.0106 134.923 44.9553 134.819C44.8449 134.334 45.5223 135.121 45.2206 134.392C44.9058 134.442 44.9054 134.688 44.5695 134.725C45.2018 135.094 44.4452 136.302 45.449 136.16C44.8035 135.615 45.5252 134.685 45.8052 135.348C46.0281 135.142 45.9259 134.734 45.9501 134.404C45.8415 134.475 45.7496 134.569 45.6809 134.679C45.6122 134.789 45.5683 134.913 45.5523 135.042L45.554 135.044Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8183 136.59C43.4271 136.674 42.8205 136.001 43.4292 136.084C43.2896 135.73 42.6014 136.237 42.8183 136.59Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8694 133.195C56.0578 133.117 55.9253 132.999 55.8291 133.022C55.7543 132.828 55.796 132.706 55.9218 132.636C55.8434 132.448 55.7262 132.581 55.749 132.677C55.6094 132.743 55.5709 132.647 55.5353 132.544C55.3469 132.623 55.4797 132.74 55.5755 132.717C55.6112 132.886 55.3953 132.9 55.2703 132.97C55.3679 133.21 55.8007 132.91 55.8694 133.195Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8211 129.357C71.391 129.858 71.8491 128.553 71.3116 128.333C71.1157 128.447 71.5901 129.236 70.8211 129.357Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1759 135.778C43.2443 135.476 43.6642 135.393 43.5321 134.967C43.3155 135.176 43.0459 135.353 43.1759 135.778Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7906 133.282C50.8689 133.47 50.9861 133.337 50.9633 133.241C51.338 133.964 52.8134 132.936 52.1851 132.229C52.0736 132.381 51.774 132.608 51.6668 132.349C51.25 132.524 51.9475 132.805 52.2656 132.575C52.2656 132.772 51.9493 132.772 52.0002 133.002C51.4132 133.289 51.0741 132.807 50.7891 133.283L50.7906 133.282Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0137 129.413C69.4874 129.841 69.1604 128.531 69.9302 128.654C69.3777 128.178 69.2028 129.175 69.0137 129.413Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7671 129.935C67.3886 129.978 66.9095 129.335 66.912 128.991C66.6702 129.062 66.429 129.134 66.3535 128.939C66.0468 129.313 67.1482 129.243 66.7671 129.936V129.935Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5229 136.131C39.0237 136.147 38.7911 135.707 39.1338 135.625C38.9959 135.519 38.3381 135.474 38.5229 136.131Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.555 132.64C53.9269 132.003 52.8996 132.746 52.7839 132.454C52.3315 133.041 53.6092 132.454 53.555 132.64Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2421 132.065C55.0675 131.984 54.8702 131.966 54.6836 132.013C54.9607 132.588 55.3344 132.072 55.5474 131.813C55.4302 131.585 55.24 131.868 55.2421 132.065Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8623 135.656C34.356 136.04 36.9698 136.675 35.8623 135.656V135.656Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3346 128.843C68.5915 128.719 68.1127 128.574 68.4272 128.457C68.3015 128.033 67.8303 128.542 67.7362 128.617C67.8331 128.857 68.2659 128.558 68.335 128.843H68.3346Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4447 128.12C71.818 127.807 70.8103 127.738 70.7256 127.377C70.4028 127.608 71.2542 127.929 71.4447 128.12Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4818 127.879C73.0029 127.431 72.0252 126.904 72.9727 126.855C73.4852 126.526 72.463 126.767 72.241 126.842C72.6539 126.155 71.6615 126.983 72.1206 126.324C71.8286 125.834 71.5564 126.538 71.4699 126.658C71.5586 126.881 72.2624 126.813 71.55 127.003C72.1662 127.196 72.6343 126.92 72.4818 127.879Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3511 136.604C33.0287 136.331 32.5796 136.261 32.4189 135.728C32.1176 136.075 32.8488 136.759 33.3511 136.604Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1973 133.903C44.0028 133.977 43.881 133.936 43.8116 133.81C43.2288 134.306 44.5888 134.208 44.3302 133.69C44.1763 133.445 44.1471 133.72 44.1973 133.903Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3327 128.861C64.073 129.066 65.2025 129.028 65.49 129.139C65.0739 128.764 65.417 128.584 65.9277 128.673L65.6869 127.636C64.93 128.675 65.2381 128.225 64.3327 128.861Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0371 130.788C55.7582 130.919 55.6809 130.729 55.6096 130.522C55.4888 130.672 55.3198 130.776 55.1313 130.815C55.2844 130.965 55.5701 130.902 55.5972 131.254L56.2882 131.093C56.2861 130.938 56.1813 130.945 56.0745 130.96C56.1154 130.788 56.1546 130.616 56.3398 130.533C56.2615 130.344 56.1443 130.477 56.1671 130.573C56.0275 130.639 55.989 130.544 55.9534 130.44C55.7251 130.578 56.0111 130.59 56.0371 130.788Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3358 129.275C63.8526 129.524 63.0102 128.774 62.9625 128.451C62.7228 128.548 63.022 128.981 62.737 129.049C62.8157 129.238 62.9326 129.105 62.9098 129.009C63.0818 129.05 63.2542 129.089 63.3372 129.274L63.3358 129.275Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9723 134.934C39.0933 134.784 39.2623 134.68 39.4507 134.641C39.237 133.969 38.8957 134.974 38.812 134.243C38.3212 134.477 39.0614 134.574 38.9727 134.934H38.9723Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5552 130.685C51.9753 130.269 51.4809 130.792 50.9199 130.7C51.223 131.377 51.6102 130.445 52.0369 130.805C52.0369 131.052 51.6376 131.049 51.3858 131.139C51.9322 132.278 51.9158 131.807 52.5552 130.685Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4511 129.399C60.5936 129.528 60.7318 129.659 60.5313 129.744C61.0121 130.222 60.8031 129.041 61.062 128.892C60.8636 128.501 60.834 129.419 60.4511 129.399Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6572 133.946C41.7698 133.798 41.6195 132.77 42.0551 133.307C42.5331 133.093 41.7274 133.1 41.7619 132.829C41.4948 133.057 41.5867 133.508 41.4442 133.813C41.3269 133.808 41.2153 133.761 41.1298 133.681C41.0443 133.6 40.9905 133.492 40.9783 133.375C40.8002 133.462 40.9409 133.746 40.7129 133.803C40.9192 134.024 41.3263 133.922 41.6572 133.946Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2049 129.921L58.7231 129.8C58.2957 129.776 58.2886 129.074 57.8327 129.097C57.8441 128.808 58.3417 128.823 58.0175 128.325C57.4052 129.035 57.9709 128.988 58.206 129.92L58.2049 129.921Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8429 125.528C70.9907 125.845 71.5446 125.509 71.5218 126.098C72.0657 125.343 72.5665 126.177 72.8921 126.508C73.286 126.088 72.2406 125.991 72.398 125.166C72.1466 125.774 71.525 125.473 70.8429 125.527V125.528Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3465 126.158C67.9464 126.156 66.6284 126.077 66.6153 126.146C66.0585 126.548 67.0014 126.967 66.1248 127.17L66.2854 127.861C66.5661 127.092 67.0224 127.343 67.4669 126.676C67.1741 126.186 67.052 126.982 66.8158 127.009C66.7881 126.918 66.7802 126.823 66.7926 126.728C66.805 126.634 66.8374 126.544 66.8877 126.463C66.9379 126.382 67.0049 126.313 67.084 126.26C67.1632 126.208 67.2527 126.173 67.3465 126.157V126.158Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3948 127.139C69.5832 127.06 69.4503 126.943 69.3545 126.966C69.3353 126.757 69.6355 126.747 69.8325 126.673C69.4371 126.443 69.9212 126.121 69.4592 125.849C69.4236 125.68 69.6398 125.666 69.7645 125.596C69.6388 125.172 69.1679 125.681 69.0735 125.756C69.188 125.862 69.2801 125.989 69.3443 126.13C69.4085 126.272 69.4435 126.425 69.4471 126.581C69.1422 126.675 69.0336 126.454 68.7159 126.569C68.6927 127.159 69.3403 126.673 69.3948 127.138V127.139Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2834 130.285C54.0843 131.116 54.895 129.779 54.2033 129.94C53.9173 130.006 54.3169 130.145 54.2834 130.285Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6101 127.705C64.6457 127.874 64.4295 127.888 64.3045 127.957C64.3622 128.339 64.9353 127.893 65.2085 127.93C65.169 127.519 64.6646 127.854 64.5698 127.532C64.3814 127.61 64.5143 127.727 64.6101 127.705Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2507 133.777C39.7411 133.484 38.945 133.362 38.9173 133.126C39.3173 132.958 39.3664 133.354 39.8216 133.098C39.6553 132.748 39.9919 132.711 40.2598 132.632C39.5937 132.113 39.3643 132.95 38.5856 132.475C38.7388 132.09 39.3988 132.495 39.755 132.021C39.037 131.56 38.804 131.995 38.2925 131.996C38.3738 131.822 38.3923 131.625 38.3449 131.438C38.2284 131.949 37.7187 131.986 37.6015 132.157C37.411 132.054 37.2505 131.903 37.1356 131.719C37.251 132.28 36.586 132.092 36.5126 132.956C36.3993 132.689 37.4469 132.722 37.3764 132.756C37.5719 132.663 37.8875 131.681 38.3737 132.342C37.9954 132.932 38.8229 133.587 37.9634 133.713C38.2815 134.525 38.7762 132.865 39.2532 133.777L39.2507 133.777Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1165 125.912C73.3106 125.48 73.0599 125.247 72.7026 124.914C72.4394 124.979 72.979 125.709 73.1165 125.912Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1586 134.595C34.3221 134.955 34.8457 134.091 34.3837 133.997C34.144 134.093 34.4432 134.526 34.1586 134.595Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7715 128.828C60.0921 128.808 59.6266 128.155 59.3056 128.39C59.2996 128.795 59.6928 128.56 59.7715 128.828Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4343 127.331C65.7268 127.821 65.8493 127.025 66.0854 126.997C65.9423 126.6 65.6698 127.303 65.4343 127.331Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8876 131.789C43.7206 131.832 43.8028 132.031 43.795 132.174C43.348 131.731 42.8664 132.103 42.5455 132.281C42.9619 132.156 44.4696 132.557 43.8876 131.789Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1109 125.516C69.8088 125.247 70.1219 126.067 70.2715 126.207C70.5757 126.175 70.6505 125.808 70.7898 126.087C71.0634 125.489 70.305 125.935 70.1109 125.516Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2951 129.554C54.3913 129.881 54.8266 129.217 55.332 129.313C55.098 128.741 54.6407 129.367 54.2951 129.554Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3906 127.196C58.16 126.88 57.7824 127.802 58.0695 127.766C58.6722 127.752 58.2651 127.344 58.1219 127.207C58.7074 127.059 58.8834 127.566 59.1865 127.871C58.7441 127.989 59.1766 128.654 58.4428 128.589C58.0584 128.151 57.7067 127.685 57.3906 127.195V127.196ZM58.4029 128.418L58.7484 128.338C58.6825 128.198 58.778 128.16 58.8809 128.124C58.7687 127.83 58.4923 127.799 58.1094 127.939C58.2593 128.06 58.3628 128.229 58.4025 128.417L58.4029 128.418Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1407 126.852C65.8175 127.311 65.2935 125.958 64.9402 125.988C64.7621 125.461 65.5414 126.312 65.4182 125.695C65.9906 125.419 64.3421 126.007 64.9523 125.257C64.3824 124.723 64.8073 126.041 64.4216 126.109C64.7617 126.193 65.3876 126.389 64.755 126.76C64.953 127.038 65.0755 126.712 65.2732 126.639C65.3391 126.779 65.2437 126.817 65.1407 126.853V126.852Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0946 133.932C33.0511 134.504 33.7485 133.255 34.3056 133.651C33.9676 133.442 34.0424 132.736 34.1988 132.401C34.6116 132.407 34.0517 132.719 34.4919 132.879C34.8998 132.789 34.9315 132.463 35.4893 132.466C34.6166 132.417 34.6469 131.937 33.641 132.349C34.4912 133.089 33.4707 133.548 33.018 133.586C33.1031 133.81 33.8066 133.741 33.0946 133.932Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7374 132.338C41.4431 132.204 41.385 130.749 40.5892 130.916C40.5939 131.225 40.7998 131.211 41.0167 131.181C41.0559 131.638 40.9693 132.337 40.4859 132.033C40.1892 132.258 40.695 132.093 40.7374 132.338Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5754 131.215C45.7424 131.171 45.6605 130.972 45.668 130.829C45.8158 130.829 45.8817 130.962 46.0538 130.922C46.2985 130.769 46.0228 130.739 45.84 130.789C45.7652 130.595 45.8069 130.473 45.9327 130.404C45.507 129.915 45.5644 130.945 45.5765 131.215L45.5754 131.215Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9137 127.47C60.7645 127.235 60.5576 127.094 60.4076 126.859C60.7453 126.199 61.1912 127.183 61.6187 126.578C61.4666 126.467 61.2397 126.167 61.4983 126.06C60.9373 125.835 59.2428 126.931 60.9152 127.47L60.9137 127.47Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7828 133.356C35.0175 133.206 35.1589 133 35.3937 132.85C35.4261 132.605 34.5185 132.975 34.7828 133.356Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4927 128.051C54.5134 128.232 55.3195 128.227 54.7859 128.529C55.4342 129.156 54.8026 127.768 55.1421 127.718C54.4838 127.384 54.1447 127.459 53.5994 127.348C53.5449 126.575 54.2049 126.248 54.2762 125.552C54.0315 125.843 53.6796 126.066 53.7857 126.576C53.4366 126.583 53.4936 125.938 52.9743 126.22C52.9974 126.54 53.2197 126.537 53.188 126.352C53.9499 126.612 53.2275 126.88 53.469 127.563C53.7896 127.329 54.3492 127.831 53.9349 128.002C54.1761 128.375 54.2498 127.427 54.9323 127.588C54.8281 127.778 54.6767 127.937 54.4927 128.051Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.477 128.369C55.742 128.801 55.7719 127.884 56.0879 127.863C56.0858 127.709 55.981 127.716 55.8742 127.73L55.5287 127.81C55.5999 128.052 55.6711 128.293 55.4763 128.369L55.477 128.369Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3808 128.341C56.8983 128.27 56.8616 127.5 57.2445 128.14C57.8743 127.416 56.5589 127.84 56.3929 127.61C56.1671 127.821 56.4997 127.857 56.3808 128.341Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9123 132.731C36.7262 132.795 36.0527 131.556 36.7483 131.627C36.7458 131.472 36.6414 131.479 36.5346 131.494C36.499 131.325 36.7148 131.311 36.8398 131.241C36.733 131.019 36.3739 131.198 36.1086 131.229C36.2001 132.045 36.3048 132.105 35.9112 132.732L35.9123 132.731Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5458 124.636C71.7346 124.558 71.6017 124.441 71.5055 124.464C71.736 123.477 71.9924 122.609 71.1721 123.812C71.1758 123.968 71.2107 124.121 71.2748 124.262C71.339 124.404 71.431 124.531 71.5454 124.636H71.5458Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1975 124.303C71.7622 124.85 72.6495 123.998 72.5832 124.395C73.0228 124.13 72.0179 123.788 72.9814 123.757C72.7827 123.443 72.4133 123.403 71.9969 123.439C72.1373 123.739 72.4069 123.96 72.1975 124.303Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8013 133.454C32.7988 133.299 32.6944 133.306 32.5876 133.321C32.3582 133.333 32.2413 132.858 32.4672 132.802C31.8737 132.21 32.1444 133.97 32.8006 133.454H32.8013Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8631 126.057C63.504 126.481 64.1548 126.009 64.3813 125.936C63.8353 125.088 64.282 125.769 63.8631 126.057Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6409 132.762C32.7759 133.001 32.8461 132.643 33.1592 132.642C32.7517 132.555 32.3089 131.9 32.0023 132.365C32.0657 132.614 33.1496 132.374 32.6409 132.762Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6519 131.599C37.9307 130.988 38.2875 130.415 38.7134 129.895C37.8852 130.274 37.4952 131.002 37.6519 131.599Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5234 127.416C52.3097 127.677 52.217 128.013 51.78 128.135C51.8662 128.313 52.1508 128.17 52.2074 128.4C52.5241 128.252 52.1886 127.698 52.7773 127.721C52.7211 127.337 52.5081 127.204 52.1383 127.323C52.1821 127.49 52.3813 127.408 52.5241 127.415L52.5234 127.416Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8131 124.643C66.6415 124.602 66.4687 124.563 66.3857 124.378C65.9618 124.504 66.4712 124.975 66.5464 125.069C66.889 124.987 66.6564 124.547 67.1572 124.563C67.1433 124.521 67.114 124.486 67.0753 124.464C67.0366 124.442 66.9912 124.436 66.9479 124.446C66.9047 124.456 66.8667 124.482 66.8415 124.518C66.8163 124.555 66.8057 124.599 66.8117 124.643H66.8131Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3755 122.706C74.2205 122.981 74.3712 122.993 74.4959 123.224C74.674 123.138 74.5315 122.853 74.7612 122.797C74.675 122.619 74.3904 122.759 74.3338 122.531C74.1454 122.61 74.2779 122.727 74.374 122.704L74.3755 122.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9742 122.929C75.1002 123.353 75.5708 122.844 75.6655 122.769C75.5904 122.573 75.3165 122.697 75.107 122.716C75.0411 122.576 75.1366 122.538 75.2395 122.503C74.7743 122.117 75.18 122.933 74.9742 122.93V122.929Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0215 132.028C35.2099 131.949 35.0771 131.832 34.9812 131.855C35.5155 130.976 35.3307 131.777 35.8853 131.827C35.8429 131.183 35.4902 131.038 35.2587 130.698C34.6938 130.977 34.4544 130.544 34.2222 130.938C34.2973 131.608 34.7511 131.67 35.0215 132.028Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6562 129.608C44.7944 129.96 45.214 129.287 45.054 128.969C44.3776 128.843 45.0861 129.58 44.6562 129.608Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4454 127.051C56.6413 126.976 56.5166 126.702 56.4978 126.493C55.9991 126.742 55.9204 126.313 55.421 126.561C55.4434 126.868 55.2101 127.326 55.7544 127.212C54.9928 126.616 56.2662 126.564 56.4454 127.051Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.688 123.279C74.1127 122.863 72.9986 122.177 74.0825 122.227C74.0885 121.821 73.6953 122.057 73.6166 121.788C73.3914 122.659 72.678 122.308 72.688 123.279Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1301 126.063C59.4963 126.516 59.1693 125.632 58.7443 125.971C58.6784 125.831 58.7739 125.793 58.8768 125.757C58.833 125.59 58.6343 125.672 58.4911 125.664C58.557 125.804 58.4615 125.842 58.3586 125.878C58.4708 126.172 58.7472 126.203 59.1301 126.063V126.063Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2716 124.706C60.2218 124.391 59.9753 124.39 59.9382 124.054C59.9792 123.883 60.0184 123.71 60.2036 123.627C60.4597 123.632 60.2891 123.928 60.111 124.012C60.4914 124.473 60.5384 123.508 60.6809 123.333C60.885 123.481 61.331 123.239 61.3196 123.732C61.5653 123.491 61.337 122.954 61.4243 122.615C61.3213 122.671 61.2419 122.762 61.2006 122.872C61.1593 122.982 61.1588 123.103 61.1992 123.213C61.0517 123.213 60.9854 123.08 60.8138 123.121C60.9876 122.737 61.0218 122.266 61.69 122.189C61.5987 122.066 61.5337 121.926 61.4992 121.778C61.4647 121.629 61.4614 121.475 61.4895 121.325C62.3596 121.991 62.178 120.455 63.2174 120.923C63.253 121.093 63.0371 121.107 62.9118 121.176C62.9142 121.331 63.0186 121.324 63.1255 121.309L63.471 121.229C63.5355 120.493 62.8202 121.008 62.8847 120.272C62.7351 120.425 62.7981 120.711 62.4466 120.739C62.2881 120.295 62.7037 120.209 63.0165 120.06C62.589 119.355 62.2293 120.189 62.0191 120.473C61.6455 120.509 62.1616 119.954 61.6857 119.822C61.3139 119.935 61.4161 120.344 61.5408 120.766L62.2318 120.606C62.2734 120.716 62.2735 120.837 62.2321 120.948C62.1907 121.058 62.1105 121.149 62.0067 121.204C61.8162 121.101 61.6557 120.95 61.5408 120.766C61.196 120.916 60.8741 121.114 60.5844 121.353C60.7101 121.777 61.181 121.268 61.2754 121.192C61.087 121.469 61.3591 122.033 61.1703 122.309C60.828 121.382 60.1374 122.989 60.5071 123.374C60.1245 123.514 59.8481 123.483 59.7356 123.189C59.9443 123.477 59.8068 124 59.7512 124.824L60.2716 124.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2637 131.525C33.5957 131.432 32.7276 130.87 33.6616 130.886C33.4653 131.395 34.0805 131.495 33.4764 131.658C33.6669 132.247 33.9394 131.534 34.0751 131.883C34.1323 131.458 34.0323 131.028 33.7941 130.672C32.7198 131.144 32.9463 129.893 32.6489 129.663C32.4769 130.536 32.5328 129.778 31.6516 130.076C31.3271 130.414 31.9668 130.447 31.5992 130.635C31.7844 131.096 32.1445 130.517 31.8646 130.207C32.292 130.253 33.2601 130.794 32.6236 131.123C32.7187 131.444 33.2227 131.11 33.2623 131.522L33.2637 131.525Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6416 130.358C40.4197 130.24 40.4396 129.733 40.0029 129.96C40.0681 130.092 40.2167 130.092 40.2558 130.265C40.108 130.265 40.0421 130.132 39.8701 130.173C39.4818 130.368 40.3225 130.519 40.6416 130.358Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1952 120.416C65.8857 120.762 66.9208 120.302 66.5286 121.067C66.0695 120.939 66.2123 121.164 65.6246 121.095C65.7745 121.216 65.878 121.385 65.9177 121.573C66.5746 121.091 67.1113 120.536 67.8184 121.132C67.6862 121.702 67.0918 121.061 66.6073 121.413C66.7498 121.542 66.888 121.673 66.6875 121.759C66.9012 122.237 66.8955 121.431 67.1658 121.465C67.496 121.405 67.2959 122.213 66.768 122.104C67.1007 122.311 67.5894 122.892 67.9252 122.382C67.7721 122.232 67.4864 122.296 67.4594 121.944C67.537 122.042 68.4848 120.949 68.6704 121.663C68.4453 120.845 67.1584 120.365 66.1952 120.416Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9445 116.185C67.1997 115.872 66.482 116.778 66.0841 116.799C65.5388 116.767 66.425 116.448 66.0962 116.068C65.5976 116.388 65.6282 116.124 65.2724 116.441C65.1331 116.108 65.1822 115.893 65.4975 115.843C65.2916 115.62 64.883 115.722 64.5532 115.698C64.7206 116.097 64.3249 116.147 64.581 116.602C64.7019 116.452 64.8709 116.348 65.0593 116.309C65.1897 116.736 64.7698 116.818 64.7031 117.12C64.8456 117.388 65.3824 116.671 65.4465 116.401C65.9716 116.566 65.7536 116.981 66.3787 117.277C66.4143 116.807 67.4156 116.938 67.2549 116.345C67.3722 116.35 67.4838 116.397 67.5693 116.478C67.6549 116.558 67.7086 116.667 67.7208 116.783C67.5477 117.214 67.2695 116.758 66.8969 117.157C66.9972 117.254 67.1217 117.322 67.2574 117.355C67.3931 117.387 67.5351 117.383 67.6685 117.342C67.6685 117.49 67.5353 117.556 67.5759 117.728C66.856 116.96 67.4174 118.423 67.5114 119.017C67.6895 118.931 67.5488 118.647 67.7767 118.59C68.5055 119.053 66.835 119.555 68.1903 119.587C68.1903 119.735 68.0571 119.801 68.0977 119.973C67.8446 119.817 67.6159 119.625 67.4188 119.403C67.3312 120.097 67.7967 120.568 68.471 120.797C68.0304 120.475 68.4539 120.376 68.6437 120.757C68.9469 120.765 68.4788 120.116 68.3103 120.106C68.326 119.832 68.5472 120.123 68.8286 119.986C68.6861 119.856 68.5483 119.725 68.7484 119.64C68.6134 119.407 68.601 119.693 68.4029 119.72C68.4788 118.98 69.7458 117.832 68.6523 117.659C68.4952 117.315 68.6644 117.174 68.6644 116.928C68.8279 117.046 68.9002 117.925 69.5962 117.804C69.3743 117.685 69.3946 117.179 68.9575 117.406C68.9454 117.177 69.4206 117.059 69.4758 117.285C69.832 116.699 68.7178 116.458 68.1981 116.49C68.6202 117.172 67.9641 118.135 68.4268 118.258C68.4624 118.427 68.2466 118.441 68.1216 118.511C67.9128 118.53 67.9028 118.23 67.8284 118.033C67.6963 118.098 67.6966 118.247 67.5228 118.286C67.8605 117.64 68.007 116.911 67.9452 116.184L67.9445 116.185Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3031 123.619C66.7025 123.553 67.3547 123.087 67.7412 123.153C67.4078 123.055 67.2365 122.698 67.022 122.409C66.9334 122.967 67.2393 123.452 66.226 123.687C66.2698 123.854 66.4685 123.772 66.6117 123.78C66.5304 123.954 66.5119 124.151 66.5594 124.338C66.8849 124.11 67.1914 123.856 67.4758 123.579C67.3975 123.39 67.2803 123.523 67.3031 123.619V123.619Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8764 122.919C71.9516 123.115 72.2255 122.991 72.4349 122.972C72.3637 122.73 72.2925 122.489 72.4873 122.413C72.0969 121.904 72.4178 123.04 71.8764 122.919Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7682 132.155C29.2802 132.581 30.31 132.523 30.58 132.511C30.5778 132.357 30.4731 132.364 30.3663 132.379C30.3306 132.209 30.5465 132.195 30.6719 132.125C30.4824 131.565 30.0236 132.755 29.7675 132.153L29.7682 132.155Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1364 130.179C35.4402 130.403 35.8466 130.463 35.8954 131.096C36.0622 130.906 36.295 130.787 36.5466 130.762C36.3663 130.425 36.1904 130.459 35.988 130.71C35.9464 130.6 35.9463 130.479 35.9877 130.368C36.0292 130.258 36.1093 130.167 36.2132 130.112C36.0151 129.833 35.8926 130.159 35.6949 130.232C35.3793 129.644 36.5679 129.876 35.8801 129.461C36.3823 129.208 36.2292 130.007 36.8244 129.605C37.0513 130.042 36.5448 130.022 36.4265 130.244C36.7193 130.734 36.8415 129.938 37.0776 129.911C37.0292 129.277 36.367 129.628 36.3186 128.994C35.4156 129.072 35.8616 129.992 35.1371 130.18L35.1364 130.179Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5896 128.963C38.9841 128.792 38.5211 128.836 38.4602 129.59C38.1813 129.722 38.104 129.531 38.0327 129.324C37.8546 129.411 37.9971 129.695 37.7674 129.752C37.9953 130.117 38.8762 129.671 38.551 129.205C39.0447 129.655 39.496 129.804 40.6525 129.628C40.5271 129.16 40.8595 129.213 40.4919 128.937C41.1366 128.809 40.9849 129.087 40.998 129.548C41.2118 129.189 41.621 128.951 41.4483 128.351C41.0045 128.446 41.2673 128.529 41.3557 128.736C41.0508 128.83 40.9421 128.609 40.6244 128.724C40.6194 128.313 41.3838 128.149 40.7694 127.78C40.3305 128.196 40.6953 129.113 39.6295 129.137C40.1774 128.808 39.7136 128.663 40.1994 128.458C39.8433 127.809 39.6192 128.583 39.5886 128.964L39.5896 128.963Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0689 128.651C43.8972 128.61 43.7245 128.57 43.6415 128.386C43.4025 128.521 43.7608 128.591 43.7619 128.904C44.0522 128.888 44.0212 128.671 44.2402 128.611C44.1637 128.422 44.0468 128.555 44.0689 128.651Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4311 123.011C64.8757 123.552 64.4147 123.463 64.4992 124.088C65.5482 123.589 64.1469 122.777 65.6807 122.903C65.2689 122.626 64.8497 122.73 64.4311 123.01V123.011Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8261 121.507C74.9009 121.703 75.1751 121.578 75.3846 121.559C75.4711 121.074 74.5878 120.807 75.3568 120.655C75.3244 120.351 74.9582 120.276 75.2364 120.137C74.4631 119.867 75.4362 121.465 74.8261 121.507Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1593 120.205C74.0107 120.515 75.5887 119.489 75.8872 119.804C76.2548 119.641 75.8095 118.855 75.6464 118.767C75.1477 118.752 75.9591 119.553 75.4612 119.538C75.0743 119.605 75.2175 118.823 75.0476 118.541C74.4652 118.831 75.1256 118.971 75.1156 119.618C74.633 119.651 74.0791 119.176 73.6934 119.766C73.8259 120.118 74.0969 119.41 74.4246 119.779C74.4257 119.977 74.1083 119.976 74.1593 120.205Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4705 118.394C75.975 118.556 75.8489 118.126 75.3535 118.289C75.8133 119.322 76.3555 118.816 76.9888 118.273C76.9001 118.05 76.1962 118.118 76.9086 117.927C76.8083 117.83 76.6838 117.762 76.5481 117.73C76.4124 117.697 76.2705 117.702 76.1371 117.742C76.1806 117.909 76.3797 117.827 76.5229 117.835C76.4416 118.01 76.4231 118.207 76.4705 118.394Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1917 132.439C26.052 132.505 26.0136 132.41 25.9779 132.307C25.564 132.476 26.1233 132.979 26.4438 132.745C26.1838 132.567 26.3135 132.489 26.3235 132.226C26.7801 131.917 26.0161 132.101 26.1917 132.439Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2462 131.86C30.5668 131.837 30.5629 131.615 30.3787 131.646C30.4856 131.32 31.069 131.288 31.3354 131.06C30.9696 130.654 29.7497 131.733 30.2462 131.86Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3374 125.801C56.5913 125.664 56.3587 125.224 56.9482 125.296L56.8681 124.95C56.7285 125.016 56.69 124.92 56.6544 124.817C56.5119 125.123 56.2533 125.356 56.3367 125.801H56.3374Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0494 131.411C29.085 131.58 28.8692 131.595 28.7441 131.664C28.5151 131.676 28.3979 131.201 28.6237 131.146C27.947 130.687 28.4709 132.04 28.8243 132.01C29.2603 131.936 29.2962 131.614 29.6079 131.464C29.5759 131.16 29.2097 131.084 29.4875 130.946C29.3532 130.719 28.7548 131.628 29.0494 131.411V131.411Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8719 130.605C34.8804 130.278 34.9651 129.957 35.1194 129.669C35.2736 129.38 35.493 129.131 35.7603 128.942C35.6074 128.555 35.4603 128.159 34.9086 128.412C35.8874 128.907 34.3939 128.91 34.7515 130.086C34.3241 130.216 34.1488 129.946 33.9401 129.73C33.5422 130.231 34.7145 130.21 34.8719 130.605Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6388 125.587C48.4696 125.622 48.4554 125.406 48.3859 125.281C47.8114 125.81 47.3059 125.767 46.6456 126.414C47.4684 126.651 46.9376 127.628 47.9635 127.383C47.5863 127.276 47.536 126.642 47.2044 126.466C47.1478 126.135 47.748 126.214 47.6023 125.827C48.2791 126.217 48.5971 125.716 49.1172 125.293C49.1079 124.942 48.2716 125.222 48.6388 125.586V125.587Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7876 127.009C48.6597 126.661 48.0175 127.138 47.8433 126.864C47.6428 127.067 48.4791 127.423 48.7876 127.009Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4786 124.444C57.2564 124.551 57.4355 124.91 57.4665 125.175C58.0803 125.065 57.8993 124.459 58.3428 124.243C58.1693 123.732 57.7572 125.021 57.4786 124.444Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2868 121.551C72.7392 121.863 73.0765 120.693 72.4318 120.606C72.1728 120.711 72.6833 121.225 72.2868 121.551Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0443 125.323C55.9043 124.94 55.9349 124.664 56.2295 124.552C55.9004 124.338 55.2834 123.963 54.9397 124.487C55.2143 124.757 55.8847 124.393 55.8302 125.19C55.0038 125.191 55.1994 125.572 56.0443 125.323Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2496 121.792C71.962 121.89 71.4712 121.24 72.0332 121.245C71.3308 120.359 72.1732 120.217 72.3631 119.53C72.7691 119.432 72.9408 119.708 73.4398 119.462C73.0965 118.952 73.9684 119.2 73.6247 118.69C73.0156 118.705 73.141 119.177 72.8813 119.409C72.4674 119.362 72.3086 118.905 71.9908 118.706C71.6304 119.133 72.2908 119.276 72.0589 119.783C71.9555 119.973 71.8046 120.134 71.6208 120.249C71.3419 120.381 71.2646 120.19 71.1933 119.984C70.9118 120.255 70.7377 120.619 70.7028 121.008C71.2923 121.079 71.059 120.639 71.3141 120.502C71.3166 120.656 71.4209 120.649 71.5278 120.634C71.4244 120.825 71.2733 120.986 71.0893 121.101C71.1606 121.653 71.4865 120.545 71.6482 121.153C71.8127 121.551 70.8385 121.24 71.2496 121.792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5527 132.041C25.7575 132.392 26.0514 131.58 26.1226 131.362C26.4688 131.36 26.6434 131.634 27.0669 131.508L26.9465 130.989C26.6562 131.005 26.6868 131.221 26.4681 131.282C26.804 130.68 27.8238 130.132 27.1036 129.314C27.3914 129.405 27.7112 129.445 27.7825 129.883C28.1647 129.482 27.3828 128.962 26.892 129.18C26.8247 129.769 26.9675 129.575 27.1328 130.216C27.1559 130.989 26.0813 130.22 26.2565 131.149C26.0588 131.149 26.0596 130.832 25.8291 130.883C25.5424 130.287 26.1689 132.109 25.4312 131.522C24.8332 131.715 26.1497 131.848 25.5516 132.041L25.5527 132.041Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6669 131.733C27.7852 131.511 28.2917 131.531 28.0648 131.094C27.928 131.237 27.5209 131.644 27.5063 131.041C27.0151 131.275 27.7574 131.372 27.6669 131.733Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0386 127.334C45.0742 127.503 44.8584 127.517 44.733 127.587C44.8951 127.954 45.6812 127.509 45.7695 127.346C45.6197 127.225 45.5161 127.056 45.4764 126.867C45.3403 126.98 45.2025 127.091 45.211 127.295C44.9645 127.133 44.7572 127.33 45.0383 127.335L45.0386 127.334Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.608 129.059C37.2643 129.137 37.2789 128.639 36.8365 128.874L36.9569 129.393C37.187 128.997 37.5093 129.481 37.7808 129.019C37.7024 128.831 37.5852 128.964 37.608 129.059V129.059Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7953 128.269C42.1359 128.136 42.0258 127.723 42.3652 127.59C42.3449 127.269 41.6927 127.735 41.9275 128.056C41.7988 128.04 41.6752 127.995 41.5653 127.927C41.4553 127.858 41.3616 127.766 41.2906 127.657C40.7809 128.046 41.6977 128.077 41.7968 128.268L41.7953 128.269Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3795 124.002C59.3352 124.009 59.2899 123.999 59.2528 123.974C59.2157 123.948 59.1895 123.91 59.1793 123.867C59.1691 123.823 59.1758 123.777 59.198 123.738C59.2202 123.699 59.2563 123.67 59.299 123.656C59.175 123.4 59.0301 123.879 58.9132 123.564C58.6913 123.671 58.8701 124.03 58.9011 124.295C59.279 124.285 59.331 124.071 59.5522 123.962C59.4739 123.774 59.3567 123.907 59.3795 124.003V124.002Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3901 122.838C64.2933 122.599 63.8605 122.898 63.7914 122.613C63.4313 122.777 64.2961 123.3 64.3901 122.838Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7492 130.106C30.3004 130.551 30.2954 130.355 29.7925 130.692C30.1031 130.804 30.7902 130.764 30.7492 130.106Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6151 124.644C56.7766 124.278 56.8707 123.886 56.8926 123.487L56.2016 123.648C56.6614 123.986 56.5339 123.959 56.6151 124.644Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4825 122.452C64.7604 122.639 64.8505 122.417 65.3467 122.252C65.2829 121.988 64.7433 121.794 65.0012 122.332C64.76 122.324 64.6585 122.091 64.4024 122.107C64.1577 122.26 64.4334 122.29 64.6161 122.239C64.6809 122.379 64.5851 122.418 64.4825 122.452Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8794 121.381C70.3802 121.397 70.1476 120.957 70.4902 120.875C70.263 120.424 69.6956 121.566 69.6788 120.517C69.5234 120.521 69.3704 120.556 69.2288 120.62C69.0872 120.684 68.9601 120.776 68.8549 120.891C68.9454 121.102 69.4249 120.997 69.3732 120.77C69.6318 120.83 69.7811 121.065 69.8794 121.381Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3295 130.668C29.0651 130.528 28.2651 130.403 28.2091 130.149C28.9571 129.802 29.6635 129.945 31.1064 129.294C31.2225 129.121 31.0993 128.796 31.3315 128.696C31.2735 128.314 30.7004 128.76 30.4275 128.723C30.5244 128.963 30.9572 128.664 31.0263 128.949C30.4866 129.468 29.7294 128.971 29.4184 129.869C29.1773 129.466 29.7789 129.273 28.6473 129.684C29.3105 129.217 28.2444 129.412 28.6594 128.952C28.0927 128.609 28.4385 130.088 27.8633 130.23C28.0164 130.379 28.3021 130.316 28.3292 130.668H28.3295Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.301 129.331C33.5642 129.529 33.9087 129.263 34.2983 128.918C34.2481 128.602 34.002 128.602 33.9649 128.267C33.8634 129.023 33.7811 128.872 33.301 129.331Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5419 122.721C62.6712 121.527 61.629 122.048 62.5419 122.721V122.721Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1872 124.398C52.1433 124.404 52.0986 124.393 52.0621 124.368C52.0255 124.343 51.9997 124.305 51.9897 124.262C51.9796 124.218 51.9861 124.173 52.0078 124.134C52.0296 124.095 52.065 124.066 52.1071 124.052C51.8107 123.644 51.3879 125.161 52.2677 124.743C52.1929 124.549 52.2346 124.427 52.3604 124.358C52.282 124.169 52.1648 124.302 52.1876 124.398H52.1872Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7231 123.941L55.6027 123.422C55.2939 123.427 55.3078 123.633 55.3374 123.85C55.1682 123.885 55.1543 123.67 55.0841 123.545C54.6535 123.807 55.3274 124.227 55.7231 123.942V123.941Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6236 123.5C57.8876 123.435 57.3479 122.704 57.2101 122.502C56.8293 122.493 57.0003 123.261 57.0776 122.716C57.4466 122.677 57.3009 123.464 57.624 123.5H57.6236Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0586 120.667C57.5133 120.918 57.4146 121.448 57.4755 122.077C56.9661 122.42 57.2137 121.549 56.704 121.892C57.0014 122.205 57.3387 122.454 57.6358 122.768C57.5054 122.188 57.8858 121.454 58.0586 120.667Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5317 121.48C64.7478 120.509 64.2669 121.281 65.5317 121.48V121.48Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3823 124.867C49.446 125.131 49.9857 125.326 49.7278 124.787C50.2927 124.508 50.5321 124.94 50.7646 124.547C50.4879 123.935 49.9048 124.76 49.3823 124.867Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9673 128.68C33.446 128.798 33.6897 127.495 34.3618 127.628C33.9572 126.923 33.7805 126.787 34.0006 126.073C33.3125 126.052 33.8225 127.009 33.217 126.619C32.7896 127.02 34.1321 126.552 33.9362 127.363C33.3705 127.651 33.4051 128.313 32.9673 128.681V128.68Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1016 126.043C45.0015 125.859 44.1292 125.574 44.4105 126.204C44.688 125.836 44.6349 126.169 45.1016 126.043Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1767 125.562C47.6042 124.891 48.5014 124.515 48.5435 123.605C48.0434 124.556 47.3167 124.457 47.1767 125.562Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6113 125.566C35.0006 125.424 34.9012 125.013 34.6234 124.835C34.7851 125.049 35.2945 124.707 35.3949 125.02C35.8309 124.875 35.0886 124.778 35.2343 124.329C35.7136 124.33 36.1867 124.22 36.6166 124.008C36.7484 124.287 36.5575 124.365 36.3513 124.436C36.4581 124.658 36.8172 124.479 37.0826 124.448C36.477 123.956 37.2407 123.835 37.6934 123.942C37.6774 124.216 37.4566 123.925 37.1748 124.062C37.2311 124.446 37.4441 124.579 37.8138 124.46C37.9106 124.227 37.9149 123.965 37.8259 123.729C37.2582 123.49 37.0451 123.584 36.4036 123.877C36.1686 123.347 36.9707 123.496 36.4158 123.146C36.2918 124.164 34.804 123.611 35.1416 124.717C34.4627 124.657 34.3438 125.105 33.7995 125.21C34.0666 125.829 34.3441 124.949 34.6113 125.566Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.022 124.197C34.731 123.952 34.5069 123.6 33.9976 123.706C34.0537 123.809 34.1451 123.889 34.255 123.93C34.365 123.971 34.4861 123.972 34.5963 123.931C34.5151 124.106 34.4966 124.303 34.544 124.49L34.8895 124.41C34.8239 124.27 34.9194 124.231 35.022 124.197Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.537 125.616C38.0193 125.658 37.3807 126.45 37.9509 126.613C38.5529 126.467 37.35 124.703 37.5898 125.058C37.5455 125.064 37.5004 125.054 37.4634 125.029C37.4264 125.004 37.4003 124.965 37.3902 124.922C37.3801 124.878 37.3868 124.832 37.4089 124.793C37.431 124.755 37.467 124.725 37.5096 124.712C36.7481 124.41 37.2346 125.211 37.5374 125.616C37.0003 125.767 36.841 125.311 36.6469 124.912C36.1222 125.369 35.1153 125.715 34.6137 125.567C34.4641 125.72 34.5272 126.006 34.1756 126.033C34.8168 127.118 35.3543 125.587 35.9716 126.71C36.0133 126.648 36.0377 126.576 36.0422 126.501C36.0466 126.427 36.031 126.352 35.997 126.286C35.9629 126.219 35.9117 126.163 35.8486 126.123C35.7855 126.083 35.7128 126.061 35.6382 126.059C35.3924 125.462 36.6693 125.814 36.3416 125.168C36.7894 125.082 36.7452 125.785 37.1933 125.699C37.3397 126.019 36.4649 126.134 36.6348 125.646C36.4168 125.855 36.1472 126.032 36.2786 126.458C36.9319 126.18 36.9981 126.083 37.2631 126.775C37.4854 126.668 37.3059 126.309 37.2752 126.044C37.2752 125.846 37.5915 125.847 37.5406 125.617L37.537 125.616Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.635 125.624C40.1958 125.951 41.1447 126.317 40.8758 126.661C41.6377 126.93 41.1305 125.775 40.635 125.624Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9893 123.948C50.908 124.122 50.8895 124.319 50.937 124.506C51.0577 124.356 51.2266 124.253 51.415 124.213C51.421 123.808 51.0281 124.044 50.9491 123.775C50.7606 123.853 50.8935 123.97 50.9893 123.948Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.772 122.969C55.4544 122.845 55.9517 123.651 56.772 122.969V122.969Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4208 130.301C24.559 130.654 24.9786 129.98 24.8187 129.662C24.1423 129.536 24.8507 130.273 24.4208 130.301Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5938 127.856C32.5874 127.313 33.0016 127.936 33.2852 127.696C33.1351 127.575 33.0316 127.406 32.992 127.217C32.1906 127.591 32.5689 127.82 32.5817 128.588C32.81 128.502 33.2289 127.572 32.5938 127.856Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8689 125.834C43.3049 125.689 42.5622 125.592 42.7082 125.143C42.6398 125.445 42.2202 125.529 42.352 125.954C42.6559 125.922 42.731 125.556 42.8703 125.834H42.8689Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6704 122.546C54.3922 122.745 54.7185 122.867 54.7908 123.064L55.1366 122.984C54.9963 122.513 55.2642 122.33 55.5748 122.518C55.8953 122.217 54.7648 122.256 54.4175 122.241C53.9224 122.542 54.9471 122.296 55.0162 122.466C55.0228 122.51 55.0124 122.555 54.9872 122.592C54.962 122.629 54.9238 122.656 54.8803 122.666C54.8367 122.676 54.7909 122.669 54.752 122.647C54.7131 122.625 54.684 122.589 54.6704 122.546Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5796 128.606C28.3701 128.389 28.2868 127.969 27.7682 128.249C27.9182 128.369 28.0217 128.538 28.0613 128.727C27.531 128.962 27.6802 128.16 27.3301 128.714C27.6649 129.114 28.1735 128.868 28.5796 128.606Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5725 127.779C30.6655 128.111 31.2276 127.245 31.2112 128.177C31.8997 128.213 31.603 127.634 32.1676 127.591C32.1416 127.158 31.7647 127.289 31.7943 126.767C32.3382 126.549 32.3603 127.542 32.7385 126.912C32.2399 126.71 32.3022 126.612 33.0039 126.485C32.824 125.983 32.102 126.351 32.2046 125.396C31.4751 125.48 32.4411 125.799 32.0194 126.167C31.9795 125.839 31.5186 126.011 31.3002 125.424C30.5565 126.228 30.1543 125.826 30.1604 126.782C30.3545 126.707 30.4767 126.748 30.5462 126.874C30.7681 126.767 30.5889 126.408 30.5583 126.143C30.7329 126.224 30.9302 126.243 31.1168 126.195C31.042 126.001 31.0833 125.879 31.2094 125.809C31.4071 125.809 31.4064 126.126 31.6368 126.075C31.6105 126.452 30.7752 126.326 31.1065 126.926C31.6069 126.943 31.3747 126.502 31.7173 126.421C31.7565 126.839 31.5952 127.133 31.8242 127.67C31.2485 127.388 30.6471 127.161 30.0283 126.993C29.6931 127.171 30.4165 127.608 30.8397 127.351C30.7987 127.523 30.7595 127.695 30.5743 127.779L30.5725 127.779Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3315 126.291C40.7919 125.935 39.3903 125.539 40.1675 125.187C39.8747 124.643 39.8262 125.176 39.2635 125.214C39.2524 125.707 39.6984 125.466 39.9021 125.612C40.0649 126.058 38.898 125.675 39.3315 126.291Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3769 124.473C46.3791 124.627 46.4838 124.621 46.5907 124.606L46.9365 124.525C46.3844 124.23 47.2877 123.955 46.736 123.662C46.1159 123.928 46.996 124.206 46.3769 124.473Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7293 119.978C65.5601 120.014 65.5459 119.798 65.4761 119.672C65.0038 120.002 65.6777 120.42 66.1147 120.071C66.0755 119.652 66.2369 119.358 66.0079 118.821C65.9028 118.935 65.7756 119.027 65.634 119.092C65.4925 119.156 65.3394 119.191 65.184 119.194C65.3136 119.54 65.9587 119.058 65.9954 119.551C65.9548 119.722 65.9153 119.895 65.73 119.978H65.7293Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.137 120.58C64.1269 120.357 63.2873 119.903 63.7197 119.169C63.5666 118.925 63.537 119.2 63.5872 119.383C63.1114 119.797 62.7324 118.905 62.6832 119.411C62.369 119.57 63.1676 119.441 63.4946 119.769C63.6513 120.211 62.8556 120.061 63.1384 120.58L63.137 120.58Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2114 120.098C65.1676 119.931 64.9689 120.013 64.8257 120.006C64.748 119.662 65.246 119.677 65.0109 119.234C64.9169 119.697 64.0517 119.173 64.4121 119.009C64.4096 118.855 64.3053 118.862 64.1984 118.877L63.8525 118.957C64.3637 119.242 64.4798 120.164 65.2104 120.096L65.2114 120.098Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7679 123.007C48.7786 123.385 48.9927 123.437 49.1013 123.658C49.1776 123.282 50.2832 123.103 50.4032 122.991C50.7181 123.439 50.5386 122.666 50.3231 122.646C49.8917 123.254 49.4583 123.071 48.7679 123.007Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1981 121.281C56.1407 121.805 55.6788 121.139 55.547 121.615C55.6968 121.735 55.8003 121.904 55.8401 122.093C55.9374 121.759 56.295 121.588 56.5835 121.374C56.441 121.245 56.3028 121.113 56.5034 121.028C55.875 121.021 56.8346 119.661 55.3991 120.192C55.7667 120.468 55.4348 120.415 55.5598 120.883C55.2677 121.382 55.8914 120.579 55.7849 120.285C56.3712 120.391 55.6424 121.128 56.1985 121.282L56.1981 121.281Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6534 128.558C25.6872 129.057 26.5638 128.204 26.5977 128.702C27.1074 128.379 26.317 128.248 25.9989 128.477C26.1023 128.287 26.2532 128.126 26.437 128.011C27.2834 127.904 25.8062 128.014 25.4928 127.866C25.605 128.003 25.7161 128.14 25.9202 128.131C25.8796 128.303 25.8404 128.476 25.6548 128.559L25.6534 128.558Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9046 128.45C27.264 128.897 27.4289 128.005 27.902 128.036C27.5814 127.789 27.6526 127.68 28.1673 127.609C28.4124 127.455 28.1367 127.426 27.9536 127.476C27.5846 127.515 27.7303 126.728 27.4072 126.692C27.2863 126.842 27.1173 126.946 26.9288 126.986C27.8193 127.074 27.7342 128.232 26.9043 128.448L26.9046 128.45Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6324 128.049C28.689 128.156 29.8645 127.144 29.2557 126.811C29.1685 127.001 29.4121 127.507 28.512 127.53C28.5448 127.834 28.9109 127.91 28.6324 128.049V128.049Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.354 124.416C40.0284 124.51 40.6411 125.027 40.7273 125.239C40.5877 125.305 40.5492 125.21 40.5136 125.107C40.5104 125.868 41.1903 124.75 40.3529 124.416H40.354Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6681 124.97C43.2202 124.898 42.1131 124.573 42.7204 124.411C42.6421 124.223 42.5249 124.356 42.5477 124.451C42.408 124.517 42.3696 124.422 42.334 124.319C41.8438 124.612 42.6396 124.734 42.6674 124.97L42.6681 124.97Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5674 124.529C43.7407 123.955 43.3695 124.879 44.5674 124.529V124.529Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9842 123.553C48.1192 123.792 48.1893 123.433 48.5024 123.432C48.1901 122.235 48.0821 122.997 47.9842 123.553Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4805 122.923C51.617 122.811 51.7544 122.7 51.7459 122.496C51.9404 122.421 52.0622 122.462 52.1316 122.588C52.5395 121.822 51.2875 122.254 51.4805 122.921V122.923Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6738 128.654C22.7873 129.183 23.5139 129.636 23.6738 128.654V128.654Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0689 121.907C55.1465 120.565 54.2596 121.465 55.0689 121.907V121.907Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3953 114.536C77.3765 114.327 77.6764 114.317 77.8737 114.243C77.4694 114.101 77.2707 113.63 76.809 113.58C76.6886 113.406 77.2682 114.419 77.1702 115.135C76.6609 115.478 76.9084 114.607 76.3987 114.95C76.5113 115.086 76.6224 115.224 76.8261 115.215C76.8261 115.362 76.6929 115.429 76.7335 115.601C76.6162 115.596 76.5046 115.549 76.419 115.468C76.3335 115.388 76.2798 115.279 76.2676 115.163C75.9232 115.711 75.8576 116.044 76.2028 116.452C76.9433 115.517 76.9234 116.527 77.8381 116.437C77.7729 116.305 77.6244 116.305 77.5848 116.132C77.5492 115.962 77.7651 115.948 77.8901 115.879C77.6557 115.639 77.3369 115.588 77.1588 115.867C76.7766 115.234 77.6457 115.381 77.2635 114.749C77.6333 114.631 77.8462 114.763 77.9022 115.147C78.3706 115.475 77.7779 114.322 77.3953 114.536Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8676 123.448C47.0561 123.37 46.9232 123.253 46.8274 123.275C47.4447 122.809 46.7683 122.867 47.3179 122.251C47.211 122.029 46.852 122.208 46.5866 122.239C46.7291 121.982 46.6546 121.849 46.3337 121.934C47.0899 122.472 46.4965 122.949 46.868 123.448L46.8676 123.448Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5437 124.038C43.8361 123.728 43.7506 123.183 43.7812 122.708C43.2113 122.834 42.5752 123.065 42.4512 122.471C42.2844 122.661 42.0516 122.78 41.8001 122.804C41.8713 123 42.4719 122.945 42.6906 123.508C42.79 123.176 43.0649 122.953 43.647 122.921C43.6313 123.306 43.3331 123.514 43.5422 124.038L43.5437 124.038Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1515 128.36C24.009 128.231 23.8708 128.1 24.0714 128.014C23.9182 127.865 23.6325 127.928 23.6055 127.576C23.313 127.688 23.7586 128.568 24.1519 128.36H24.1515Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5366 120.374C58.3425 119.535 57.8356 120.1 57.5122 119.883C57.2565 120.082 58.0216 120.628 58.5366 120.374Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.055 120.253C59.4543 120.107 58.7544 119.83 58.5891 119.815C58.5154 119.379 59.1626 119.628 59.2801 119.654C59.5205 119.573 58.6087 119.137 59.4653 118.883C58.7476 118.304 59.273 119.738 58.3362 119.51C58.4099 120.024 58.7992 120.03 59.0554 120.253H59.055Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.83 118.447C66.9425 117.844 65.8989 118.542 65.1947 118.463C65.334 119.07 66.4852 118.176 66.83 118.447Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8716 116.215C74.9375 116.355 74.842 116.393 74.7391 116.429C75.1708 116.969 75.1783 115.87 74.6589 116.083C74.3494 115.627 74.5342 116.392 74.8726 116.216L74.8716 116.215Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4026 125.847C33.5376 126.086 33.6078 125.728 33.9209 125.727C33.444 125.007 33.574 125.134 33.4026 125.847Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6851 122.248C49.4083 121.729 48.8733 121.794 49.0585 121.118C48.4679 121.095 48.9541 121.743 48.4886 121.797C49.0204 121.656 49.0785 122.04 49.6851 122.248Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.273 121.232C53.0375 120.701 53.8397 120.851 53.2851 120.501C53.1839 120.969 52.733 121.406 52.2878 120.914C51.9398 121.049 52.6528 121.322 52.0626 121.513C52.5068 122.002 53.0208 120.908 53.4849 121.365C53.7296 121.212 53.4539 121.182 53.2712 121.232L53.273 121.232Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.927 116.07C73.7179 116.089 73.708 115.789 73.6339 115.592C73.2438 115.126 73.6556 116.376 73.7019 116.669C73.7578 116.26 74.2647 116.133 74.1924 115.645C74.5304 115.734 75.1185 115.423 75.1765 115.962C75.2738 115.629 75.6314 115.458 75.9199 115.243C75.4423 114.819 75.1228 115.864 75.2813 114.845C74.9764 114.939 74.8677 114.718 74.55 114.833C75.2759 115.51 74.5678 115.221 73.9391 115.339C74.0332 115.644 73.8123 115.752 73.927 116.07Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8755 119.465C60.6803 119.412 59.9034 118.747 60.1442 119.452C60.4491 119.36 60.5578 119.581 60.8755 119.465Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.49 122.211C47.625 122.45 47.6952 122.091 48.0083 122.09L47.8879 121.572C47.3785 121.916 47.6261 121.044 47.1164 121.387C47.1363 121.833 47.7312 121.783 47.49 122.211Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6333 117.997C65.3597 117.528 64.9857 118.095 64.8618 117.812C64.4867 118.032 65.493 118.52 65.6333 117.997Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9595 123.514C38.3271 123.79 37.9951 123.737 38.1202 124.205C38.3695 124.356 38.7763 124.259 39.1969 124.137C39.1221 123.943 39.1635 123.821 39.2896 123.752C38.8318 123.953 38.5252 124.049 37.9595 123.514Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7114 123.603C39.8362 124.349 42.2074 122.486 40.804 123.218C40.6003 123.323 40.8272 123.504 40.7114 123.603Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9135 119.658C56.8082 119.687 56.6959 119.678 56.5969 119.632C56.4979 119.586 56.4187 119.505 56.3735 119.406C56.3284 119.306 56.3204 119.194 56.3509 119.089C56.3814 118.984 56.4484 118.894 56.5398 118.834C56.7485 118.815 56.7589 119.115 56.833 119.312C57.0777 119.022 57.4292 118.797 57.3234 118.287C57.2203 118.344 57.1408 118.435 57.0995 118.545C57.0582 118.655 57.0578 118.776 57.0983 118.886C55.9585 118.247 56.2335 119.323 55.676 119.034C55.6048 119.614 56.2816 119.578 56.6481 120.083C56.9907 120.001 56.7582 119.561 57.259 119.578C57.245 119.535 57.2158 119.5 57.1771 119.478C57.1384 119.457 57.0929 119.45 57.0497 119.46C57.0064 119.47 56.9685 119.496 56.9433 119.533C56.9181 119.569 56.9075 119.614 56.9135 119.658Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2986 116.913C70.2797 116.705 70.1889 116.615 70.0453 116.608C70.0097 116.439 70.2259 116.424 70.3509 116.355C70.3456 115.328 69.3628 115.728 69.6439 114.88C69.9769 114.966 70.7687 114.782 69.9897 114.8C69.9826 114.45 70.6277 114.508 70.3459 113.988C70.6309 114.561 71.2468 114.598 71.9289 114.531C71.7508 114.892 71.8619 114.962 72.3563 114.796C72.3514 114.913 72.3044 115.025 72.224 115.11C72.1435 115.196 72.035 115.25 71.9182 115.262C72.0696 115.81 72.4881 115.931 73.1154 115.712C72.8243 115.167 72.7235 115.782 72.3442 115.527C72.4621 115.249 72.6459 115.535 72.782 115.061C73.3134 114.949 73.8295 115.486 74.2046 114.913C73.7579 114.682 72.965 115.005 72.5305 114.756C72.8097 113.659 72.0247 115.032 71.8117 114.012C71.2382 114.196 70.8318 114.601 70.6548 113.735C70.5005 113.806 70.3287 113.83 70.1609 113.804C69.993 113.778 69.8364 113.704 69.7105 113.59C69.4968 113.703 69.5096 113.957 69.2724 114.056C69.4224 114.177 69.5261 114.346 69.5655 114.534C69.6865 114.384 69.8556 114.28 70.0442 114.241C69.8305 114.503 69.7376 114.838 69.3005 114.96C69.5238 115.142 69.7839 116.242 68.8503 116.157C68.8902 116.568 69.3938 116.233 69.4889 116.555C69.6471 116.354 69.3881 116.171 69.6738 115.784C70.6291 115.842 69.282 116.955 70.3007 116.913L70.2986 116.913Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9096 116.407C71.1116 116.479 71.1807 116.764 71.5084 116.632C71.5921 116.024 70.9185 116.63 71.0022 116.022C70.5727 116.112 70.9802 117.31 70.9096 116.407Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0916 125.706C30.6683 125.188 30.1942 123.854 30.3691 124.549C30.2979 124.751 30.0129 124.82 30.144 125.148C29.6453 125.397 29.5666 124.97 29.0672 125.216C29.4255 125.578 30.0204 125.192 29.7864 125.959C29.9153 125.817 30.0467 125.679 30.1319 125.879C30.3203 125.801 30.1874 125.684 30.0916 125.706V125.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6521 118.093C64.0838 117.828 63.1673 117.798 63.146 117.481C63.2318 117.082 64.206 116.477 63.1182 116.578C63.51 116.707 63.2133 117.183 62.9857 116.791C62.6722 116.892 63.0156 117.401 62.8005 117.563C62.5469 117.416 62.373 117.142 61.8562 117.418C62.0054 117.653 62.2124 117.794 62.3624 118.029C62.8746 117.585 63.2724 117.74 63.6521 118.094V118.093Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.396 122.616C43.3935 122.461 43.2891 122.468 43.1823 122.483C42.7114 122.275 43.3942 121.541 43.2069 121.02L42.3431 121.221C42.4179 121.417 42.6918 121.292 42.9016 121.273C43.0405 121.819 42.4838 122.852 43.3953 122.615L43.396 122.616Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5173 120.729C51.8956 120.718 51.9473 120.505 52.1685 120.396C52.1545 120.354 52.1253 120.318 52.0866 120.297C52.0479 120.275 52.0024 120.269 51.9592 120.279C51.9159 120.289 51.878 120.314 51.8528 120.351C51.8276 120.388 51.8169 120.432 51.8229 120.476C51.6513 120.435 51.4785 120.396 51.3955 120.211C51.1572 120.346 51.5163 120.416 51.5173 120.729Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0005 126.524C25.2651 126.956 25.2954 126.04 25.6113 126.018C25.3937 125.616 25.1444 126.396 25.0005 126.524Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2053 122.991C40.3667 123.599 40.6912 122.492 40.7638 123.043C40.9918 122.926 40.7083 122.735 40.5106 122.738C40.5919 122.563 40.6104 122.366 40.5629 122.179C40.7485 122.247 41.2939 122.433 41.041 121.886C41.2316 121.989 41.3922 122.14 41.5072 122.324C41.8887 122.266 41.4431 121.693 41.4794 121.42C41.0826 121.862 40.2958 122.061 40.1259 122.645C40.2146 122.869 40.9184 122.8 40.206 122.991H40.2053Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3681 121.711C43.4842 122.237 44.0744 122.001 44.5254 121.989C44.4251 121.892 44.3006 121.823 44.1649 121.791C44.0292 121.758 43.8873 121.763 43.7539 121.804C43.688 121.664 43.7834 121.626 43.8864 121.59C43.7514 121.352 43.6809 121.711 43.3681 121.711Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7642 120.64C48.6983 120.501 48.7938 120.462 48.8967 120.426C48.5583 120.12 48.574 120.693 48.8443 120.985C49.0632 120.915 49.2501 120.769 49.3716 120.574C49.4931 120.379 49.5413 120.147 49.5076 119.92C49.1639 119.998 49.1785 119.5 48.7361 119.735C48.725 120.227 49.171 119.984 49.3747 120.133C49.4043 120.448 49.1695 120.597 48.7642 120.64Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8039 123.668C31.6992 124.237 31.1375 124.154 30.767 123.908C30.3991 124.362 31.7775 124.01 31.6988 124.784C32.0657 124.276 32.1081 123.989 32.8279 124.158C33.1788 123.81 31.9489 124.009 31.8039 123.668Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6137 118.352C58.7302 118.179 58.6066 117.854 58.8389 117.754C58.7217 117.526 58.5311 117.809 58.5333 118.007C58.3619 117.966 58.1888 117.927 58.1058 117.742C57.5359 118.768 57.4401 118.624 58.612 118.352H58.6137Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6355 116.025C68.4958 116.091 68.4574 115.996 68.4218 115.892C68.0217 116.569 69.7546 115.821 68.6871 115.465C68.4912 115.54 68.6159 115.814 68.6348 116.023L68.6355 116.025Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5485 125.336C28.6695 125.186 28.8384 125.082 29.0269 125.043C28.6671 124.75 27.9497 125.032 27.7891 124.42C27.3218 124.687 27.6551 124.723 27.777 125.151C27.9704 124.819 28.5043 124.779 28.5481 125.336L28.5485 125.336Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6357 124.556C25.6275 124.797 25.3946 124.898 25.4106 125.155C25.1695 125.146 25.0683 124.913 24.8119 124.929",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1088 125.821C24.947 125.39 25.6729 125.983 26.0497 125.552C25.7199 125.454 25.4143 125.127 25.6764 124.728C26.1039 124.599 26.2791 124.868 26.4879 125.086C26.8084 125.066 26.3429 124.413 26.022 124.648C26.1163 124.263 26.1491 123.841 26.5124 123.624",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4502 125.327C25.4007 125.835 24.8539 125.211 24.4133 125.568L25.4502 125.327Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0864 125.311C27.3261 125.214 27.0269 124.781 27.3115 124.713C27.2554 124.609 27.1641 124.53 27.0541 124.489C26.9442 124.447 26.823 124.447 26.7128 124.487C26.6469 124.348 26.7423 124.309 26.8453 124.274C26.1703 124.037 27.0205 124.953 27.0861 125.31L27.0864 125.311Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0933 123.734C33.2431 123.766 33.3983 123.765 33.5477 123.731C33.697 123.696 33.8369 123.629 33.957 123.533C33.1438 123.154 33.8284 122.771 33.8088 122.111C33.36 121.965 33.2628 122.707 33.1178 122.272C33.0487 122.595 33.6055 123.092 33.0933 123.734Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7103 121.217C45.1185 120.921 43.978 121.155 43.7661 121.073C43.2856 120.79 44.2117 121.575 44.7103 121.217Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8203 120.495C48.0087 120.417 47.8758 120.299 47.78 120.322C47.8242 120.002 48.1523 120.122 48.1658 120.414C48.3439 120.328 48.2014 120.044 48.4312 119.989C47.3569 119.906 47.6586 119.034 47.2461 118.807C47.0502 118.882 47.1749 119.156 47.1937 119.365C47.066 119.581 46.9334 119.794 46.7959 120.004C46.9216 120.428 47.3928 119.919 47.4869 119.843C47.5617 120.038 47.52 120.16 47.3943 120.229C47.4805 120.407 47.7651 120.265 47.8217 120.494L47.8203 120.495Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9424 116.204C63.7999 115.385 63.324 116.584 63.1306 115.848C62.9693 115.402 64.1361 115.784 63.7005 115.169C62.8457 115.227 62.763 115.767 62.9048 116.447C63.2428 115.803 63.667 116.747 63.9417 116.206L63.9424 116.204Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2687 116.028C67.0114 116.481 67.2643 115.374 67.4905 115.016C67.3035 114.63 66.6484 115.1 67.1849 115.269C67.0676 115.264 66.956 115.217 66.8705 115.136C66.785 115.056 66.7312 114.948 66.719 114.831C66.6549 114.439 67.2063 114.954 67.5827 114.63C67.7078 115.053 67.8096 115.461 67.4378 115.575C67.5991 116.182 67.9236 115.076 67.9963 115.627C68.3229 115.531 67.659 115.096 67.7555 114.59C67.072 114.56 66.3663 114.099 65.9874 114.819C66.1273 115.555 66.252 114.754 66.5056 114.699C66.9979 115.547 65.6507 115.251 65.8826 115.936C66.0686 115.707 66.4803 115.619 66.6663 115.39C66.8351 115.354 66.8493 115.57 66.9195 115.695C66.9209 115.942 66.5206 115.938 66.2687 116.028Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9155 123.38C29.6356 123.18 29.1454 124.08 28.7985 123.275C28.8263 124.165 28.1125 123.713 28.1752 124.512C28.8106 124.528 29.1853 123.933 29.9155 123.38Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7825 123.592L29.9029 124.111C30.3136 124.071 29.9788 123.567 30.3008 123.472C30.1658 123.233 30.0956 123.592 29.7825 123.592Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3617 123.722C32.5287 123.678 32.4464 123.479 32.4543 123.336C32.6235 123.3 32.6374 123.516 32.7075 123.642L33.053 123.561C32.9871 123.421 33.0826 123.383 33.1855 123.348C33.0855 123.034 32.5757 123.377 32.414 123.162C32.429 122.949 32.6164 122.653 32.7197 122.91",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0735 113.606C67.9844 113.944 67.6218 114.112 67.1171 114.192C66.8154 113.465 67.4929 114.252 67.3825 113.765C67.3066 113.57 67.0658 113.64 66.8239 113.712C66.8442 113.922 66.9664 114.196 66.7716 114.271C66.7162 114.167 66.6248 114.087 66.5146 114.046C66.4045 114.004 66.2829 114.004 66.1728 114.046C66.1372 113.062 64.6016 113.196 65.6385 112.531C65.3208 112.645 65.2111 112.424 64.9073 112.518C64.7737 112.928 64.3708 112.954 63.7379 112.972C63.8871 112.884 63.7906 112.468 63.6175 112.454C63.3486 112.533 63.5844 112.926 63.1794 112.92C62.6914 112.081 62.6782 112.164 62.2073 111.871C62.1364 111.717 62.1124 111.545 62.1381 111.377C62.1639 111.21 62.2384 111.053 62.3523 110.927C62.742 111.329 63.0604 111.846 63.6702 111.895C63.6304 111.707 63.5269 111.538 63.3771 111.417C63.8045 111.287 63.9797 111.557 64.1885 111.773C64.0631 111.845 63.8486 111.857 63.8828 112.027C64.056 111.986 64.1208 112.119 64.2686 112.119C64.721 111.579 64.3327 112.565 65.2129 112.264C65.0629 111.952 64.6465 112.066 64.6668 111.481L65.0123 111.4C65.1192 111.385 65.2228 111.378 65.226 111.533C65.101 111.604 64.8862 111.617 64.9204 111.786C65.0936 111.746 65.1587 111.878 65.3062 111.879C65.2207 111.431 65.8854 111.451 66.0496 111.16C66.3067 111.763 65.2759 111.565 65.3461 112.05C65.5433 112.273 65.7721 112.465 66.025 112.62C65.8683 112.093 67.163 111.926 67.8455 111.833C67.4537 112.047 68.5518 112.887 67.781 113.123C67.7917 112.579 67.0747 113.077 67.0498 113.111C67.4359 112.965 67.3575 113.565 67.6884 113.509C68.4055 113.076 68.9971 113.272 69.2557 112.416C69.3625 113.025 68.9351 113.3 68.6323 113.654C68.9077 113.607 69.2261 113.491 69.2307 113.879C68.9632 113.958 68.6252 113.995 68.793 114.345C69.0516 113.909 69.2813 114.356 69.4316 114.743C68.9465 114.615 69.0494 115.551 68.7809 115.076C69.4737 114.476 67.9538 114.15 68.0742 113.601L68.0735 113.606ZM66.7434 113.368C67.2232 112.314 65.6898 112.911 66.7434 113.368V113.368Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6661 113.436C64.8172 113.09 64.6879 114.243 64.0988 114.529C64.5583 114.805 64.9971 113.816 65.3206 113.516C65.6411 113.56 65.5207 113.888 65.2279 113.902C65.3975 114.316 66.05 113.85 65.6661 113.436Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9038 121.706C37.8992 121.397 37.6933 121.411 37.4764 121.441C37.5576 121.266 37.576 121.069 37.5287 120.882C37.0739 121.924 36.3764 120.71 35.8008 121.284C35.866 121.762 36.0344 122.22 36.2945 122.626C36.4726 122.539 36.3301 122.255 36.5599 122.198C36.4228 121.944 35.9821 122.177 36.0537 121.587C36.4616 121.276 36.6924 122.315 36.572 121.467C37.0881 121.429 37.2545 121.953 37.902 121.705L37.9038 121.706Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1043 117.327C59.2379 117.136 58.5017 116.608 59.2091 116.21C59.8256 116.087 58.9747 116.867 59.5022 116.689C60.2203 116.576 59.4174 116.456 59.5143 115.957C59.3202 116.032 59.1984 115.991 59.1289 115.865C58.9904 116 58.9786 116.406 58.8233 116.118C58.6007 116.324 58.7025 116.732 58.6783 117.062C58.85 117.103 59.0228 117.142 59.1058 117.328L59.1043 117.327Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7515 113.744C73.3508 113.964 74.5733 113.901 74.2299 113.45C73.9393 113.467 73.9702 113.683 73.7515 113.744Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0505 120.743C42.3629 121.359 43.206 120.015 43.1675 120.847C43.5508 120.435 42.5684 120.016 43.6982 119.996C42.9449 119.303 42.8957 120.9 42.0505 120.743Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7329 119.322C49.2154 119.013 49.9164 118.94 49.7052 118.418C49.454 118.51 49.0295 119.556 49.7329 119.322Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.137 122.367C30.7944 122.449 31.0266 122.89 30.5261 122.873C30.3958 122.445 30.8154 122.363 30.8823 122.061C30.5347 121.712 30.5828 122.848 29.7532 122.688C30.1096 123.051 30.5475 123.324 31.0305 123.484C30.5115 123.287 31.1691 122.813 31.2033 123.443L31.5488 123.363C31.4829 123.224 31.5783 123.185 31.6816 123.15C31.386 122.705 30.9468 123.093 31.1352 122.366L31.137 122.367Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7125 119.246C48.1043 119.681 48.4064 119.305 48.7494 119.005C48.53 118.737 47.9658 118.554 48.8018 118.447C48.7519 118.132 48.5054 118.131 48.4684 117.795C48.4257 117.809 48.3898 117.838 48.3677 117.877C48.3455 117.916 48.3389 117.962 48.349 118.005C48.3591 118.049 48.3852 118.087 48.4222 118.112C48.4591 118.137 48.5042 118.148 48.5485 118.141C48.327 118.545 47.8892 118.814 47.7125 119.245V119.246Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1491 124.022C27.5591 124.297 26.8787 123.508 27.1213 123.117C26.8007 123.212 27.1341 123.717 26.7234 123.756C26.81 123.934 27.0942 123.792 27.1509 124.022H27.1491Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.75 119.437C43.7546 119.746 43.9605 119.732 44.1774 119.702C44.2522 119.897 44.2109 120.019 44.0848 120.088C44.0873 120.242 44.1917 120.236 44.2985 120.221L44.644 120.14C44.5254 119.715 44.196 119.681 44.4435 119.277C44.166 119.008 44.3862 119.708 43.7525 119.437H43.75Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7999 118.014C54.1234 117.478 53.0231 117.271 53.8647 116.724C53.7501 116.239 53.489 117.245 53.4373 116.459C53.2012 116.486 53.079 117.282 52.7862 116.792C52.2765 117.116 53.0672 117.246 53.385 117.017C53.3739 117.185 52.876 117.747 52.7338 117.351C52.1639 117.769 53.1969 117.516 53.0672 118.002C53.2635 117.927 53.1385 117.653 53.1196 117.443C53.4858 117.408 53.5716 117.825 53.7985 118.013L53.7999 118.014Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5278 117.612C54.8753 117.541 55.2073 117.002 54.6762 117.082C54.6914 117.175 54.7265 117.265 54.7792 117.344C54.8319 117.423 54.9009 117.49 54.9815 117.54C55.0622 117.591 55.1527 117.623 55.2469 117.635C55.3411 117.648 55.4369 117.64 55.5278 117.612Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.113 116.183C60.1782 116.315 60.3267 116.315 60.3659 116.489L60.7114 116.409C60.4051 116.213 60.4517 115.892 60.9365 115.81C60.4628 114.899 60.1668 114.614 60.1493 113.989C59.5018 114.423 59.9801 115.23 60.6434 115.332C60.4991 115.635 60.6737 116.138 60.113 116.183Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3998 115.834C62.5519 116.155 62.7916 114.522 63.1029 114.944C63.4178 115.391 63.2383 114.618 63.0228 114.598C62.4287 114.808 62.6584 114.958 62.3998 115.834Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3007 115.393C64.5906 115.706 64.7637 114.709 65.2168 114.633C64.7837 114.185 64.8015 115.248 64.0474 115.087C63.7625 115.295 64.1942 115.249 64.4332 115.18C64.4991 115.319 64.4036 115.358 64.3007 115.394V115.393Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2902 119.393C46.5592 119.869 46.4559 118.932 46.9414 119.06C46.2575 118.826 46.8345 118.791 47.1665 118.461C46.6589 117.65 47.9455 117.512 47.191 116.999C47.094 117.099 47.0257 117.224 46.9932 117.359C46.9606 117.495 46.9651 117.637 47.0062 117.77C46.5788 117.663 46.0067 117.793 45.809 117.32C45.3367 117.584 46.0416 117.852 46.0095 118.183C46.4687 117.599 46.0911 118.729 46.7006 118.023C46.8698 117.987 46.8836 118.203 46.9535 118.328C46.817 118.578 46.4573 118.571 45.9166 118.569C46.0665 118.69 46.17 118.859 46.2097 119.048C45.9048 119.142 45.7962 118.921 45.4785 119.035L45.5989 119.554C45.7659 119.51 45.6836 119.311 45.6915 119.168C45.7467 119.205 45.809 119.23 45.8744 119.242C45.9399 119.254 46.0071 119.253 46.0718 119.238C46.1366 119.223 46.1977 119.194 46.2511 119.155C46.3045 119.115 46.3493 119.065 46.3825 119.007C46.4573 119.202 46.4156 119.324 46.2899 119.393H46.2902Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1085 118.626C44.7784 118.341 45.1333 118.562 45.1732 119.289C45.3869 119.176 45.3741 118.922 45.6113 118.823C45.3203 118.579 45.0963 118.227 44.5869 118.333",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4898 123.114C29.8104 123.094 29.3448 122.441 29.0239 122.676C29.0175 123.081 29.4107 122.845 29.4898 123.114Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3698 120.191C37.4991 120.925 36.7999 120.217 36.7999 120.87C36.7147 120.67 36.5833 120.808 36.4544 120.95C36.4544 120.637 36.095 120.567 36.334 120.432C36.5723 120.618 37.4795 119.971 37.383 119.46C37.1643 119.52 37.1949 119.737 36.9046 119.753L37.3698 120.191ZM38.022 119.857L37.6765 119.938L38.022 119.857Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5085 123.21C27.2453 123.719 28.0966 122.939 28.5454 122.97C28.258 122.523 27.8227 123.188 27.5085 123.21Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1667 121.299C34.5168 121.133 34.5532 121.47 34.6326 121.737C34.8107 121.651 34.67 121.367 34.8979 121.31C34.8419 121.207 34.7505 121.127 34.6406 121.086C34.5306 121.044 34.4094 121.044 34.2992 121.085",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1476 113.124C70.3638 113.889 71.2493 112.177 70.1476 113.124V113.124Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0729 121.704C30.0661 121.292 28.8372 121.668 29.2614 121.346C29.1264 121.107 29.0563 121.466 28.7432 121.466C28.8782 122.188 29.3106 122.067 28.5177 122.065C28.3987 122.809 29.2778 121.951 29.3295 122.421C29.5514 122.314 29.3722 121.955 29.3416 121.69C29.5998 121.75 29.7491 121.985 29.8477 122.301C30.1063 121.904 29.9108 121.953 30.4989 121.968C30.4412 121.934 30.391 121.89 30.3513 121.836C30.3117 121.783 30.2834 121.722 30.2684 121.657C30.2533 121.592 30.2517 121.525 30.2637 121.459C30.2758 121.394 30.3011 121.332 30.3382 121.277C30.6335 121.594 31.1051 121.627 31.27 122.153",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6061 112.735C73.0991 112.599 72.735 111.929 73.3096 111.845C73.2344 111.649 72.9605 111.774 72.7511 111.793C73.1528 112.386 72.3532 112.234 72.6061 112.735Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2953 123.077C27.5119 122.496 28.1381 122.731 28.4248 122.451C28.226 122.137 27.8567 122.097 27.4403 122.133C28.0013 123.193 25.8609 121.936 27.2953 123.077Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6679 114.321C51.8286 113.851 52.7009 113.298 52.038 112.778C51.6793 112.804 51.9875 114.306 51.6402 113.417C51.4599 113.712 51.4656 114.356 51.7082 114.493C51.0877 114.54 50.9459 113.819 50.298 113.91C50.3262 114.146 51.0286 114.418 50.6314 114.561C50.8295 114.84 50.952 114.513 51.1497 114.441C51.3171 114.841 50.9214 114.89 51.1775 115.345C50.8466 114.98 50.807 115.318 50.5787 115.12C50.2058 115.433 51.2134 115.502 51.2979 115.863C51.2362 116.099 50.3718 115.629 49.7025 116.051C49.8059 115.861 49.9568 115.7 50.1406 115.585C48.6666 115.361 49.5076 117.651 48.8141 117.715C48.9401 117.829 49.0967 117.903 49.2645 117.929C49.4324 117.955 49.6041 117.931 49.7584 117.86C49.2098 117.28 49.6847 116.956 49.9956 116.53C50.1985 116.644 50.3747 116.801 50.5125 116.988C50.6504 117.176 50.7468 117.391 50.7953 117.619C51.035 117.522 50.7358 117.089 51.0204 117.02C50.6927 116.835 50.318 116.724 50.1299 116.317C49.9646 116.608 49.3388 116.612 49.1735 116.903C49.1425 116.539 49.5625 116.456 49.5297 116.091C50.1141 116.216 50.6666 116.46 51.1529 116.807C51.4621 116.409 51.9575 116.126 51.9486 115.53C51.6722 115.897 51.7253 115.565 51.2576 115.69C51.6494 115.192 52.0021 113.893 52.9175 114.212C53.2851 114.05 52.8398 113.263 52.6767 113.175C53.0649 112.452 53.7987 112.816 54.2439 112.083C54.2585 111.584 53.4578 112.395 53.4724 111.897C53.1939 112.096 53.5205 112.218 53.5928 112.416",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.023 112.193C70.3463 112.226 71.8362 112.104 71.8344 112.549C71.9314 112.448 71.9997 112.324 72.0322 112.188C72.0647 112.053 72.0603 111.911 72.0193 111.777C71.2916 112.079 72.0788 111.402 71.5919 111.512C71.1181 111.211 72.2401 112.263 71.022 112.191L71.023 112.193Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9091 114.905C61.2257 114.757 60.8902 114.204 61.479 114.226C61.4042 114.03 61.1303 114.155 60.9205 114.174C61.0145 114.478 60.7937 114.587 60.9084 114.905H60.9091Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6504 119.447C36.6479 119.293 36.5435 119.3 36.4367 119.314L36.0912 119.395C36.1567 119.527 36.3049 119.526 36.3444 119.7",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.892 115.242C58.0829 115.016 58.1228 114.696 58.4619 114.563C58.4594 114.409 58.3551 114.416 58.2482 114.431L57.9027 114.511C57.9967 114.816 57.7759 114.925 57.8906 115.242H57.892Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1521 122.069C26.4118 121.63 26.5902 122.161 26.9233 122.253C27.4975 121.773 27.5783 121.755 28.3057 121.933",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2241 121.587C27.5189 121.606 27.2866 121.616 26.882 122.081L28.2241 121.587Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4647 112.139C70.8683 111.92 70.0373 111.753 70.0914 111.316C69.7644 111.287 69.1247 111.761 69.0146 111.384C68.6634 111.393 68.9434 112.23 69.3078 111.862C69.3434 112.031 69.1276 112.045 69.0022 112.115C69.5333 112.359 69.9051 111.286 70.4651 112.14L70.4647 112.139Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.156 111.979C71.7541 111.787 70.4379 111.654 71.0356 111.461C71.0331 111.307 70.9288 111.314 70.8219 111.328L70.4764 111.408C70.4536 111.999 71.1015 111.513 71.156 111.979Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.142 115.567C54.8188 115.931 54.526 114.433 55.7495 114.647C55.607 114.518 55.4688 114.386 55.6694 114.302C55.6533 113.846 54.9238 114.983 54.8978 114.116C54.5976 114.57 54.6592 115.249 54.142 115.567Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2928 115.017C58.0739 114.447 56.5348 114.675 57.0117 113.806C56.6007 113.845 56.9355 114.349 56.6139 114.445C56.7613 114.761 57.3156 114.425 57.2928 115.014V115.017Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6835 113.552C59.8288 113.988 59.9257 113.245 60.3745 113.391C60.2249 113.078 60.1391 112.662 59.6956 112.821C59.7458 113.106 60.1587 113.506 59.7757 113.167C59.5873 113.245 59.7202 113.362 59.816 113.339C59.8819 113.479 59.7864 113.518 59.6835 113.553V113.552Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5126 114.024C54.0139 114.342 54.0748 114.21 53.6085 114.052C53.1779 114.151 54.7925 114.891 54.5126 114.024Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0078 110.557C70.8091 110.243 70.4397 110.203 70.0236 110.239C70.3296 110.381 70.5619 110.64 71.0078 110.557Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1057 113.422C57.9855 113.869 57.5 112.441 57.9819 112.49C57.6054 112.383 57.1983 112.323 57.2229 111.574C56.4852 111.767 57.6859 112.243 56.8667 112.385C56.4393 111.989 56.9525 112.848 57.4252 112.437C57.3864 113.066 57.6802 113.056 57.1057 113.422Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2749 110.564C65.8026 110.827 66.5072 111.096 66.4755 111.427C66.7465 111.153 66.3822 110.483 67.179 110.537C66.4969 111.229 67.4974 110.608 67.8176 110.935C68.4965 110.493 66.9439 110.504 67.4842 110.284C67.0401 109.689 66.6294 111.103 66.2732 110.565L66.2749 110.564Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9845 115.308C49.59 115.115 49.8707 114.821 50.1539 114.855C50.2868 114.803 50.5457 114.161 50.2063 114.296C50.0417 114.07 50.0014 114.362 50.2063 114.296C49.9715 114.591 48.8923 114.471 48.9845 115.308Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8306 113.04C54.4455 112.943 54.0216 113.146 53.2355 113.228C53.1582 112.795 52.9556 112.983 53.0628 113.268C53.7972 113.197 54.3554 113.407 54.6859 113.984C54.7501 113.258 54.1784 113.494 54.8306 113.04Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5608 112.619C61.2072 112.267 60.5177 111.909 60.1875 111.795C59.999 111.874 60.1319 111.991 60.2277 111.968C60.2231 112.224 59.9271 112.054 59.8419 111.875C59.624 112.084 59.3543 112.261 59.4858 112.687C59.7689 112.28 60.8571 111.754 60.5608 112.619Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8071 109.693C70.2796 108.976 69.7346 110.162 70.8071 109.693V109.693Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2783 111.41C60.6199 111.573 61.3633 111.092 61.4356 111.687C62.3456 111.187 61.6585 110.588 62.1914 110.237C61.8872 110.269 61.8121 110.636 61.6728 110.358C61.3593 110.458 61.7027 110.967 61.4879 111.129",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8114 110.539C64.8898 110.728 65.007 110.595 64.9842 110.499C65.0347 110.574 65.1033 110.635 65.1837 110.676C65.2641 110.717 65.3537 110.737 65.444 110.734C65.5343 110.732 65.6224 110.706 65.7001 110.66C65.7778 110.614 65.8425 110.549 65.8882 110.471C65.9046 109.97 65.464 110.202 65.3821 109.86C65.1912 110.086 65.1513 110.406 64.8122 110.539L64.8114 110.539Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8271 112.626C55.7837 112.063 55.4243 112.007 55.2409 111.669C54.937 111.701 54.8619 112.067 54.7226 111.789C54.6913 112.016 54.5901 112.228 54.4331 112.395C54.2761 112.562 54.0711 112.676 53.8464 112.721C54.4266 112.788 55.1675 111.929 55.8271 112.625V112.626Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0442 113.605C50.0595 114.271 50.2772 112.992 50.6141 112.926C50.8143 112.39 49.7757 112.769 50.321 112.447",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5591 115.457C48.1216 115.462 47.6304 114.812 48.3428 114.91L47.5591 115.457Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1991 62.3962C50.1991 62.3962 58.6512 78.4863 50.1991 83.1756C41.7469 87.8649 35.5449 71.2356 46.7401 63.1368",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1558 65.6462C45.9618 65.6462 44.1831 63.8676 44.1831 61.6735C44.1831 59.4795 45.9618 57.7009 48.1558 57.7009C50.3498 57.7009 52.1284 59.4795 52.1284 61.6735C52.1284 63.8676 50.3498 65.6462 48.1558 65.6462Z",
    fill: "#6180EE",
    stroke: "#6180EE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3758 36.4252C56.9368 36.5298 56.5041 36.6589 56.0796 36.8117C55.6224 36.9145 55.1535 36.9557 54.6854 36.9342C54.3976 36.9193 54.4742 36.9317 54.2327 36.9068C53.9165 36.8565 53.607 36.7705 53.3101 36.6504C52.9901 36.519 52.6888 36.3458 52.4143 36.1353C52.133 35.9256 51.8821 35.678 51.6688 35.3994C51.5701 35.2761 51.4824 35.1444 51.4066 35.0058C51.3139 34.8533 51.2353 34.6925 51.1719 34.5256C51.0041 34.1572 50.8844 33.7688 50.8157 33.3698C50.7943 33.1561 50.784 32.9641 50.7765 32.7853C50.7783 32.6118 50.7801 32.443 50.7822 32.2738C50.7413 31.861 50.7067 31.3188 50.6611 30.9737C50.6572 30.9024 50.6536 30.8412 50.6508 30.7892L50.6479 30.7389L50.6038 30.7108L50.1642 30.4319C49.9359 30.2987 49.8643 30.2812 49.6456 30.1551L49.6855 30.2303V30.2047C49.704 29.9681 49.7311 29.8542 49.7567 29.6604C49.8464 28.836 49.9892 28.0183 50.1842 27.2123C50.4421 26.0262 50.8139 24.8678 51.2944 23.7533C51.3756 23.5623 51.4665 23.3756 51.5669 23.194C52.01 22.177 52.6418 21.2532 53.4291 20.4716C53.582 20.3002 53.7488 20.1416 53.9278 19.9975C54.1468 19.7902 54.3765 19.5943 54.6159 19.4109C54.7791 19.3005 54.9276 19.2196 55.001 19.1637C55.1684 19.0664 55.4284 18.9607 55.6421 18.867C56.2797 18.5935 56.9527 18.4112 57.6411 18.3256C57.3242 18.3467 57.0088 18.3872 56.6968 18.4467C56.5597 18.4823 56.4411 18.5104 56.3342 18.5332L56.0514 18.6141C55.8838 18.6487 55.7202 18.7007 55.5634 18.7694C55.4161 18.8273 55.2523 18.8273 55.105 18.7694C54.9161 18.8797 54.7155 18.9688 54.507 19.0351C54.3802 19.1543 54.2152 19.2248 54.0414 19.2339C53.8608 19.3272 53.9413 19.3884 53.7354 19.5039C53.4013 19.6299 53.0117 20.0916 52.7434 20.0424C52.6733 20.196 52.5687 20.3313 52.4378 20.4378C52.2877 20.5836 52.1133 20.7021 51.9224 20.7879C51.7753 20.9593 51.6538 21.1441 51.5188 21.3254C51.3472 21.6179 51.1516 21.4116 50.9699 21.5968C50.6398 22.2441 50.3288 22.81 50.0659 23.376C49.7866 23.9286 49.5873 24.5181 49.4739 25.1267C49.1423 25.7323 49.1338 26.1921 48.8541 26.7553C48.7035 27.2607 48.7537 28.0094 48.5386 28.3685C48.6303 28.9652 48.5998 29.5744 48.4492 30.1591L48.3558 30.6933L49.0091 31.213L49.3528 31.4866C49.5719 31.5457 49.7783 31.6443 49.9619 31.7776L49.4038 30.8515C49.4055 31.0805 49.3959 31.3235 49.4209 31.5813C49.4565 31.9304 49.5298 32.3265 49.5911 32.7183L49.6958 33.3751C49.7229 33.5967 49.7842 33.8068 49.8055 34.0049C49.8921 34.2603 50.0064 34.5937 50.1478 34.6767C50.3309 35.3289 50.7082 35.9098 51.2296 36.3422C51.7463 36.7773 52.345 37.1044 52.9903 37.304C53.0971 37.2281 53.3928 37.3332 53.5435 37.2958C53.9078 37.3065 53.9378 37.4382 54.2263 37.4318C54.2765 37.3385 54.4183 37.2976 54.5878 37.2634C54.7581 37.2163 54.9583 37.1921 55.1271 37.1447C55.3583 37.1232 55.5872 37.0812 55.811 37.0194C56.0023 36.9706 56.1786 36.936 56.3766 36.8719C56.4762 36.8358 56.5673 36.7798 56.6445 36.7073C56.7941 36.6717 57.1278 36.5196 57.374 36.4224L57.3758 36.4252Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2784 28.0526C53.2324 27.7099 53.4312 27.4003 53.7225 27.3612C54.0138 27.3221 54.2872 27.5683 54.3332 27.9111C54.3792 28.2538 54.1804 28.5634 53.8891 28.6025C53.5978 28.6416 53.3244 28.3954 53.2784 28.0526Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4208 49.5313C25.2719 23.4728 50.2251 9.08929 63.1963 13.2051C76.316 17.368 74.041 25.8009 70.8683 31.1662C70.4692 31.8361 69.9367 32.4168 69.3039 32.8725C68.671 33.3281 67.9514 33.6488 67.1895 33.8149C66.4276 33.9809 65.6397 33.9887 64.8747 33.8377C64.1097 33.6868 63.3838 33.3803 62.7421 32.9372C62.7421 32.9372 65.8976 32.6398 64.1217 30.4513C62.1177 27.9815 60.4578 31.6816 60.4578 31.6816L59.2229 31.152L59.8719 29.5288C56.5947 27.8979 53.8123 25.4218 51.8119 22.3561C51.8119 22.3561 49.419 24.988 48.8356 28.3113C48.2521 31.6346 48.6931 30.1774 48.6931 30.1774L50.0274 31.3094L50.8787 35.7932C50.8787 35.7932 50.8627 36.2181 50.8021 36.9362C50.4407 40.7282 51.1429 44.5459 52.8299 47.9612C54.4186 51.0846 54.8781 55.5435 51.1056 61.3327C47.5675 66.7629 41.5742 58.7072 38.4211 53.3593L38.2787 53.3661C37.7041 52.3067 37.1951 51.2666 36.7346 50.2419C36.5921 49.9437 36.4852 49.7012 36.4175 49.5316L36.4208 49.5313Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1809 67.4243C62.7788 67.5019 63.0684 69.1016 63.1699 70.287C63.1699 71.148 63.2693 72.2247 63.3501 73.2623C63.4035 73.875 63.5282 73.6898 63.5902 74.2016C63.7255 75.7689 63.8976 76.6415 64.0621 78.4368C64.3491 79.8801 64.5432 81.3405 64.6431 82.8087C64.7809 83.8381 64.9637 84.3371 65.1026 85.3669C65.1766 86.142 65.2021 86.921 65.1788 87.6992L65.2921 88.1331L66.2121 87.2989C65.4385 87.187 64.5551 87.0203 63.9353 86.9897C63.2678 86.8583 63.0584 86.7094 62.5188 86.5726C61.9588 86.4483 61.7967 86.5306 61.2365 86.4066C60.7506 86.2823 60.5337 86.1477 60.1408 86.0201C58.544 85.6102 56.6764 85.1777 55.0882 84.6698C52.9286 84.195 50.2126 83.4082 47.654 82.8094C47.2277 82.7064 46.8076 82.5794 46.3956 82.429C44.0833 82.0558 41.8077 81.4828 39.5944 80.7164C39.1103 80.6498 38.6334 80.5388 38.1697 80.3848C37.3062 80.2241 36.9743 80.3385 36.2355 80.2423C35.9224 80.1583 35.6001 80.1128 35.2759 80.107C34.8998 79.9356 34.3299 79.7718 33.8679 79.604C32.5268 79.4394 30.8527 78.8695 29.5757 78.7381C29.5551 79.0092 30.8937 79.2304 31.4451 79.4804C32.6023 79.7297 33.086 79.9566 33.8134 80.1187C34.1041 80.1923 34.3687 80.3451 34.5778 80.56C35.0071 80.6387 35.4295 80.7516 35.8409 80.8977C36.1726 80.9337 36.4933 81.0381 36.7826 81.2044C37.163 81.3112 37.136 81.2044 37.5798 81.3469C38.2071 81.5798 39.3804 81.7925 39.6172 82.04C39.941 82.0668 40.2612 82.1264 40.5729 82.2181C40.948 82.317 41.3145 82.4464 41.6686 82.6049L42.9359 82.8999C43.582 83.0324 43.4043 83.1952 43.8641 83.3348C46.5819 83.8666 48.7251 84.5127 51.1586 84.9872C52.436 85.3758 53.3104 85.5215 54.4712 85.8891C55.4736 86.1512 56.9051 86.397 57.6364 86.6691C59.0848 86.909 60.5135 87.2558 61.9107 87.7067C62.7752 87.8464 63.6878 88.1498 64.7603 88.4123L65.8734 88.6738L66.8579 88.905L66.6951 87.9286C66.4949 86.729 66.2652 85.4246 66.1608 84.3884C66.1124 83.958 66.029 83.5322 65.9115 83.1154C65.7373 80.876 65.2422 78.487 64.912 76.1742C64.7948 75.8732 64.7011 75.5636 64.6317 75.2481C64.5657 74.8144 64.5235 74.3774 64.5053 73.9391C64.273 73.829 64.1106 72.9332 63.9282 72.2564C63.7739 71.3954 63.6758 70.5253 63.6344 69.6516C63.6229 69.4309 63.5429 69.2192 63.4057 69.046C63.3681 68.5022 63.2946 67.9614 63.1859 67.4271L63.1809 67.4243Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3102 86.4095C26.1969 86.5748 26.9157 87.3235 27.9651 88.2496C29.0098 89.1832 30.3943 90.2832 31.5583 91.2192C33.183 92.6219 35.3518 94.2665 37.4833 95.7842C38.7464 96.679 38.4885 96.3142 39.5652 97.0391C42.854 99.2365 44.7956 100.36 48.7654 102.564C50.8068 103.579 52.363 104.306 53.8946 104.998C55.4262 105.69 56.9276 106.36 58.9109 107.154C60.1444 107.61 61.088 107.902 62.0369 108.175C62.9858 108.448 63.9389 108.706 65.2145 109.033C67.4528 109.644 69.2655 110.066 70.9666 110.384C73.18 110.571 76.1211 110.537 77.9548 110.143L79.0686 109.976L79.9435 109.826C80.2174 109.787 80.4753 109.716 80.7567 109.656C81.0693 109.591 81.3775 109.507 81.6796 109.404C83.0833 108.915 83.3683 108.656 84.6627 107.951C85.545 107.48 86.3856 106.935 87.1753 106.322C88.0056 105.586 88.7584 104.767 89.4218 103.878C90.0914 102.945 90.6729 101.952 91.1586 100.911C92.0786 98.8612 92.7345 96.7032 93.1105 94.4884C93.5375 91.397 93.6529 88.2705 93.455 85.1561C93.4087 84.3262 93.3374 83.4902 93.2669 82.6503C93.1697 81.8146 93.0988 80.9669 92.977 80.1337L92.6261 77.6326L92.448 76.3898L92.2343 75.1606C92.0598 74.067 91.824 72.6237 91.721 71.8875C91.372 70.4851 91.0681 69.0087 90.6688 67.5287C90.4754 66.7875 90.3059 66.0356 90.1007 65.2911L89.4827 63.0635C88.6257 60.1163 87.6886 57.2718 86.725 54.8799C86.4248 54.2975 86.1637 53.8021 85.919 53.2742C85.7915 53.0124 85.6775 52.7399 85.5304 52.4549L85.0488 51.5445C84.626 50.7961 84.1458 50.0815 83.6126 49.4073C83.4064 49.1224 83.1852 48.8613 82.9415 48.5781C82.6979 48.2949 82.4489 47.9829 82.1601 47.6121C81.8252 47.2025 81.5082 46.8285 81.234 46.5108C81.0125 46.2545 80.7698 46.0174 80.5084 45.8019C80.347 45.6 80.1622 45.3784 79.9634 45.1444L79.2866 44.4591L78.9304 44.105C78.8061 43.9917 78.6758 43.8849 78.5497 43.7748C78.2943 43.5586 78.0485 43.3371 77.8056 43.1383C76.2423 42.0571 74.5069 41.2491 72.6732 40.7486C70.7565 40.267 68.7458 40.2571 67.1618 40.8059C67.2718 40.9043 68.1296 40.7027 69.1864 40.6816C70.1932 40.6435 71.2001 40.7565 72.1734 41.0168C73.3093 41.2551 74.404 41.6588 75.4226 42.2151C75.8291 42.4398 76.191 42.6745 76.5593 42.8957L77.6428 43.6576C77.9896 43.9309 78.3126 44.2332 78.6081 44.5613C78.7972 44.8021 78.9144 44.9887 79.0808 45.2121C79.5185 45.5914 79.9513 46.0876 80.3574 46.5115C80.6744 46.8591 80.9662 47.2289 81.2304 47.6182C81.5689 48.0111 81.879 48.4278 82.1583 48.8648C82.3292 49.1097 82.4797 49.3682 82.6082 49.6378C83.1107 50.4766 83.1339 50.3124 83.7042 51.3148C84.465 52.7798 85.8164 55.4174 85.8851 56.1733C86.2535 56.8892 86.5694 57.631 86.8305 58.3927C87.0349 58.9626 87.2002 59.4545 87.3427 59.9005C87.4791 60.3486 87.5724 60.7578 87.6707 61.1471L88.1723 62.6863C88.3322 63.202 88.47 63.7253 88.6204 64.2443C89.0784 65.8218 88.8191 65.5465 89.0681 66.7155L89.6932 69.1619L90.1958 71.5384L90.438 72.696L90.6421 73.8444L91.0339 76.1048C91.2811 77.6008 91.4692 79.0833 91.6961 80.5676C91.7997 81.3099 91.8788 82.0526 91.9764 82.8016L92.1987 85.0731C92.2525 86.7269 92.2952 88.1007 92.2539 89.4333C92.245 89.7667 92.2357 90.0976 92.2268 90.4306C92.203 90.7619 92.1787 91.0946 92.1556 91.4326C92.12 92.1094 92.0103 92.7997 91.9134 93.5409C91.7263 94.9375 91.4475 96.3203 91.0788 97.6802C90.7448 98.8741 90.2762 100.026 89.6822 101.114C89.5365 101.439 89.3516 101.764 89.1714 102.112C88.9815 102.453 88.7493 102.786 88.5253 103.14C88.2716 103.472 88.0198 103.824 87.7299 104.155C87.4365 104.495 87.1242 104.818 86.7945 105.123C86.1162 105.761 85.3693 106.322 84.5676 106.797C83.7596 107.268 82.9089 107.663 82.0268 107.975C80.99 108.384 79.912 108.68 78.8115 108.858C77.5614 109.044 76.2996 109.14 75.0358 109.145C73.0705 109.151 71.1081 108.995 69.1686 108.677C67.2681 108.371 65.3918 107.931 63.5535 107.359C62.4347 107.044 61.0245 106.558 60.4678 106.433C55.0083 104.386 49.726 101.894 44.6741 98.9832C44.3561 98.9066 43.1186 98.1604 42.5462 97.879C41.0833 97.0373 40.9277 96.7887 39.8035 96.0749C39.3886 96.0599 37.4626 94.8414 35.9923 93.8985C33.6517 92.2194 32.4036 91.3528 30.7726 89.9216C30.3673 89.577 29.9218 89.2828 29.4458 89.0454C28.862 88.4979 27.3638 87.321 26.3113 86.4127L26.3102 86.4095Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.608 86.5792C25.7636 86.2044 24.9372 85.8668 24.4143 85.4536C24.0756 85.1045 23.6101 84.7327 23.1851 84.3433C22.9304 84.1196 22.9187 84.2913 22.6946 84.1147C22.0535 83.5234 21.641 83.253 20.9432 82.5388C20.2773 82.0708 19.6872 81.5031 19.1936 80.8558C18.7979 80.4466 18.5222 80.3158 18.146 79.8877C17.8873 79.5452 17.6806 79.1664 17.5327 78.7635C17.1576 78.4704 16.7758 78.0091 16.4684 77.7544C16.3411 77.5436 16.2523 77.3118 16.2062 77.0698C16.1685 76.9807 16.1193 76.8969 16.0598 76.8205C16.0026 76.7522 15.9677 76.6681 15.9597 76.5794C15.9793 76.4216 16.0997 76.382 16.1891 76.3143C16.4714 76.0756 16.8209 75.9304 17.1893 75.899C17.6403 75.8321 18.0986 75.8297 18.5503 75.8919C19.7976 75.9156 21.0386 76.0747 22.2515 76.3663L22.9461 75.4445C22.9653 75.4819 22.95 75.4524 22.9497 75.4484C22.9493 75.4445 22.9436 75.4249 22.9386 75.4128C22.9332 75.3876 22.9296 75.362 22.9276 75.3362C22.9454 75.2557 22.9864 75.1286 23.0982 75.0983C23.2112 74.8853 23.3884 74.7133 23.6047 74.6067C23.7366 74.5351 23.8739 74.474 24.0154 74.424L24.2348 74.3485C24.2922 74.3378 24.3392 74.3271 24.3926 74.3193C24.6368 74.336 24.8746 74.4051 25.0897 74.5219C25.3048 74.6387 25.4922 74.8004 25.6393 74.9961C25.8634 75.1032 26.0574 75.2642 26.2039 75.4648C26.5601 75.7498 26.8055 75.7423 27.13 75.9963C27.2418 76.1386 27.3803 76.2578 27.5378 76.3471C27.6144 76.5701 27.7893 76.8458 27.9001 77.0951C28.4589 77.6073 28.8454 78.5199 29.3298 79.0467C29.5603 78.8996 29.093 78.288 29.0093 77.9507C28.6299 77.4057 28.5501 77.1055 28.2969 76.7696C28.2 76.6093 28.1704 76.4173 28.2146 76.2353C28.0449 76.0514 27.8975 75.8481 27.7754 75.6297C27.6199 75.5088 27.5087 75.3399 27.4591 75.1492C27.3141 74.9711 27.2639 75.0573 27.0993 74.8411C26.8895 74.5006 26.2979 74.1042 26.2512 73.8562C26.0573 73.7826 25.8712 73.6899 25.6956 73.5795C25.4149 73.4317 25.2108 73.3027 24.9868 73.2005C24.6568 73.131 24.3152 73.14 23.9894 73.2268C23.5801 73.3786 23.6193 73.1524 23.3098 73.2415C22.8071 73.457 22.3598 73.7835 22.0011 74.1964C21.7944 74.4475 21.6575 74.7486 21.6043 75.0694C21.5809 75.2348 21.5809 75.4027 21.6043 75.5681C21.6153 75.6501 21.6325 75.731 21.656 75.8103C21.6834 75.9058 21.7205 75.9982 21.7667 76.086L22.5457 75.0531C21.9485 74.9254 21.3422 74.8444 20.7324 74.8108C19.9779 74.6434 19.4632 74.6645 18.7505 74.5644C18.0851 74.5753 17.4209 74.6261 16.7615 74.7165C16.2871 74.8801 15.8439 75.1231 15.4507 75.4349C15.1901 75.6737 15.0104 75.9876 14.9364 76.3332C14.9021 76.5028 14.8902 76.676 14.9007 76.8486C14.9137 76.9934 14.9358 77.1373 14.967 77.2793C15.1959 77.8554 15.4803 78.4078 15.8162 78.9288C16.3148 79.6515 17.0896 80.4134 17.5896 81.0286C17.7508 81.2196 17.9402 81.3847 18.1514 81.5184C18.9496 82.5367 20.0887 83.3574 21.1227 84.1898C21.2374 84.1602 21.4878 84.3743 21.6403 84.4128C21.9751 84.6055 21.9498 84.7391 22.2006 84.9115C22.3919 84.7879 22.8275 85.0646 23.2001 85.216C23.626 85.4725 24.0309 85.7623 24.4111 86.0826C24.4654 86.122 24.5283 86.1477 24.5946 86.1576C24.6608 86.1676 24.7285 86.1614 24.7919 86.1396C25.0422 86.3241 25.3183 86.4708 25.6112 86.5752L25.608 86.5792Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0275 63.1409C32.2192 63.1213 32.2259 62.3406 32.3296 61.7625C32.4364 61.3546 32.5269 60.8346 32.6345 60.3377C32.6947 60.0431 32.6071 60.1122 32.6516 59.8636C32.8133 59.1106 32.8614 58.6775 33.0612 57.8169C33.1496 57.1009 33.2907 56.3924 33.4833 55.6972C33.5902 55.1985 33.5848 54.9381 33.691 54.4398C33.7869 54.0701 33.9071 53.707 34.0507 53.3531C34.0821 52.9256 34.1775 52.3757 34.1839 52.0123C34.2381 51.6829 34.309 51.5781 34.3681 51.3114C34.419 51.0335 34.377 50.9552 34.4393 50.6869C34.5013 50.4522 34.5683 50.3489 34.6317 50.1608C34.8617 49.3582 35.2059 48.5927 35.6536 47.888C35.7884 47.6446 35.9398 47.4107 36.1067 47.188C36.1957 47.0723 36.2823 46.9508 36.3785 46.834L36.6876 46.4942C37.123 46.042 37.6066 45.639 38.1299 45.2924C38.3044 45.1812 38.4879 45.0847 38.6784 45.0039C39.1568 44.6889 39.6783 44.4451 40.2268 44.2801C40.749 44.1278 41.2866 44.0346 41.8297 44.0022C42.056 43.9439 42.2887 43.9133 42.5225 43.9111C42.9374 43.8484 43.0749 43.7515 43.4325 43.6973C43.5901 43.6974 43.7471 43.6802 43.9009 43.646C44.0983 43.6863 44.385 43.707 44.6201 43.7483C45.3281 43.7634 46.0341 43.8293 46.7327 43.9452C46.7473 43.8028 46.0812 43.7255 45.8005 43.6364C45.2221 43.5755 44.9688 43.5075 44.6016 43.4907C44.4537 43.4801 44.3111 43.431 44.188 43.3483C43.9713 43.354 43.7544 43.348 43.5383 43.3301C43.3741 43.3533 43.207 43.3462 43.0454 43.3091C42.848 43.3123 42.8765 43.3557 42.645 43.3611C42.287 43.3919 41.9277 43.4038 41.5686 43.3967C41.4134 43.4471 41.2547 43.4858 41.0938 43.5125C40.8548 43.5631 40.6767 43.5702 40.5135 43.5908C40.3034 43.6535 40.0907 43.7087 39.8852 43.7875C39.5749 43.9107 39.6002 43.7835 39.3694 43.8665C38.7659 44.1283 38.1877 44.4451 37.6422 44.8129C37.1249 45.1565 36.6575 45.5698 36.2531 46.0411C36.0372 46.2499 35.8399 46.4771 35.6632 46.72L35.4139 47.0513C35.3369 47.1685 35.2561 47.2881 35.1645 47.4149C34.8925 47.8965 34.6454 48.3917 34.424 48.8985C34.3296 49.1834 34.2459 49.5368 34.1177 49.8983L33.7932 51.0228C33.738 51.4503 33.6016 51.9033 33.4883 52.4341C33.3426 53.1408 33.1926 54.0533 33.0324 54.7137C32.9839 54.9214 32.9527 55.1328 32.939 55.3456C32.6541 56.4142 32.502 57.6067 32.3136 58.743C32.3233 58.902 32.3218 59.0615 32.3089 59.2203C32.2773 59.4344 32.2337 59.6465 32.1786 59.8557C32.2733 59.9409 32.2267 60.3872 32.221 60.732C32.1369 61.2926 32.1358 61.5915 32.0315 62.0107C32.0105 62.1181 32.0251 62.2294 32.0731 62.3277C32.0293 62.596 32.0144 62.8681 32.0286 63.1395L32.0275 63.1409Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0411 99.1411C39.6571 99.2872 40.6227 102.596 41.2219 105.047L41.4416 106.08L41.7433 105.684C40.1529 105.6 38.295 105.55 36.4966 105.492C35.1936 105.456 35.5445 105.605 34.4502 105.593C31.1184 105.499 29.232 105.542 25.4118 105.444C21.5774 105.515 19.634 105.497 16.0528 105.382C15.4711 105.379 14.9664 105.382 14.5009 105.393L15.0875 105.853C14.7491 104.586 14.4485 103.602 14.0702 102.024C13.6513 100.127 13.3781 98.599 13.1498 97.1831C12.6034 95.4228 11.9822 93.0915 11.4757 91.6286C11.0985 90.237 11.0682 89.7212 10.7879 88.5732C10.4826 87.3953 10.2974 87.1402 9.99215 85.9627C9.74103 84.9297 9.69366 84.4093 9.51272 83.553C8.68848 80.1528 7.68543 76.2104 6.94811 72.7557C6.2001 69.8794 5.39297 66.4781 4.55128 62.9867L3.94574 63.76C6.00704 63.7699 8.10681 63.7764 10.1503 63.7628C11.0821 63.7842 12.3135 63.765 12.9368 63.8284C17.7882 63.6061 23.5265 63.6674 27.8211 63.8497C28.9121 63.7724 29.6851 63.8159 30.9275 63.8277C31.2837 63.8177 31.5968 63.8024 31.8689 63.7838L31.2342 63.2638C31.5458 64.4193 31.8094 65.0309 32.1268 66.2615C32.2552 66.9327 32.4225 67.5959 32.628 68.2477C32.7238 69.1079 32.9503 70.3457 33.1042 71.3726C33.8255 74.1306 34.4157 77.8268 35.1238 80.4356C35.3678 80.2885 34.6964 77.4931 34.5539 76.2353C34.0221 73.7815 33.9049 72.6698 33.5758 71.1232C33.4524 70.5274 33.4135 69.9172 33.4604 69.3106C33.262 68.3346 32.9777 67.1089 32.9364 66.5864C32.754 65.9096 32.6388 65.2166 32.5923 64.5172C32.4499 63.7628 32.3786 63.8049 32.239 63.0615L32.1827 62.7641L31.8675 62.7573L31.6506 62.7527C30.2393 62.6779 27.7139 62.7544 27.0991 62.5714C26.7052 62.6237 25.8934 62.6284 25.0399 62.6291C24.007 62.6212 23.2686 62.5731 22.5858 62.5183L19.8245 62.5379C18.4261 62.5653 18.7086 62.364 17.6902 62.3398C12.6255 62.4606 8.39818 62.3954 3.94432 62.4563L3.06275 62.4684L3.28393 63.2991L3.83034 65.3511C4.43979 68.1152 4.95698 69.9186 5.49946 72.4447C6.0131 74.5819 6.85301 77.5419 7.16041 79.1604C7.89951 81.5569 8.70594 85.0426 9.41583 88.2174C9.92946 89.9983 10.3441 91.993 10.9072 94.2627C11.6552 97.2822 12.6932 101.132 13.3329 103.99C13.5174 104.702 13.7219 105.565 13.8893 106.149L14.0318 106.645L14.5001 106.627C14.716 106.619 14.8952 106.607 15.0209 106.589C19.7765 106.742 24.9459 106.6 29.9034 106.61C30.1699 106.516 31.3973 106.53 31.9366 106.467C33.3681 106.421 33.5925 106.539 34.7245 106.533C35.0276 106.319 36.9586 106.289 38.4357 106.207L41.7423 106.214H42.0229L41.9517 105.941C41.7601 105.223 41.5919 104.541 41.4327 103.746C41.3357 103.304 41.1707 102.88 40.9437 102.488C40.8329 101.818 40.3503 100.277 40.0411 99.1411Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7235 63.1902C14.1061 63.0424 13.4175 60.9558 13.0207 59.3985L12.6353 57.5199L12.1837 55.4679C12.0038 54.659 11.9051 54.9147 11.7513 54.2358C11.5468 53.195 11.3637 52.3865 11.1717 51.5401C10.9694 50.696 10.8255 49.8009 10.6179 48.6069C10.1509 46.6863 9.85695 44.7277 9.73948 42.7546C9.62906 41.3733 9.436 40.6887 9.41891 39.3027C9.42603 38.2818 9.55031 37.2651 9.78934 36.2726C9.80289 35.7987 9.84979 35.3264 9.92969 34.8592C9.96744 34.6275 10.0175 34.3981 10.0796 34.1717C10.1078 34.0628 10.1463 33.9701 10.1765 33.8693C10.1905 33.8255 10.207 33.7826 10.226 33.7407L10.2499 33.6809C10.2577 33.661 10.252 33.6688 10.252 33.6592L10.3589 33.1381C10.2598 32.8872 10.1251 32.652 9.9589 32.4396C9.45096 31.626 9.34339 31.3222 8.94267 30.6818C8.5213 30.0406 8.31221 29.9491 7.93998 29.3015C7.82028 29.0911 7.73864 28.8613 7.69884 28.6226C7.6821 28.5513 7.72519 28.4648 7.70097 28.5916C7.68612 28.6287 7.66397 28.6625 7.63583 28.6909C7.60768 28.7193 7.57411 28.7417 7.53712 28.7569C7.50435 28.7765 7.4951 28.7683 7.53 28.7793C7.74857 28.8287 7.95952 28.9072 8.15726 29.0126C8.39769 29.1291 8.64418 29.2662 8.89174 29.4109C9.38685 29.7022 9.88658 30.0267 10.3803 30.3637C10.8701 30.6886 11.3432 31.038 11.7979 31.4105C12.0191 31.5861 12.229 31.7755 12.4263 31.9776C12.629 32.1659 12.8216 32.3648 13.0033 32.5735C15.1084 34.5885 17.1743 37.8096 18.9941 40.8237C19.2791 41.3402 19.6798 42.0105 19.8241 42.3827C20.7124 43.7379 21.5228 45.1427 22.2512 46.5901C22.9899 48.0523 23.6364 49.5109 24.1443 50.7811C24.4739 51.3517 24.7614 51.9457 25.0046 52.5581C25.5502 53.6086 25.8858 53.8925 26.3755 54.7694C26.5484 55.1701 26.7561 55.5549 26.9964 55.9192C27.1488 56.4535 27.4498 57.1951 27.6628 57.8223C28.5309 59.4227 29.3056 61.6821 30.0949 63.2137C30.3272 63.0595 29.5475 61.3953 29.3401 60.6114C28.6937 59.1453 28.5099 58.4521 28.0953 57.5317C27.9378 57.1683 27.8583 56.7758 27.8619 56.3798C27.6009 55.8491 27.3686 55.3048 27.1663 54.7491C26.9429 54.3587 26.7789 53.9372 26.6797 53.4985C26.4682 53.0062 26.4126 53.1067 26.1736 52.525C25.8651 51.6734 25.105 50.2454 25.0972 49.814C24.8606 49.4427 24.6511 49.0549 24.4703 48.6535C24.2431 48.1796 24.043 47.6932 23.8708 47.1967L23.0483 45.6295C22.6084 44.8483 22.8734 44.9139 22.5881 44.3251C21.6442 42.6933 20.7961 41.2141 19.9402 39.7943C19.0989 38.3668 18.1761 36.989 17.1761 35.6678C16.2855 34.3583 15.3054 33.112 14.2429 31.9377C13.9762 31.6494 13.6939 31.3759 13.3972 31.1184L12.9224 30.7049C12.7604 30.5692 12.5815 30.4467 12.4145 30.3188C12.074 30.0563 11.7523 29.839 11.4592 29.6363C11.166 29.4336 10.9021 29.2445 10.6912 29.0778L9.51115 28.426C9.04295 28.1534 8.5525 27.9211 8.04506 27.7314C7.85045 27.664 7.64545 27.6315 7.43953 27.6356C7.3534 27.6397 7.26817 27.6549 7.18592 27.6808C7.13228 27.6998 7.08003 27.7226 7.02955 27.7488C6.97282 27.7824 6.91959 27.8215 6.87068 27.8657C6.70974 28.0214 6.61367 28.2323 6.60176 28.4559C6.59452 28.6709 6.62837 28.8854 6.70149 29.0878C6.75163 29.2361 6.8093 29.3817 6.87425 29.5241C7.12002 30.0584 7.39359 30.5257 7.65788 30.9845C7.93785 31.3751 8.212 31.7857 8.48033 32.2162C8.6139 32.4299 8.74676 32.6533 8.87001 32.8763C8.98385 33.0687 9.07926 33.2714 9.15496 33.4818L9.2807 32.8684C9.21399 32.956 9.15444 33.0488 9.10261 33.1459C9.05789 33.2221 9.01838 33.3012 8.98435 33.3828C8.91121 33.5348 8.84918 33.6919 8.79876 33.8529C8.12199 35.9509 8.23064 38.5572 8.27303 40.4539C8.30038 41.0478 8.36869 41.6391 8.47748 42.2235C8.61996 45.3028 9.39112 48.5538 10.0804 51.6545C10.2526 52.0568 10.4016 52.4686 10.5267 52.888C10.7885 53.7678 10.7076 53.9356 10.8846 54.6394C11.134 54.7758 11.4966 55.9573 11.8236 56.846C12.017 57.6015 12.1844 58.1725 12.3265 58.7C12.4857 59.2208 12.6165 59.7498 12.7183 60.2847C12.7819 60.5716 12.9125 60.8393 13.0995 61.0659C13.1564 61.4997 13.5094 62.4696 13.7246 63.1898L13.7235 63.1902Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6063 83.2705C41.8094 83.2459 41.7264 82.556 41.7207 82.0466C41.7531 81.6787 41.7449 81.216 41.7442 80.7707C41.741 80.5075 41.6729 80.5841 41.6605 80.364C41.6526 79.6911 41.6003 79.3139 41.5867 78.5427C41.4988 77.9194 41.4577 77.2904 41.4638 76.661C41.4343 76.2179 41.3616 76.0006 41.3324 75.5568C41.3266 75.2215 41.3422 74.8863 41.3791 74.553C41.3044 74.1631 41.2092 73.7774 41.0941 73.3975C41.0403 73.1094 41.066 73.0011 41.0318 72.7628C40.988 72.5188 40.9139 72.471 40.8651 72.2285C40.8295 72.0148 40.8455 71.9058 40.8248 71.7298C40.6909 71.0295 40.4761 70.2302 40.319 69.525C39.996 68.4649 39.5976 67.4293 39.1269 66.4261C39.0403 66.256 38.9649 66.0805 38.901 65.9007C38.3934 65.0793 38.1566 64.1191 38.2242 63.1558C38.1864 62.9574 38.1789 62.7543 38.2018 62.5535C38.1836 62.1916 38.0974 62.063 38.08 61.7492C38.0973 61.6129 38.0949 61.4749 38.0729 61.3393C38.1359 61.1743 38.1797 60.9282 38.2424 60.7305C38.3222 60.1203 38.4443 59.5164 38.6079 58.9232C38.4715 58.8908 38.3446 59.4614 38.2335 59.6936C38.1267 60.1884 38.0351 60.3989 37.9842 60.7156C37.9598 60.8446 37.8978 60.9635 37.8061 61.0575C37.7909 61.2461 37.764 61.4336 37.7256 61.6189C37.7313 61.7646 37.7077 61.9099 37.6561 62.0463C37.6408 62.218 37.6896 62.1977 37.6643 62.3989C37.6616 62.7137 37.6378 63.028 37.5931 63.3396C37.6584 63.648 37.6861 63.9632 37.6754 64.2782L37.8121 64.8421C37.9001 65.122 37.7972 65.0914 37.8499 65.303C37.9584 65.5837 38.0818 65.8585 38.2196 66.1262C38.3425 66.3808 38.4643 66.5967 38.5733 66.8311C38.7945 67.2906 38.9894 67.7451 39.2074 68.2202C39.3726 68.7574 39.5279 69.0972 39.6423 69.5987C39.7963 70.03 39.9194 70.4717 40.0106 70.9205C40.2124 71.5072 40.3412 72.1165 40.3942 72.7346C40.4785 73.1393 40.5369 73.5489 40.5691 73.961C40.6492 74.5722 40.7472 75.3655 40.7671 75.9586C40.775 76.1438 40.8006 76.3278 40.8434 76.5082C40.8434 77.4699 41.0008 78.5029 41.077 79.4977C41.1283 79.5472 41.1411 79.7944 41.1814 79.9002C41.1977 80.0872 41.2021 80.2751 41.1946 80.4626C41.3061 80.5146 41.3531 80.9015 41.4179 81.1946C41.462 81.5663 41.4779 81.9408 41.4653 82.3148C41.4633 82.4108 41.4955 82.5044 41.5561 82.5788C41.554 82.812 41.57 83.0451 41.6038 83.2759L41.6063 83.2705Z",
    fill: "#2F426C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8312 43.3865C54.1262 43.6714 54.6665 43.0581 55.1395 42.6894C55.5708 42.4282 55.9838 42.1378 56.3755 41.8203C56.6195 41.629 56.4553 41.5816 56.6477 41.4082C57.1862 40.9875 57.473 40.6733 58.008 40.2206L58.1839 40.0717L58.1515 39.7479L58.118 39.4145C57.8991 38.7072 57.7715 37.9747 57.7383 37.235C57.6482 36.7217 57.489 36.487 57.3985 35.9748C57.3729 35.7194 57.3683 35.4623 57.3846 35.2061L56.8347 36.0022C56.9825 36.0165 57.1196 36.0378 57.2561 36.0599C57.699 35.9106 58.134 35.7389 58.5594 35.5452C58.8042 35.5057 59.0519 35.4866 59.2999 35.4882C59.5813 35.4277 59.6301 35.2991 59.9115 35.2389C60.1083 35.2274 60.3058 35.2328 60.5017 35.2549C61.3625 35.0964 62.2314 34.9855 63.1044 34.9229C64.1887 34.685 65.6045 34.5639 66.8993 34.3174C67.1172 34.279 67.3387 34.2652 67.5597 34.2761C67.8333 34.1764 68.1125 34.0923 68.3957 34.0243L67.7634 33.6627C68.1432 34.4658 68.4231 35.3123 68.5969 36.1835C68.7325 36.3898 68.8291 36.6192 68.8819 36.8603C69.0899 37.2521 69.3214 37.3198 69.5351 37.635C69.5909 37.7923 69.6827 37.9343 69.8034 38.0496C69.8316 38.3014 69.8755 38.5513 69.9348 38.7976C70.3309 39.3654 70.5118 40.2431 70.9108 40.772C71.1526 40.6538 70.8039 40.0596 70.8 39.7426C70.5507 39.2033 70.5507 38.9205 70.3996 38.5789C70.3762 38.4976 70.3706 38.4122 70.3833 38.3285C70.396 38.2448 70.4266 38.1649 70.473 38.0941C70.3686 37.9004 70.2957 37.6913 70.2572 37.4747C70.2068 37.4051 70.1708 37.3262 70.1513 37.2425C70.1317 37.1589 70.1291 37.0721 70.1435 36.9874C70.0826 36.7987 70.0035 36.8571 69.9458 36.6312C69.8949 36.2932 69.6075 35.7646 69.7257 35.5627C69.6209 35.4352 69.5426 35.2881 69.4956 35.1299C69.4296 34.9432 69.3935 34.7472 69.3887 34.5493L69.1344 33.948C68.9895 33.6499 69.201 33.6392 69.1366 33.4063L69.0208 33.1747L68.713 32.5596L68.1763 32.6921C66.9346 32.9984 65.8781 33.081 64.7511 33.3845C64.08 33.4241 63.654 33.5651 63.0396 33.5869C62.5089 33.7136 61.9701 33.8037 61.4271 33.8565C60.7254 34.0891 59.9933 34.2168 59.2543 34.2355C58.7766 34.3495 58.2915 34.4294 57.8025 34.4745C57.4391 34.5361 57.0281 34.6266 56.6209 34.7078L55.9442 34.8424L56.0945 35.4697C56.1908 35.8463 56.2647 36.2284 56.3157 36.6138C56.3453 36.8308 56.4096 37.0416 56.5063 37.2382C56.6075 38.1638 56.7829 39.0798 57.0306 39.9773L57.2015 39.4131C57.0331 39.5912 56.8639 39.7643 56.6915 39.9328C56.7132 40.0439 56.4974 40.2381 56.451 40.3724C56.2437 40.6438 56.123 40.5975 55.9374 40.7902C56.0375 40.9925 55.7351 41.3355 55.5456 41.6397C55.2526 41.969 54.9184 42.2591 54.5511 42.5028C54.5041 42.5408 54.4677 42.5902 54.4453 42.6463C54.4229 42.7025 54.4153 42.7634 54.4232 42.8233C54.2594 42.885 54.0289 43.1938 53.8291 43.3879L53.8312 43.3865Z",
    fill: "#2F426C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipients);
export default __webpack_public_path__ + "static/media/recipients.551ce9f8db12f8ecc15b196de13bc090.svg";
export { ForwardRef as ReactComponent };